export default {
  props: [],
  data() {
    return {
      emojiTypeList: [],
      emojiList: []
    };
  },
  components: {},
  computed: {},
  methods: {
    emojiClick(emoji) {
      this.$emit("emojiClick", emoji);
    },
    emojiTypeClick(emojiType) {
      this.emojiList = emojiType.emojiCategoryEntities;
    },
    closeClick() {
      this.$emit("facePanelClose");
    },
    scrollBtnClick(type) {
      let typeBarList = this.$refs.typeBarList;
      if (type == 'left') {
        typeBarList.scrollLeft -= typeBarList.clientWidth;
      } else {
        typeBarList.scrollLeft += typeBarList.clientWidth;
      }
    }
  },
  created() {
    this.emojiTypeList = [{
      "categoryName": "人物",
      "emojiCategoryEntities": [{
        "emoji": "😀",
        "emojiKeyword": "笑脸,微笑,开心,哈哈,笑,嘿嘿,咧嘴",
        "emojiLength": 2
      }, {
        "emoji": "😃",
        "emojiKeyword": "笑脸,微笑,开心,哈哈,笑,咧嘴",
        "emojiLength": 2
      }, {
        "emoji": "😄",
        "emojiKeyword": "笑脸,微笑,开心,哈哈,笑,高兴,咧嘴",
        "emojiLength": 2
      }, {
        "emoji": "😁",
        "emojiKeyword": "笑脸,微笑,眯眼笑,笑,咧嘴",
        "emojiLength": 2
      }, {
        "emoji": "😆",
        "emojiKeyword": "笑脸,大笑,开心,笑,咧嘴",
        "emojiLength": 2
      }, {
        "emoji": "😅",
        "emojiKeyword": "笑,笑脸,无语,汗颜,尴尬,汗,咧嘴",
        "emojiLength": 2
      }, {
        "emoji": "😂",
        "emojiKeyword": "笑,笑脸,笑哭,眼泪,哭笑,咧嘴",
        "emojiLength": 2
      }, {
        "emoji": "🤣",
        "emojiKeyword": "笑,笑脸,笑哭,眼泪,咧嘴",
        "emojiLength": 2
      }, {
        "emoji": "☺️",
        "emojiKeyword": "笑,笑脸,满意,舒服,愉快,脸红,嘻嘻",
        "emojiLength": 2
      }, {
        "emoji": "😊",
        "emojiKeyword": "笑,笑脸,愉快,脸红",
        "emojiLength": 2
      }, {
        "emoji": "😇",
        "emojiKeyword": "笑,笑脸,善良,天使",
        "emojiLength": 2
      }, {
        "emoji": "🙂",
        "emojiKeyword": "笑,笑脸,微笑,假笑,呵呵",
        "emojiLength": 2
      }, {
        "emoji": "🙃",
        "emojiKeyword": "笑,笑脸,呵呵,假笑,无语",
        "emojiLength": 2
      }, {
        "emoji": "😉",
        "emojiKeyword": "笑,眨眼,媚眼,调皮",
        "emojiLength": 2
      }, {
        "emoji": "😌",
        "emojiKeyword": "笑,笑脸,满意,舒服,惬意",
        "emojiLength": 2
      }, {
        "emoji": "😍",
        "emojiKeyword": "笑,笑脸,爱,爱心,心动,一见钟情,花痴",
        "emojiLength": 2
      }, {
        "emoji": "🥰",
        "emojiKeyword": "笑,笑脸,开心,爱,愉快,脸红",
        "emojiLength": 2
      }, {
        "emoji": "😘",
        "emojiKeyword": "笑,笑脸,亲,啵,飞吻",
        "emojiLength": 2
      }, {
        "emoji": "😗",
        "emojiKeyword": "笑,笑脸,亲,啵,吹口哨",
        "emojiLength": 2
      }, {
        "emoji": "😙",
        "emojiKeyword": "笑,笑脸,亲,啵,吹口哨",
        "emojiLength": 2
      }, {
        "emoji": "😚",
        "emojiKeyword": "笑,笑脸,亲,啵,吹口哨,脸红",
        "emojiLength": 2
      }, {
        "emoji": "😋",
        "emojiKeyword": "笑,笑脸,好吃,吐舌,卖萌,嘿嘿",
        "emojiLength": 2
      }, {
        "emoji": "😛",
        "emojiKeyword": "吐舌,鬼脸,调皮,搞怪,略,嘻嘻",
        "emojiLength": 2
      }, {
        "emoji": "😝",
        "emojiKeyword": "吐舌,鬼脸,调皮,搞怪,略,嘻嘻",
        "emojiLength": 2
      }, {
        "emoji": "😜",
        "emojiKeyword": "吐舌,鬼脸,调皮,搞怪,略,嘻嘻",
        "emojiLength": 2
      }, {
        "emoji": "🤪",
        "emojiKeyword": "吐舌,鬼脸,调皮,搞怪,略,滑稽",
        "emojiLength": 2
      }, {
        "emoji": "🤨",
        "emojiKeyword": "怀疑,思考,挑眉,困惑,疑惑",
        "emojiLength": 2
      }, {
        "emoji": "🧐",
        "emojiKeyword": "聪明,思考,怀疑,书呆子,想,严肃,困惑,疑惑",
        "emojiLength": 2
      }, {
        "emoji": "🤓",
        "emojiKeyword": "笑,笑脸,眼镜,兔牙,书呆子",
        "emojiLength": 2
      }, {
        "emoji": "😎",
        "emojiKeyword": "笑,笑脸,眼镜,酷,自信",
        "emojiLength": 2
      }, {
        "emoji": "🤩",
        "emojiKeyword": "脸,哇,惊喜,星星",
        "emojiLength": 2
      }, {
        "emoji": "🥳",
        "emojiKeyword": "脸,恭喜,祝贺,庆祝,派对,开心,笑脸,聚会",
        "emojiLength": 2
      }, {
        "emoji": "😏",
        "emojiKeyword": "脸,笑脸,坏笑,假笑,斜眼,自信,得意",
        "emojiLength": 2
      }, {
        "emoji": "😒",
        "emojiKeyword": "脸,无语,斜眼,不屑,鄙视,郁闷,失望",
        "emojiLength": 2
      }, {
        "emoji": "😞",
        "emojiKeyword": "脸,难过,难受,悲伤,伤心,无精打采,闷闷不乐,累,疲惫,唉,愁,灰心",
        "emojiLength": 2
      }, {
        "emoji": "😔",
        "emojiKeyword": "脸,难过,难受,悲伤,伤心,无精打采,闷闷不乐,失望,唉,愁,灰心",
        "emojiLength": 2
      }, {
        "emoji": "😟",
        "emojiKeyword": "脸,难过,难受,悲伤,伤心,无精打采,闷闷不乐,困惑,疑惑,失望,愁,灰心",
        "emojiLength": 2
      }, {
        "emoji": "😕",
        "emojiKeyword": "脸,难过,难受,悲伤,伤心,无精打采,闷闷不乐,严肃,困惑,疑惑,失望,愁,灰心",
        "emojiLength": 2
      }, {
        "emoji": "🙁",
        "emojiKeyword": "脸,难过,难受,悲伤,伤心,无精打采,闷闷不乐,严肃,失望,愁,灰心",
        "emojiLength": 2
      }, {
        "emoji": "☹️",
        "emojiKeyword": "脸,难过,难受,悲伤,伤心,无精打采,闷闷不乐,严肃,失望,唉,愁,灰心",
        "emojiLength": 2
      }, {
        "emoji": "😣",
        "emojiKeyword": "脸,忍耐,难受,痛苦,纠结,累,愁,灰心",
        "emojiLength": 2
      }, {
        "emoji": "😖",
        "emojiKeyword": "脸,忍耐,难受,痛苦,纠结,累,愁,灰心",
        "emojiLength": 2
      }, {
        "emoji": "😫",
        "emojiKeyword": "脸,忍耐,难受,痛苦,纠结,累,愁,灰心",
        "emojiLength": 2
      }, {
        "emoji": "😩",
        "emojiKeyword": "脸,疲倦,疲劳,疲惫,累,愁",
        "emojiLength": 2
      }, {
        "emoji": "🥺",
        "emojiKeyword": "脸,可怜,委屈,请求,求",
        "emojiLength": 2
      }, {
        "emoji": "😢",
        "emojiKeyword": "脸,哭,委屈,难过,悲伤,伤心,流泪,眼泪,灰心",
        "emojiLength": 2
      }, {
        "emoji": "😭",
        "emojiKeyword": "脸,哭,大哭,流泪,眼泪,痛哭,灰心",
        "emojiLength": 2
      }, {
        "emoji": "😤",
        "emojiKeyword": "脸,傲慢,生气,愤怒",
        "emojiLength": 2
      }, {
        "emoji": "😠",
        "emojiKeyword": "脸,生气,讨厌,严肃,怒",
        "emojiLength": 2
      }, {
        "emoji": "😡",
        "emojiKeyword": "脸,生气,发火,发飙,怒,脸红",
        "emojiLength": 2
      }, {
        "emoji": "🤬",
        "emojiKeyword": "脸,骂,脏话,咒骂,脸红",
        "emojiLength": 2
      }, {
        "emoji": "🤯",
        "emojiKeyword": "脸,震惊,爆炸,脑",
        "emojiLength": 2
      }, {
        "emoji": "😳",
        "emojiKeyword": "脸,发呆,呆,愣住,脸红,尴尬",
        "emojiLength": 2
      }, {
        "emoji": "🥵",
        "emojiKeyword": "脸,哭,热,出汗,发烧,发热,脸红,辣",
        "emojiLength": 2
      }, {
        "emoji": "🥶",
        "emojiKeyword": "脸,冷,冻僵,寒冷",
        "emojiLength": 2
      }, {
        "emoji": "😶‍🌫️",
        "emojiKeyword": "脸,隐藏,雾霾,烟雾,雾,模糊,迷茫",
        "emojiLength": 6
      }, {
        "emoji": "😱",
        "emojiKeyword": "脸,吓死,害怕,尖叫,恐怖,惊吓",
        "emojiLength": 2
      }, {
        "emoji": "😨",
        "emojiKeyword": "脸,怕,恐怖,恐惧,惊吓",
        "emojiLength": 2
      }, {
        "emoji": "😰",
        "emojiKeyword": "脸,哭,汗,无语,焦虑,紧张",
        "emojiLength": 2
      }, {
        "emoji": "😥",
        "emojiKeyword": "脸,哭,汗,无语,焦虑,紧张",
        "emojiLength": 2
      }, {
        "emoji": "😓",
        "emojiKeyword": "脸,黄脸,汗,无语,尴尬",
        "emojiLength": 2
      }, {
        "emoji": "🤗",
        "emojiKeyword": "脸,伸手,脸红,拥抱,抱,欢迎,热情",
        "emojiLength": 2
      }, {
        "emoji": "🤔",
        "emojiKeyword": "脸,怀疑,思考,想,困惑,疑惑",
        "emojiLength": 2
      }, {
        "emoji": "🤭",
        "emojiKeyword": "脸,偷笑,捂嘴笑,脸红,嘿嘿,嘻嘻",
        "emojiLength": 2
      }, {
        "emoji": "🤫",
        "emojiKeyword": "脸,嘘,保密,闭嘴,别说",
        "emojiLength": 2
      }, {
        "emoji": "🤥",
        "emojiKeyword": "脸,撒谎,长鼻子,匹诺曹,吹牛",
        "emojiLength": 2
      }, {
        "emoji": "😶",
        "emojiKeyword": "脸,沉默,安静,闭嘴",
        "emojiLength": 2
      }, {
        "emoji": "😐",
        "emojiKeyword": "脸,撇嘴,嗯,冷漠,面无表情,纠结,严肃",
        "emojiLength": 2
      }, {
        "emoji": "😬",
        "emojiKeyword": "脸,嘻嘻,咬牙切齿,露齿,鬼脸,龇牙",
        "emojiLength": 2
      }, {
        "emoji": "🙄",
        "emojiKeyword": "脸,白眼,无语,嫌弃,不屑",
        "emojiLength": 2
      }, {
        "emoji": "😯",
        "emojiKeyword": "脸,惊讶,震惊,目瞪口呆,天啊",
        "emojiLength": 2
      }, {
        "emoji": "😦",
        "emojiKeyword": "脸,震惊,惊讶,目瞪口呆,天啊",
        "emojiLength": 2
      }, {
        "emoji": "😧",
        "emojiKeyword": "脸,震惊,惊讶,目瞪口呆,天啊",
        "emojiLength": 2
      }, {
        "emoji": "😮",
        "emojiKeyword": "脸,震惊,惊讶,目瞪口呆,天啊",
        "emojiLength": 2
      }, {
        "emoji": "😲",
        "emojiKeyword": "脸,震惊,惊讶,目瞪口呆,天啊",
        "emojiLength": 2
      }, {
        "emoji": "😴",
        "emojiKeyword": "脸,困,睡觉,做梦,呼噜",
        "emojiLength": 2
      }, {
        "emoji": "🤤",
        "emojiKeyword": "脸,馋,流口水,想吃",
        "emojiLength": 2
      }, {
        "emoji": "😪",
        "emojiKeyword": "脸,困,睡觉,瞌睡,呼噜,无聊",
        "emojiLength": 2
      }, {
        "emoji": "😮‍💨",
        "emojiKeyword": "脸,叹气,唉,愁,冷,呼气",
        "emojiLength": 5
      }, {
        "emoji": "😵",
        "emojiKeyword": "脸,头晕,头晕眼花,完蛋,死,眩晕",
        "emojiLength": 2
      }, {
        "emoji": "😵‍💫",
        "emojiKeyword": "脸,晕,眼圈,眩晕,迷糊,头晕,头晕眼花,",
        "emojiLength": 5
      }, {
        "emoji": "🤐",
        "emojiKeyword": "脸,闭嘴,别说,拉链嘴,嘘,保密",
        "emojiLength": 2
      }, {
        "emoji": "🥴",
        "emojiKeyword": "脸,喝醉,头晕眼花,微醺,眼花,醉醺醺",
        "emojiLength": 2
      }, {
        "emoji": "🤢",
        "emojiKeyword": "脸,吐,呕,恶心,绿",
        "emojiLength": 2
      }, {
        "emoji": "🤮",
        "emojiKeyword": "脸,吐,呕,恶心",
        "emojiLength": 2
      }, {
        "emoji": "🤧",
        "emojiKeyword": "脸,感冒,鼻涕,流感,喷嚏,鼻炎",
        "emojiLength": 2
      }, {
        "emoji": "😷",
        "emojiKeyword": "脸,感冒,口罩,流感,新冠,疫情",
        "emojiLength": 2
      }, {
        "emoji": "🤒",
        "emojiKeyword": "脸,生病,发烧,量体温,温度计",
        "emojiLength": 2
      }, {
        "emoji": "🤕",
        "emojiKeyword": "脸,受伤,包扎,绷带",
        "emojiLength": 2
      }, {
        "emoji": "🤑",
        "emojiKeyword": "脸,吐舌,钱,鬼脸,发财",
        "emojiLength": 2
      }, {
        "emoji": "🤠",
        "emojiKeyword": "脸,牛仔,笑脸",
        "emojiLength": 2
      }, {
        "emoji": "😈",
        "emojiKeyword": "恶魔,妖怪,笑脸,魔鬼,怪物",
        "emojiLength": 2
      }, {
        "emoji": "👿",
        "emojiKeyword": "恶魔,妖怪,魔鬼,怪物",
        "emojiLength": 2
      }, {
        "emoji": "👹",
        "emojiKeyword": "鬼,面具,妖怪,魔鬼,怪物",
        "emojiLength": 2
      }, {
        "emoji": "👺",
        "emojiKeyword": "鬼,天狗,面具,怪物",
        "emojiLength": 2
      }, {
        "emoji": "🤡",
        "emojiKeyword": "小丑,面具,马戏团",
        "emojiLength": 2
      }, {
        "emoji": "💩",
        "emojiKeyword": "屎,大便,便,笑脸,恶心",
        "emojiLength": 2
      }, {
        "emoji": "👻",
        "emojiKeyword": "鬼,万圣节,吓人,魔鬼",
        "emojiLength": 2
      }, {
        "emoji": "💀",
        "emojiKeyword": "头,骷髅,骨头,死亡",
        "emojiLength": 2
      }, {
        "emoji": "☠️",
        "emojiKeyword": "头,骷髅,海盗,骨头,死亡",
        "emojiLength": 2
      }, {
        "emoji": "👽",
        "emojiKeyword": "外星人,太空,飞船",
        "emojiLength": 2
      }, {
        "emoji": "👾",
        "emojiKeyword": "外星人,游戏,像素,怪物",
        "emojiLength": 2
      }, {
        "emoji": "🤖",
        "emojiKeyword": "机器人,怪物",
        "emojiLength": 2
      }, {
        "emoji": "🎃",
        "emojiKeyword": "万圣节,南瓜",
        "emojiLength": 2
      }, {
        "emoji": "😺",
        "emojiKeyword": "动物,猫脸,微笑,开心,哈哈,笑",
        "emojiLength": 2
      }, {
        "emoji": "😸",
        "emojiKeyword": "动物,猫脸,微笑,开心,哈哈,笑,高兴",
        "emojiLength": 2
      }, {
        "emoji": "😹",
        "emojiKeyword": "动物,猫脸,笑脸,笑哭,眼泪,哭笑",
        "emojiLength": 2
      }, {
        "emoji": "😻",
        "emojiKeyword": "动物,猫脸,笑脸,爱,爱心,心动,一见钟情,花痴",
        "emojiLength": 2
      }, {
        "emoji": "😼",
        "emojiKeyword": "动物,猫脸,笑脸,坏笑,假笑,斜眼,自信,得意",
        "emojiLength": 2
      }, {
        "emoji": "😽",
        "emojiKeyword": "动物,猫脸,笑脸,亲,啵,吹口哨,脸红",
        "emojiLength": 2
      }, {
        "emoji": "🙀",
        "emojiKeyword": "动物,猫脸,吓死,害怕,尖叫,恐怖,惊吓,怕,恐惧",
        "emojiLength": 2
      }, {
        "emoji": "😿",
        "emojiKeyword": "动物,猫脸,哭,委屈,难过,悲伤,伤心,流泪,眼泪",
        "emojiLength": 2
      }, {
        "emoji": "😾",
        "emojiKeyword": "动物,猫脸,生气,讨厌,严肃,怒",
        "emojiLength": 2
      }, {
        "emoji": "🤲",
        "emojiKeyword": "手,手心,祷告",
        "emojiLength": 2
      }, {
        "emoji": "👐",
        "emojiKeyword": "手,双手,摊手,安慰,拥抱",
        "emojiLength": 2
      }, {
        "emoji": "🙌",
        "emojiKeyword": "手,拍手,击掌,投降,庆祝",
        "emojiLength": 2
      }, {
        "emoji": "👏",
        "emojiKeyword": "手,鼓掌,拍手",
        "emojiLength": 2
      }, {
        "emoji": "🤝",
        "emojiKeyword": "手,握手,协议,合作",
        "emojiLength": 2
      }, {
        "emoji": "👍",
        "emojiKeyword": "手,好,棒,赞同,点赞",
        "emojiLength": 2
      }, {
        "emoji": "👎",
        "emojiKeyword": "手,差,反对,不赞成,鄙视",
        "emojiLength": 2
      }, {
        "emoji": "👊",
        "emojiKeyword": "手,拳,打拳",
        "emojiLength": 2
      }, {
        "emoji": "✊",
        "emojiKeyword": "手,拳,握拳,拳头,奋斗,努力,石头",
        "emojiLength": 1
      }, {
        "emoji": "🤛",
        "emojiKeyword": "手,拳,打拳",
        "emojiLength": 2
      }, {
        "emoji": "🤜",
        "emojiKeyword": "手,拳,打拳",
        "emojiLength": 2
      }, {
        "emoji": "🤞",
        "emojiKeyword": "交叉,幸运,手,手指",
        "emojiLength": 2
      }, {
        "emoji": "✌️",
        "emojiKeyword": "手,耶,胜利,和平,剪刀",
        "emojiLength": 2
      }, {
        "emoji": "🤟",
        "emojiKeyword": "手,爱,我爱你",
        "emojiLength": 2
      }, {
        "emoji": "🤘",
        "emojiKeyword": "手,摇滚",
        "emojiLength": 2
      }, {
        "emoji": "👌",
        "emojiKeyword": "手,好的,没问题,OK,ok",
        "emojiLength": 2
      }, {
        "emoji": "👈",
        "emojiKeyword": "手,左,指,方向",
        "emojiLength": 2
      }, {
        "emoji": "👉",
        "emojiKeyword": "手,右,指,方向",
        "emojiLength": 2
      }, {
        "emoji": "👆",
        "emojiKeyword": "手,上,指,方向",
        "emojiLength": 2
      }, {
        "emoji": "👇",
        "emojiKeyword": "手,下,指,方向",
        "emojiLength": 2
      }, {
        "emoji": "☝️",
        "emojiKeyword": "手,上,指,方向,稍候,稍等",
        "emojiLength": 2
      }, {
        "emoji": "✋",
        "emojiKeyword": "手,手掌,手心",
        "emojiLength": 1
      }, {
        "emoji": "🤚",
        "emojiKeyword": "手,手背",
        "emojiLength": 2
      }, {
        "emoji": "🖐️",
        "emojiKeyword": "手,手掌,手心,击掌,五,布",
        "emojiLength": 3
      }, {
        "emoji": "🖖",
        "emojiKeyword": "手,打招呼,敬礼,星际迷航,瓦肯",
        "emojiLength": 2
      }, {
        "emoji": "👋",
        "emojiKeyword": "手,拜拜,再见,挥手,打招呼",
        "emojiLength": 2
      }, {
        "emoji": "🤙",
        "emojiKeyword": "手,打电话,六",
        "emojiLength": 2
      }, {
        "emoji": "💪",
        "emojiKeyword": "胳膊,手臂,加油,肌肉,锻炼",
        "emojiLength": 2
      }, {
        "emoji": "🖕",
        "emojiKeyword": "手,中指",
        "emojiLength": 2
      }, {
        "emoji": "✍️",
        "emojiKeyword": "手,写,写字,写作",
        "emojiLength": 2
      }, {
        "emoji": "🙏",
        "emojiKeyword": "手,拜托,祈祷,祝福,感谢",
        "emojiLength": 2
      }, {
        "emoji": "🦶",
        "emojiKeyword": "脚,脚丫",
        "emojiLength": 2
      }, {
        "emoji": "🦵",
        "emojiKeyword": "腿,踢",
        "emojiLength": 2
      }, {
        "emoji": "💄",
        "emojiKeyword": "口红,唇膏,化妆",
        "emojiLength": 2
      }, {
        "emoji": "💋",
        "emojiKeyword": "亲,口红,唇印",
        "emojiLength": 2
      }, {
        "emoji": "👄",
        "emojiKeyword": "嘴唇,器官",
        "emojiLength": 2
      }, {
        "emoji": "🦷",
        "emojiKeyword": "牙,牙齿,牙医,蛀牙",
        "emojiLength": 2
      }, {
        "emoji": "👅",
        "emojiKeyword": "舌头,吐舌,调皮,略,器官",
        "emojiLength": 2
      }, {
        "emoji": "👂",
        "emojiKeyword": "听,耳朵,器官",
        "emojiLength": 2
      }, {
        "emoji": "👃",
        "emojiKeyword": "鼻子,器官",
        "emojiLength": 2
      }, {
        "emoji": "👣",
        "emojiKeyword": "足迹,脚印",
        "emojiLength": 2
      }, {
        "emoji": "👁️",
        "emojiKeyword": "眼睛,器官",
        "emojiLength": 3
      }, {
        "emoji": "👀",
        "emojiKeyword": "眼睛,看,盯,器官",
        "emojiLength": 2
      }, {
        "emoji": "🧠",
        "emojiKeyword": "脑,思考,聪明,器官",
        "emojiLength": 2
      }, {
        "emoji": "🗣️",
        "emojiKeyword": "剪影,头像,说话",
        "emojiLength": 3
      }, {
        "emoji": "👤",
        "emojiKeyword": "人像,半身像,剪影,头像",
        "emojiLength": 2
      }, {
        "emoji": "👥",
        "emojiKeyword": "双人像,半身像,剪影",
        "emojiLength": 2
      }, {
        "emoji": "👶",
        "emojiKeyword": "宝宝,婴儿,小孩",
        "emojiLength": 2
      }, {
        "emoji": "👧",
        "emojiKeyword": "儿童,小孩,女孩,小女孩,小朋友,女儿",
        "emojiLength": 2
      }, {
        "emoji": "🧒",
        "emojiKeyword": "儿童,小孩,小朋友,孩子",
        "emojiLength": 2
      }, {
        "emoji": "👦",
        "emojiKeyword": "儿童,小孩,男孩,小男孩,小朋友,儿子",
        "emojiLength": 2
      }, {
        "emoji": "👩",
        "emojiKeyword": "女,大人,女人,长发,女性,妈妈,阿姨",
        "emojiLength": 2
      }, {
        "emoji": "🧑",
        "emojiKeyword": "中性,大人,短发",
        "emojiLength": 2
      }, {
        "emoji": "👨",
        "emojiKeyword": "男,大人,男人,短发,男性,爸爸,叔叔",
        "emojiLength": 2
      }, {
        "emoji": "👩‍🦱",
        "emojiKeyword": "女,大人,女人,卷发,女性,妈妈,阿姨",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🦱",
        "emojiKeyword": "中性,大人,卷发",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🦱",
        "emojiKeyword": "男,大人,男人,卷发,男性,爸爸,叔叔",
        "emojiLength": 5
      }, {
        "emoji": "👩‍🦰",
        "emojiKeyword": "女,大人,女人,长发,女性,妈妈,阿姨,红发",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🦰",
        "emojiKeyword": "中性,大人,短发,红发",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🦰",
        "emojiKeyword": "男,大人,男人,卷发,男性,爸爸,叔叔,红发",
        "emojiLength": 5
      }, {
        "emoji": "👱‍♀️",
        "emojiKeyword": "女,大人,女人,长发,女性,妈妈,阿姨,金发",
        "emojiLength": 5
      }, {
        "emoji": "👱",
        "emojiKeyword": "中性,大人,短发,金发",
        "emojiLength": 2
      }, {
        "emoji": "👱‍♂️",
        "emojiKeyword": "男,大人,男人,卷发,男性,爸爸,叔叔,金发",
        "emojiLength": 5
      }, {
        "emoji": "👩‍🦳",
        "emojiKeyword": "女,大人,女人,长发,女性,妈妈,阿姨,白发",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🦳",
        "emojiKeyword": "中性,大人,短发,白发",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🦳",
        "emojiKeyword": "男,大人,男人,卷发,男性,爸爸,叔叔,白发",
        "emojiLength": 5
      }, {
        "emoji": "👩‍🦲",
        "emojiKeyword": "女,大人,女人,光头,秃头,女性,妈妈,阿姨",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🦲",
        "emojiKeyword": "中性,大人,光头,秃头",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🦲",
        "emojiKeyword": "男,大人,男人,光头,秃头,男性,爸爸,叔叔",
        "emojiLength": 5
      }, {
        "emoji": "🧔‍♀️",
        "emojiKeyword": "女,大人,女人,长发,女性,妈妈,阿姨,胡子",
        "emojiLength": 5
      }, {
        "emoji": "🧔",
        "emojiKeyword": "中性,大人,短发,胡子",
        "emojiLength": 2
      }, {
        "emoji": "🧔‍♂️",
        "emojiKeyword": "男,大人,男人,卷发,男性,爸爸,叔叔,胡子",
        "emojiLength": 5
      }, {
        "emoji": "👵",
        "emojiKeyword": "女,老人,奶奶,女人,女性,妈妈,眼镜,外婆",
        "emojiLength": 2
      }, {
        "emoji": "🧓",
        "emojiKeyword": "中性,老人,短发,眼镜",
        "emojiLength": 2
      }, {
        "emoji": "👴",
        "emojiKeyword": "男,老人,男人,男性,爸爸,爷爷,外公,眼镜",
        "emojiLength": 2
      }, {
        "emoji": "👲",
        "emojiKeyword": "男,地主,中华,帽子,瓜皮帽,古装",
        "emojiLength": 2
      }, {
        "emoji": "👳‍♀️",
        "emojiKeyword": "女,女人,头巾,女性,阿拉伯人,印度人",
        "emojiLength": 5
      }, {
        "emoji": "👳",
        "emojiKeyword": "中性,阿拉伯人,印度人",
        "emojiLength": 2
      }, {
        "emoji": "👳‍♂️",
        "emojiKeyword": "男,男人,男性,阿拉伯人,印度人",
        "emojiLength": 5
      }, {
        "emoji": "🧕",
        "emojiKeyword": "女,女人,女性,头巾,希贾布,穆斯林",
        "emojiLength": 2
      }, {
        "emoji": "👮‍♀️",
        "emojiKeyword": "女,女人,女性,警察,警官,公安,女警察,女警官,安全",
        "emojiLength": 5
      }, {
        "emoji": "👮",
        "emojiKeyword": "中性,警察,警官,公安,安全",
        "emojiLength": 2
      }, {
        "emoji": "👮‍♂️",
        "emojiKeyword": "男,男人,男性,警察,警官,公安,男警察,男警官,安全",
        "emojiLength": 5
      }, {
        "emoji": "👷‍♀️",
        "emojiKeyword": "女,女人,女性,工人,建筑,民工,搬砖,工地,安全",
        "emojiLength": 5
      }, {
        "emoji": "👷",
        "emojiKeyword": "中性,工人,建筑,民工,搬砖,工地,安全",
        "emojiLength": 2
      }, {
        "emoji": "👷‍♂️",
        "emojiKeyword": "男,男人,男性,工人,建筑,民工,搬砖,工地,安全",
        "emojiLength": 5
      }, {
        "emoji": "💂‍♀️",
        "emojiKeyword": "女,女人,女性,卫兵,卫士,女卫兵,女卫士",
        "emojiLength": 5
      }, {
        "emoji": "💂",
        "emojiKeyword": "中性,卫兵,卫士",
        "emojiLength": 2
      }, {
        "emoji": "💂‍♂️",
        "emojiKeyword": "男,男人,男性,卫兵,卫士,男卫兵,男卫士",
        "emojiLength": 5
      }, {
        "emoji": "🕵️‍♀️",
        "emojiKeyword": "女,女人,女性,间谍,侦探,女间谍,女侦探",
        "emojiLength": 6
      }, {
        "emoji": "🕵️",
        "emojiKeyword": "中性,,间谍,侦探",
        "emojiLength": 3
      }, {
        "emoji": "🕵️‍♂️",
        "emojiKeyword": "男,男人,男性,间谍,侦探,男间谍,男侦探",
        "emojiLength": 6
      }, {
        "emoji": "👩‍⚕️",
        "emojiKeyword": "女,女人,女性,医生,护士,女医生,女护士,医疗,药剂师,女药剂师",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍⚕️",
        "emojiKeyword": "中性,医生,护士,医疗,药剂师",
        "emojiLength": 5
      }, {
        "emoji": "👨‍⚕️",
        "emojiKeyword": "男,男人,男性,医生,护士,男医生,男护士,医疗,药剂师,男药剂师",
        "emojiLength": 5
      }, {
        "emoji": "👩‍🌾",
        "emojiKeyword": "女,女人,女性,农业,农民,种田,园丁,农妇",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🌾",
        "emojiKeyword": "中性,农业,农民,种田,园丁",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🌾",
        "emojiKeyword": "男,男人,男性,农业,农民,种田,园丁,农夫",
        "emojiLength": 5
      }, {
        "emoji": "👩‍🍳",
        "emojiKeyword": "女,女人,女性,厨师,做饭,女厨师",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🍳",
        "emojiKeyword": "中性,厨师,做饭",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🍳",
        "emojiKeyword": "男,男人,男性,厨师,做饭,男厨师",
        "emojiLength": 5
      }, {
        "emoji": "👩‍🎓",
        "emojiKeyword": "女,女人,女性,毕业,毕业生,研究生,博士生,女博士",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🎓",
        "emojiKeyword": "中性,毕业,毕业生,研究生,博士生",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🎓",
        "emojiKeyword": "男,男人,男性,毕业,毕业生,研究生,博士生,男博士",
        "emojiLength": 5
      }, {
        "emoji": "👩‍🎤",
        "emojiKeyword": "女,女人,女性,歌手,艺人,朋克,女歌手,女艺人",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🎤",
        "emojiKeyword": "中性,歌手,艺人,朋克",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🎤",
        "emojiKeyword": "男,男人,男性,歌手,艺人,朋克,男歌手,男艺人",
        "emojiLength": 5
      }, {
        "emoji": "👩‍🏫",
        "emojiKeyword": "女,女人,女性,上课,学校,老师,教授,女老师,女教授",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🏫",
        "emojiKeyword": "中性,上课,学校,老师,教授",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🏫",
        "emojiKeyword": "男,男人,男性,上课,学校,老师,教授,男老师,男教授",
        "emojiLength": 5
      }, {
        "emoji": "👩‍🏭",
        "emojiKeyword": "女,女人,女性,工人,工业,电工,电焊,维修",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🏭",
        "emojiKeyword": "中性,工人,工业,电工,电焊,维修",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🏭",
        "emojiKeyword": "男,男人,男性,工人,工业,电工,电焊,维修",
        "emojiLength": 5
      }, {
        "emoji": "👩‍💻",
        "emojiKeyword": "女,女人,女性,工人,写代码,程序员,开发,码农,程序媛",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍💻",
        "emojiKeyword": "中性,写代码,工人,程序员,开发,码农",
        "emojiLength": 5
      }, {
        "emoji": "👨‍💻",
        "emojiKeyword": "男,男人,男性,工人,写代码,程序员,开发,码农,程序猿",
        "emojiLength": 5
      }, {
        "emoji": "👩‍💼",
        "emojiKeyword": "女,女人,女性,工人,白领,公务员,女白领",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍💼",
        "emojiKeyword": "中性,工人,白领,公务员",
        "emojiLength": 5
      }, {
        "emoji": "👨‍💼",
        "emojiKeyword": "男,男人,男性,工人,白领,公务员,男白领",
        "emojiLength": 5
      }, {
        "emoji": "👩‍🔧",
        "emojiKeyword": "女,女人,女性,工人,蓝领,维修,女维修,技工,女技工",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🔧",
        "emojiKeyword": "中性,工人,蓝领,维修,技工",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🔧",
        "emojiKeyword": "男,男人,男性,工人,蓝领,维修,男维修,技工,男技工",
        "emojiLength": 5
      }, {
        "emoji": "👩‍🔬",
        "emojiKeyword": "女,女人,女性,研究员,实验,化学,女研究员,科学家,女科学家,研究",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🔬",
        "emojiKeyword": "中性,研究员,实验,化学,科学家,研究",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🔬",
        "emojiKeyword": "男,男人,男性,研究员,实验,化学,男研究员,科学家,男科学家,研究",
        "emojiLength": 5
      }, {
        "emoji": "👩‍🎨",
        "emojiKeyword": "女,女人,女性,画家,艺术家,画画,女画家,女艺术家",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🎨",
        "emojiKeyword": "中性,画家,艺术家,画画",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🎨",
        "emojiKeyword": "男,男人,男性,画家,艺术家,画画,男画家,男艺术家",
        "emojiLength": 5
      }, {
        "emoji": "👩‍🚒",
        "emojiKeyword": "女,女人,女性,消防,消防员,救火,女消防员",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🚒",
        "emojiKeyword": "中性,消防,消防员,救火",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🚒",
        "emojiKeyword": "男,男人,男性,消防,消防员,救火,男消防员",
        "emojiLength": 5
      }, {
        "emoji": "👩‍✈️",
        "emojiKeyword": "女,女人,女性,飞行,飞行员,机长,女机长",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍✈️",
        "emojiKeyword": "中性,飞行,飞行员,机长",
        "emojiLength": 5
      }, {
        "emoji": "👨‍✈️",
        "emojiKeyword": "男,男人,男性,飞行,飞行员,机长,男机长",
        "emojiLength": 5
      }, {
        "emoji": "👩‍🚀",
        "emojiKeyword": "女,女人,女性,太空,航天,航天员,女航天员,宇航员,女宇航员",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🚀",
        "emojiKeyword": "中性,太空,航天,航天员,宇航员",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🚀",
        "emojiKeyword": "男,男人,男性,太空,航天,航天员,男航天员,宇航员,男宇航员",
        "emojiLength": 5
      }, {
        "emoji": "👩‍⚖️",
        "emojiKeyword": "女,女人,女性,法庭,法官,法律,女法官",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍⚖️",
        "emojiKeyword": "中性,法庭,法官,法律",
        "emojiLength": 5
      }, {
        "emoji": "👨‍⚖️",
        "emojiKeyword": "男,男人,男性,法庭,法官,法律,男法官",
        "emojiLength": 5
      }, {
        "emoji": "👰‍♀️",
        "emojiKeyword": "女,女人,女性,婚礼,头纱,新娘,头纱女",
        "emojiLength": 5
      }, {
        "emoji": "👰",
        "emojiKeyword": "中性,婚礼,头纱",
        "emojiLength": 2
      }, {
        "emoji": "👰‍♂️",
        "emojiKeyword": "男,男人,男性,女性,婚礼,头纱,头纱男",
        "emojiLength": 5
      }, {
        "emoji": "🤵‍♀️",
        "emojiKeyword": "女,女人,女性,西服,燕尾服,西装,西装女,西服女",
        "emojiLength": 5
      }, {
        "emoji": "🤵",
        "emojiKeyword": "中性,西服,燕尾服,西装",
        "emojiLength": 2
      }, {
        "emoji": "🤵‍♂️",
        "emojiKeyword": "男,男人,男性,西服,燕尾服,西装,新郎",
        "emojiLength": 5
      }, {
        "emoji": "👸",
        "emojiKeyword": "女,女人,女性,王冠,皇冠,王,王族,公主,皇后",
        "emojiLength": 2
      }, {
        "emoji": "🤴",
        "emojiKeyword": "男,男人,男性,王冠,皇冠,王,王族,王子,皇帝",
        "emojiLength": 2
      }, {
        "emoji": "🦸‍♀️",
        "emojiKeyword": "女,女人,女性,超能力,英雄,超人,女英雄,女超人",
        "emojiLength": 5
      }, {
        "emoji": "🦸",
        "emojiKeyword": "中性,超能力,英雄,超人",
        "emojiLength": 2
      }, {
        "emoji": "🦸‍♂️",
        "emojiKeyword": "男,男人,男性,超能力,英雄,超人,男英雄,男超人",
        "emojiLength": 5
      }, {
        "emoji": "🦹‍♀️",
        "emojiKeyword": "女,女人,女性,超能力,罪犯,坏人,坏蛋,女罪犯",
        "emojiLength": 5
      }, {
        "emoji": "🦹",
        "emojiKeyword": "中性,超能力,罪犯,坏人,坏蛋",
        "emojiLength": 2
      }, {
        "emoji": "🦹‍♂️",
        "emojiKeyword": "男,男人,男性,超能力,罪犯,坏人,坏蛋,男罪犯",
        "emojiLength": 5
      }, {
        "emoji": "🤶",
        "emojiKeyword": "女,女人,女性,圣诞,圣诞节,圣诞老人,圣诞老奶奶",
        "emojiLength": 2
      }, {
        "emoji": "🧑‍🎄",
        "emojiKeyword": "中性,圣诞,圣诞节,圣诞老人",
        "emojiLength": 5
      }, {
        "emoji": "🎅",
        "emojiKeyword": "男,男人,男性,圣诞,圣诞节,圣诞老人,圣诞老爷爷",
        "emojiLength": 2
      }, {
        "emoji": "🧙‍♀️",
        "emojiKeyword": "女,女人,女性,魔法,巫师,法师,魔法师,女巫,女魔法师,传说",
        "emojiLength": 5
      }, {
        "emoji": "🧙",
        "emojiKeyword": "中性,魔法,巫师,法师,魔法师,传说",
        "emojiLength": 2
      }, {
        "emoji": "🧙‍♂️",
        "emojiKeyword": "男,男人,男性,魔法,巫师,法师,魔法师,男巫,男魔法师,传说",
        "emojiLength": 5
      }, {
        "emoji": "🧝‍♀️",
        "emojiKeyword": "女,女人,女性,魔法,精灵,女精灵,传说",
        "emojiLength": 5
      }, {
        "emoji": "🧝",
        "emojiKeyword": "中性,魔法,精灵,传说",
        "emojiLength": 2
      }, {
        "emoji": "🧝‍♂️",
        "emojiKeyword": "男,男人,男性,魔法,精灵,男精灵,传说",
        "emojiLength": 5
      }, {
        "emoji": "🧛‍♀️",
        "emojiKeyword": "女,女人,女性,吸血鬼,女吸血鬼,传说",
        "emojiLength": 5
      }, {
        "emoji": "🧛",
        "emojiKeyword": "中性,吸血鬼,传说",
        "emojiLength": 2
      }, {
        "emoji": "🧛‍♂️",
        "emojiKeyword": "男,男人,男性,吸血鬼,男吸血鬼,传说",
        "emojiLength": 5
      }, {
        "emoji": "🧟‍♀️",
        "emojiKeyword": "女,女人,女性,僵尸,丧尸,女僵尸,女丧尸,传说",
        "emojiLength": 5
      }, {
        "emoji": "🧟",
        "emojiKeyword": "中性,僵尸,丧尸,传说",
        "emojiLength": 2
      }, {
        "emoji": "🧟‍♂️",
        "emojiKeyword": "男,男人,男性,僵尸,丧尸,男僵尸,男丧尸,传说",
        "emojiLength": 5
      }, {
        "emoji": "🧞‍♀️",
        "emojiKeyword": "女,女人,女性,神灯,精灵,女精灵,妖精,传说",
        "emojiLength": 5
      }, {
        "emoji": "🧞",
        "emojiKeyword": "中性,神灯,精灵,妖精,传说",
        "emojiLength": 2
      }, {
        "emoji": "🧞‍♂️",
        "emojiKeyword": "男,男人,男性,神灯,精灵,男精灵,妖精,传说",
        "emojiLength": 5
      }, {
        "emoji": "🧜‍♀️",
        "emojiKeyword": "女,女人,女性,美人鱼,传说,人鱼",
        "emojiLength": 5
      }, {
        "emoji": "🧜",
        "emojiKeyword": "中性,美人鱼,传说,人鱼",
        "emojiLength": 2
      }, {
        "emoji": "🧜‍♂️",
        "emojiKeyword": "男,男人,男性,美人鱼,美人鱼男,传说,人鱼",
        "emojiLength": 5
      }, {
        "emoji": "🧚‍♀️",
        "emojiKeyword": "女,女人,女性,精灵,仙子,仙女,妖精,传说",
        "emojiLength": 5
      }, {
        "emoji": "🧚",
        "emojiKeyword": "中性,精灵,仙子,妖精,传说",
        "emojiLength": 2
      }, {
        "emoji": "🧚‍♂️",
        "emojiKeyword": "男,男人,男性,精灵,仙子,妖精,传说",
        "emojiLength": 5
      }, {
        "emoji": "👼",
        "emojiKeyword": "宝宝,天使,传说",
        "emojiLength": 2
      }, {
        "emoji": "🤰",
        "emojiKeyword": "女,女人,女性,怀孕,孕妇,生孩子,大肚子",
        "emojiLength": 2
      }, {
        "emoji": "🤱",
        "emojiKeyword": "女,女人,女性,哺乳,喂奶,母乳",
        "emojiLength": 2
      }, {
        "emoji": "👩‍🍼",
        "emojiKeyword": "女,女人,女性,哺乳,喂奶,奶瓶,喂奶女",
        "emojiLength": 5
      }, {
        "emoji": "🧑‍🍼",
        "emojiKeyword": "中性,哺乳,喂奶,奶瓶",
        "emojiLength": 5
      }, {
        "emoji": "👨‍🍼",
        "emojiKeyword": "男,男人,男性,哺乳,喂奶,奶瓶,喂奶男",
        "emojiLength": 5
      }, {
        "emoji": "🙇‍♀️",
        "emojiKeyword": "女,女人,女性,鞠躬,道歉,对不起,鞠躬女,道歉女",
        "emojiLength": 5
      }, {
        "emoji": "🙇",
        "emojiKeyword": "中性,鞠躬,道歉,对不起",
        "emojiLength": 2
      }, {
        "emoji": "🙇‍♂️",
        "emojiKeyword": "男,男人,男性,鞠躬,道歉,对不起,鞠躬男,道歉男",
        "emojiLength": 5
      }, {
        "emoji": "💁‍♀️",
        "emojiKeyword": "女,女人,女性,前台,接待,介绍,前台女",
        "emojiLength": 5
      }, {
        "emoji": "💁",
        "emojiKeyword": "中性,前台,接待,介绍",
        "emojiLength": 2
      }, {
        "emoji": "💁‍♂️",
        "emojiKeyword": "男,男人,男性,前台,接待,介绍,前台男",
        "emojiLength": 5
      }, {
        "emoji": "🙅‍♀️",
        "emojiKeyword": "女,女人,女性,拒绝,反对,禁止,叉,不行",
        "emojiLength": 5
      }, {
        "emoji": "🙅",
        "emojiKeyword": "中性,拒绝,反对,禁止,叉,不行",
        "emojiLength": 2
      }, {
        "emoji": "🙅‍♂️",
        "emojiKeyword": "男,男人,男性,拒绝,反对,禁止,叉,不行",
        "emojiLength": 5
      }, {
        "emoji": "🙆‍♀️",
        "emojiKeyword": "女,女人,女性,可以,通过,同意,OK,ok",
        "emojiLength": 5
      }, {
        "emoji": "🙆",
        "emojiKeyword": "中性,可以,通过,同意,OK,ok",
        "emojiLength": 2
      }, {
        "emoji": "🙆‍♂️",
        "emojiKeyword": "男,男人,男性,可以,通过,同意,OK,ok",
        "emojiLength": 5
      }, {
        "emoji": "🙋‍♀️",
        "emojiKeyword": "女,女人,女性,举手,加入,支持,举手女,举",
        "emojiLength": 5
      }, {
        "emoji": "🙋",
        "emojiKeyword": "中性,举手,加入,支持,举",
        "emojiLength": 2
      }, {
        "emoji": "🙋‍♂️",
        "emojiKeyword": "男,男人,男性,举手,加入,支持,举手男,举",
        "emojiLength": 5
      }, {
        "emoji": "🤦‍♀️",
        "emojiKeyword": "女,女人,女性,无语,捂脸,捂脸女",
        "emojiLength": 5
      }, {
        "emoji": "🤦",
        "emojiKeyword": "中性,无语,捂脸",
        "emojiLength": 2
      }, {
        "emoji": "🤦‍♂️",
        "emojiKeyword": "男,男人,男性,无语,捂脸,捂脸男",
        "emojiLength": 5
      }, {
        "emoji": "🤷‍♀️",
        "emojiKeyword": "女,女人,女性,耸肩,无所谓,耸肩女",
        "emojiLength": 5
      }, {
        "emoji": "🤷",
        "emojiKeyword": "中性,耸肩,无所谓",
        "emojiLength": 2
      }, {
        "emoji": "🤷‍♂️",
        "emojiKeyword": "男,男人,男性,耸肩,无所谓,耸肩男",
        "emojiLength": 5
      }, {
        "emoji": "🙎‍♀️",
        "emojiKeyword": "女,女人,女性,噘嘴,烦躁,生气,噘嘴女,生气女",
        "emojiLength": 5
      }, {
        "emoji": "🙎",
        "emojiKeyword": "中性,噘嘴,烦躁,生气",
        "emojiLength": 2
      }, {
        "emoji": "🙎‍♂️",
        "emojiKeyword": "男,男人,男性,噘嘴,烦躁,生气,噘嘴男,生气男",
        "emojiLength": 5
      }, {
        "emoji": "🙍‍♀️",
        "emojiKeyword": "女,女人,女性,皱眉,失望,无奈,皱眉女,失望女",
        "emojiLength": 5
      }, {
        "emoji": "🙍",
        "emojiKeyword": "中性,皱眉,失望,无奈",
        "emojiLength": 2
      }, {
        "emoji": "🙍‍♂️",
        "emojiKeyword": "男,男人,男性,皱眉,失望,无奈,皱眉男,失望男",
        "emojiLength": 5
      }, {
        "emoji": "💇‍♀️",
        "emojiKeyword": "女,女人,女性,理发,剪发,剪头,理发女,剪头女",
        "emojiLength": 5
      }, {
        "emoji": "💇",
        "emojiKeyword": "中性,理发,剪发,剪头",
        "emojiLength": 2
      }, {
        "emoji": "💇‍♂️",
        "emojiKeyword": "男,男人,男性,理发,剪发,剪头,理发男,剪头男",
        "emojiLength": 5
      }, {
        "emoji": "💆‍♀️",
        "emojiKeyword": "女,女人,女性,按摩,按摩女",
        "emojiLength": 5
      }, {
        "emoji": "💆",
        "emojiKeyword": "中性,按摩",
        "emojiLength": 2
      }, {
        "emoji": "💆‍♂️",
        "emojiKeyword": "男,男人,男性,按摩,按摩男",
        "emojiLength": 5
      }, {
        "emoji": "🧖‍♀️",
        "emojiKeyword": "女,女人,女性,桑拿,蒸桑拿,桑拿女",
        "emojiLength": 5
      }, {
        "emoji": "🧖",
        "emojiKeyword": "中性,桑拿,蒸桑拿",
        "emojiLength": 2
      }, {
        "emoji": "🧖‍♂️",
        "emojiKeyword": "男,男人,男性,桑拿,蒸桑拿,桑拿男",
        "emojiLength": 5
      }, {
        "emoji": "💅",
        "emojiKeyword": "美甲,指甲油,指甲",
        "emojiLength": 2
      }, {
        "emoji": "🤳",
        "emojiKeyword": "自拍,胳膊,拍照,手机,录像",
        "emojiLength": 2
      }, {
        "emoji": "💃",
        "emojiKeyword": "女,女人,女性,跳舞,裙子,踢踏舞,舞女,跳舞女",
        "emojiLength": 2
      }, {
        "emoji": "🕺",
        "emojiKeyword": "男,男人,男性,跳舞,踢踏舞,跳舞男",
        "emojiLength": 2
      }, {
        "emoji": "👯‍♀️",
        "emojiKeyword": "女,女人,女性,兔耳朵,兔女郎,好朋友,双胞胎",
        "emojiLength": 5
      }, {
        "emoji": "👯",
        "emojiKeyword": "中性,兔耳朵,兔女郎,好朋友,双胞胎",
        "emojiLength": 2
      }, {
        "emoji": "👯‍♂️",
        "emojiKeyword": "男,男人,男性,兔耳朵,兔女郎,好朋友,双胞胎",
        "emojiLength": 5
      }, {
        "emoji": "🕴️",
        "emojiKeyword": "男,男人,男性,西装,跳舞,魔术师,魔术,漂浮,悬浮,悬空,站立",
        "emojiLength": 3
      }, {
        "emoji": "🚶‍♀️",
        "emojiKeyword": "女,女人,女性,走路,步行,走路女,步行女,行人",
        "emojiLength": 5
      }, {
        "emoji": "🚶",
        "emojiKeyword": "中性,走路,步行,行人",
        "emojiLength": 2
      }, {
        "emoji": "🚶‍♂️",
        "emojiKeyword": "男,男人,男性,走路,步行,走路男,步行男,行人",
        "emojiLength": 5
      }, {
        "emoji": "🏃‍♀️",
        "emojiKeyword": "女,女人,女性,跑步,赛跑,运动,跑步女",
        "emojiLength": 5
      }, {
        "emoji": "🏃",
        "emojiKeyword": "中性,跑步,赛跑,运动",
        "emojiLength": 2
      }, {
        "emoji": "🏃‍♂️",
        "emojiKeyword": "男,男人,男性,跑步,赛跑,运动,跑步男",
        "emojiLength": 5
      }, {
        "emoji": "👫",
        "emojiKeyword": "手拉手,情侣,男女,好朋友",
        "emojiLength": 2
      }, {
        "emoji": "👭",
        "emojiKeyword": "手拉手,情侣,女女,好朋友",
        "emojiLength": 2
      }, {
        "emoji": "👬",
        "emojiKeyword": "手拉手,情侣,男男,好朋友",
        "emojiLength": 2
      }, {
        "emoji": "👩‍❤️‍👨",
        "emojiKeyword": "情侣,男女,爱,爱情",
        "emojiLength": 8
      }, {
        "emoji": "👩‍❤️‍👩",
        "emojiKeyword": "情侣,女,爱,爱情,同性恋",
        "emojiLength": 8
      }, {
        "emoji": "💑",
        "emojiKeyword": "情侣,爱,爱情",
        "emojiLength": 2
      }, {
        "emoji": "👨‍❤️‍👨",
        "emojiKeyword": "情侣,男,爱,爱情,同性恋",
        "emojiLength": 8
      }, {
        "emoji": "👩‍❤️‍💋‍👨",
        "emojiKeyword": "情侣,男女,接吻,爱情,爱,亲",
        "emojiLength": 11
      }, {
        "emoji": "👩‍❤️‍💋‍👩",
        "emojiKeyword": "情侣,女,爱,爱情,同性恋,接吻,亲",
        "emojiLength": 11
      }, {
        "emoji": "💏",
        "emojiKeyword": "情侣,爱,爱情,接吻,亲",
        "emojiLength": 2
      }, {
        "emoji": "👨‍❤️‍💋‍👨",
        "emojiKeyword": "情侣,男,接吻,爱情,爱,亲",
        "emojiLength": 11
      }, {
        "emoji": "👨‍👩‍👦",
        "emojiKeyword": "家庭,一家三口,一家人,儿子,独生子",
        "emojiLength": 8
      }, {
        "emoji": "👨‍👩‍👧",
        "emojiKeyword": "家庭,一家三口,一家人,女儿,独生女",
        "emojiLength": 8
      }, {
        "emoji": "👨‍👩‍👧‍👦",
        "emojiKeyword": "家庭,一家四口,一家人,龙凤胎,二胎,兄妹,姐弟",
        "emojiLength": 11
      }, {
        "emoji": "👨‍👩‍👦‍👦",
        "emojiKeyword": "家庭,一家四口,一家人,双胞胎,二胎,兄弟",
        "emojiLength": 11
      }, {
        "emoji": "👨‍👩‍👧‍👧",
        "emojiKeyword": "家庭,一家四口,一家人,双胞胎,二胎,姐妹",
        "emojiLength": 11
      }, {
        "emoji": "👩‍👩‍👦",
        "emojiKeyword": "家庭,一家三口,一家人,同性恋,同性恋家庭,女同性恋,女同性恋家庭,独生子",
        "emojiLength": 8
      }, {
        "emoji": "👩‍👩‍👧",
        "emojiKeyword": "家庭,一家三口,一家人,同性恋,同性恋家庭,女同性恋,女同性恋家庭,独生女",
        "emojiLength": 8
      }, {
        "emoji": "👩‍👩‍👧‍👦",
        "emojiKeyword": "家庭,一家四口,一家人,同性恋,同性恋家庭,女同性恋,女同性恋家庭,姐弟,兄妹",
        "emojiLength": 11
      }, {
        "emoji": "👩‍👩‍👦‍👦",
        "emojiKeyword": "家庭,一家四口,一家人,同性恋,同性恋家庭,女同性恋,女同性恋家庭,兄弟",
        "emojiLength": 11
      }, {
        "emoji": "👩‍👩‍👧‍👧",
        "emojiKeyword": "家庭,一家四口,一家人,同性恋,同性恋家庭,女同性恋,女同性恋家庭,姐妹",
        "emojiLength": 11
      }, {
        "emoji": "👨‍👨‍👦",
        "emojiKeyword": "家庭,一家三口,一家人,同性恋,同性恋家庭,男同性恋,男同性恋家庭,独生子",
        "emojiLength": 8
      }, {
        "emoji": "👨‍👨‍👧",
        "emojiKeyword": "家庭,一家三口,一家人,同性恋,同性恋家庭,男同性恋,男同性恋家庭,独生女",
        "emojiLength": 8
      }, {
        "emoji": "👨‍👨‍👧‍👦",
        "emojiKeyword": "家庭,一家四口,一家人,同性恋,同性恋家庭,男同性恋,男同性恋家庭,姐弟,兄妹",
        "emojiLength": 11
      }, {
        "emoji": "👨‍👨‍👦‍👦",
        "emojiKeyword": "家庭,一家四口,一家人,同性恋,同性恋家庭,男同性恋,男同性恋家庭,兄弟",
        "emojiLength": 11
      }, {
        "emoji": "👨‍👨‍👧‍👧",
        "emojiKeyword": "家庭,一家四口,一家人,同性恋,同性恋家庭,男同性恋,男同性恋家庭,姐妹",
        "emojiLength": 11
      }, {
        "emoji": "👩‍👦",
        "emojiKeyword": "家庭,单亲家庭,单亲妈妈,儿子,独生子",
        "emojiLength": 5
      }, {
        "emoji": "👩‍👧",
        "emojiKeyword": "家庭,单亲家庭,单亲妈妈,女儿,独生女",
        "emojiLength": 5
      }, {
        "emoji": "👩‍👧‍👦",
        "emojiKeyword": "家庭,单亲家庭,一家三口,单亲妈妈,姐弟,兄妹",
        "emojiLength": 8
      }, {
        "emoji": "👩‍👦‍👦",
        "emojiKeyword": "家庭,单亲家庭,一家三口,单亲妈妈,兄弟",
        "emojiLength": 8
      }, {
        "emoji": "👩‍👧‍👧",
        "emojiKeyword": "家庭,单亲家庭,一家三口,单亲妈妈,姐妹",
        "emojiLength": 8
      }, {
        "emoji": "👨‍👦",
        "emojiKeyword": "家庭,单亲家庭,单亲爸爸,儿子,独生子",
        "emojiLength": 5
      }, {
        "emoji": "👨‍👧",
        "emojiKeyword": "家庭,单亲家庭,单亲爸爸,女儿,独生女",
        "emojiLength": 5
      }, {
        "emoji": "👨‍👧‍👦",
        "emojiKeyword": "家庭,单亲家庭,一家三口,单亲爸爸,姐弟,兄妹",
        "emojiLength": 8
      }, {
        "emoji": "👨‍👦‍👦",
        "emojiKeyword": "家庭,单亲家庭,一家三口,单亲爸爸,兄弟",
        "emojiLength": 8
      }, {
        "emoji": "👨‍👧‍👧",
        "emojiKeyword": "家庭,单亲家庭,一家三口,单亲爸爸,姐妹",
        "emojiLength": 8
      }]
    }, {
      "categoryName": "服饰",
      "emojiCategoryEntities": [{
        "emoji": "🧶",
        "emojiKeyword": "线,毛线球,编织,毛线",
        "emojiLength": 2
      }, {
        "emoji": "🧵",
        "emojiKeyword": "线,线轴,绳子,针线,缝纫",
        "emojiLength": 2
      }, {
        "emoji": "🧥",
        "emojiKeyword": "服饰,大衣,风衣,夹克,外套,秋冬",
        "emojiLength": 2
      }, {
        "emoji": "🥼",
        "emojiKeyword": "服饰,白衣,白大褂,医生,科学家,实验,实验室,研究,研究员",
        "emojiLength": 2
      }, {
        "emoji": "👚",
        "emojiKeyword": "服饰,女,女装,短袖,粉色,上衣,夏装,休闲装",
        "emojiLength": 2
      }, {
        "emoji": "👕",
        "emojiKeyword": "服饰,男,男装,短袖,蓝色,上衣,夏装,休闲装",
        "emojiLength": 2
      }, {
        "emoji": "👖",
        "emojiKeyword": "服饰,裤子,牛仔裤,牛仔,休闲装",
        "emojiLength": 2
      }, {
        "emoji": "👔",
        "emojiKeyword": "服饰,衬衫,上班,领带",
        "emojiLength": 2
      }, {
        "emoji": "👗",
        "emojiKeyword": "服饰,女,女装,裙子,连衣裙,长裙,礼服",
        "emojiLength": 2
      }, {
        "emoji": "👙",
        "emojiKeyword": "服饰,女,女装,泳衣,比基尼,内衣,三点式,泳装,游泳,沙滩,夏",
        "emojiLength": 2
      }, {
        "emoji": "👘",
        "emojiKeyword": "服饰,礼服,和服,日本,女,女装",
        "emojiLength": 2
      }, {
        "emoji": "🥿",
        "emojiKeyword": "鞋,女鞋,平底鞋,休闲鞋",
        "emojiLength": 2
      }, {
        "emoji": "👠",
        "emojiKeyword": "鞋,女鞋,高跟鞋",
        "emojiLength": 2
      }, {
        "emoji": "👡",
        "emojiKeyword": "鞋,女鞋,高跟鞋,凉鞋",
        "emojiLength": 2
      }, {
        "emoji": "👢",
        "emojiKeyword": "鞋,女鞋,靴子,长筒靴,女靴",
        "emojiLength": 2
      }, {
        "emoji": "👞",
        "emojiKeyword": "鞋,皮鞋,男鞋,休闲鞋",
        "emojiLength": 2
      }, {
        "emoji": "👟",
        "emojiKeyword": "鞋,运动鞋,休闲鞋",
        "emojiLength": 2
      }, {
        "emoji": "🥾",
        "emojiKeyword": "鞋,登山鞋",
        "emojiLength": 2
      }, {
        "emoji": "🧦",
        "emojiKeyword": "袜子,长筒袜,冬,短袜,长袜",
        "emojiLength": 2
      }, {
        "emoji": "🧤",
        "emojiKeyword": "服饰,手套,冬,手",
        "emojiLength": 2
      }, {
        "emoji": "🧣",
        "emojiKeyword": "服饰,围巾,围脖,冬",
        "emojiLength": 2
      }, {
        "emoji": "🎩",
        "emojiKeyword": "头饰,服饰,帽子,礼帽,高帽",
        "emojiLength": 2
      }, {
        "emoji": "🧢",
        "emojiKeyword": "头饰,服饰,帽子,棒球帽,棒球,蓝",
        "emojiLength": 2
      }, {
        "emoji": "👒",
        "emojiKeyword": "头饰,服饰,帽子,女,遮阳帽,夏,沙滩,遮阳,太阳帽",
        "emojiLength": 2
      }, {
        "emoji": "🎓",
        "emojiKeyword": "头饰,服饰,帽子,毕业帽,毕业,学士帽",
        "emojiLength": 2
      }, {
        "emoji": "⛑️",
        "emojiKeyword": "帽子,安全帽,工地,十字,安全盔,头盔",
        "emojiLength": 2
      }, {
        "emoji": "👑",
        "emojiKeyword": "头饰,皇冠,王冠,王族,王",
        "emojiLength": 2
      }, {
        "emoji": "💍",
        "emojiKeyword": "首饰,钻石,戒指,钻戒,结婚,婚戒,婚礼",
        "emojiLength": 2
      }, {
        "emoji": "👝",
        "emojiKeyword": "包,手袋,化妆包,手提包,手拿包",
        "emojiLength": 2
      }, {
        "emoji": "👛",
        "emojiKeyword": "包,钱包,零钱包,钱",
        "emojiLength": 2
      }, {
        "emoji": "👜",
        "emojiKeyword": "包,手袋,手提包,挎包,女包",
        "emojiLength": 2
      }, {
        "emoji": "💼",
        "emojiKeyword": "包,手提包,文件,公文包,办公",
        "emojiLength": 2
      }, {
        "emoji": "🎒",
        "emojiKeyword": "包,双肩包,书包,背包",
        "emojiLength": 2
      }, {
        "emoji": "🧳",
        "emojiKeyword": "包,行李箱,行李包,行李,旅游,旅行",
        "emojiLength": 2
      }, {
        "emoji": "👓",
        "emojiKeyword": "眼镜,近视,近视镜,饰品",
        "emojiLength": 2
      }, {
        "emoji": "🕶️",
        "emojiKeyword": "眼镜,墨镜,太阳镜,饰品,遮阳,夏,沙滩",
        "emojiLength": 3
      }, {
        "emoji": "🥽",
        "emojiKeyword": "眼镜,游泳镜,护目镜",
        "emojiLength": 2
      }, {
        "emoji": "🌂",
        "emojiKeyword": "伞,雨伞,遮阳伞,雨",
        "emojiLength": 2
      }]
    }, {
      "categoryName": "动物",
      "emojiCategoryEntities": [{
        "emoji": "🐶",
        "emojiKeyword": "动物,宠物,狗,狗脸,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐱",
        "emojiKeyword": "动物,宠物,猫,猫脸,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐭",
        "emojiKeyword": "动物,鼠,老鼠,耗子",
        "emojiLength": 2
      }, {
        "emoji": "🐹",
        "emojiKeyword": "动物,宠物,鼠,仓鼠,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐰",
        "emojiKeyword": "动物,宠物,兔子,兔,家畜",
        "emojiLength": 2
      }, {
        "emoji": "🦊",
        "emojiKeyword": "动物,狐狸,狐,狐狸脸,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐻",
        "emojiKeyword": "动物,熊,狗熊,棕熊,熊脸,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐼",
        "emojiKeyword": "动物,熊猫,国宝,大熊猫,熊猫脸,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐻‍❄️",
        "emojiKeyword": "动物,白熊,北极熊,北极,哺乳,哺乳动物",
        "emojiLength": 5
      }, {
        "emoji": "🐨",
        "emojiKeyword": "动物,考拉,澳洲,澳大利亚,考拉脸,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐯",
        "emojiKeyword": "动物,老虎,虎头,老虎脸,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🦁",
        "emojiKeyword": "动物,狮子,狮子脸,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐮",
        "emojiKeyword": "动物,牛,奶牛,牛脸,哺乳,哺乳动物,家畜",
        "emojiLength": 2
      }, {
        "emoji": "🐷",
        "emojiKeyword": "动物,宠物,猪,猪头,猪脸,哺乳,哺乳动物,家畜",
        "emojiLength": 2
      }, {
        "emoji": "🐽",
        "emojiKeyword": "动物,猪,猪鼻子,鼻子",
        "emojiLength": 2
      }, {
        "emoji": "🐸",
        "emojiKeyword": "动物,宠物,青蛙,蛙,两栖,青蛙脸,蛙脸,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐵",
        "emojiKeyword": "动物,猴,猴子,猴脸,微笑,开心,哈哈,笑,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🙈",
        "emojiKeyword": "动物,猴,猴子,猴脸,不看,捂脸,捂眼,捂,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🙉",
        "emojiKeyword": "动物,猴,猴子,猴脸,不听,捂耳朵,捂,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🙊",
        "emojiKeyword": "动物,猴,猴子,猴脸,不说,捂嘴,吃惊,惊讶,天啊,震惊,捂,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐒",
        "emojiKeyword": "动物,生肖,猴,猴子,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐔",
        "emojiKeyword": "动物,禽,家禽,鸡,公鸡,家畜",
        "emojiLength": 2
      }, {
        "emoji": "🐧",
        "emojiKeyword": "动物,禽,南极,企鹅",
        "emojiLength": 2
      }, {
        "emoji": "🐦",
        "emojiKeyword": "动物,禽,鸟,小鸟",
        "emojiLength": 2
      }, {
        "emoji": "🐤",
        "emojiKeyword": "动物,禽,鸡,小鸡",
        "emojiLength": 2
      }, {
        "emoji": "🐣",
        "emojiKeyword": "动物,禽,家禽,孵化,破壳,小鸡,鸡",
        "emojiLength": 2
      }, {
        "emoji": "🐥",
        "emojiKeyword": "动物,宠物,家禽,小鸡,鸡",
        "emojiLength": 2
      }, {
        "emoji": "🦆",
        "emojiKeyword": "动物,宠物,禽,鸭,鸭子,家禽",
        "emojiLength": 2
      }, {
        "emoji": "🦅",
        "emojiKeyword": "动物,禽,鹰,老鹰",
        "emojiLength": 2
      }, {
        "emoji": "🦉",
        "emojiKeyword": "动物,禽,鹰,猫头鹰",
        "emojiLength": 2
      }, {
        "emoji": "🦇",
        "emojiKeyword": "动物,蝙蝠,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐺",
        "emojiKeyword": "动物,狼,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐗",
        "emojiKeyword": "动物,猪,猪头,野猪,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐴",
        "emojiKeyword": "动物,马,马脸,马头,哺乳,哺乳动物,家畜",
        "emojiLength": 2
      }, {
        "emoji": "🦄",
        "emojiKeyword": "动物,传说,马,独角兽,哺乳,哺乳动物",
        "emojiLength": 2
      }, {
        "emoji": "🐝",
        "emojiKeyword": "动物,昆虫,蜜蜂,蜜,勤劳",
        "emojiLength": 2
      }, {
        "emoji": "🐛",
        "emojiKeyword": "动物,昆虫,毛毛虫,青虫,虫",
        "emojiLength": 2
      }, {
        "emoji": "🦋",
        "emojiKeyword": "动物,昆虫,蝴蝶,蝶,蓝",
        "emojiLength": 2
      }, {
        "emoji": "🐌",
        "emojiKeyword": "动物,蜗牛,慢",
        "emojiLength": 2
      }, {
        "emoji": "🐞",
        "emojiKeyword": "动物,昆虫,瓢虫,甲壳虫,金龟子,虫",
        "emojiLength": 2
      }, {
        "emoji": "🐜",
        "emojiKeyword": "动物,昆虫,蚂蚁,蚁,虫",
        "emojiLength": 2
      }, {
        "emoji": "🦟",
        "emojiKeyword": "动物,昆虫,蚊子,蚊,虫",
        "emojiLength": 2
      }, {
        "emoji": "🦗",
        "emojiKeyword": "动物,昆虫,蟋蟀,蛐蛐",
        "emojiLength": 2
      }, {
        "emoji": "🕷️",
        "emojiKeyword": "动物,昆虫,蜘蛛,虫,蛛",
        "emojiLength": 3
      }, {
        "emoji": "🕸️",
        "emojiKeyword": "昆虫,蜘蛛,虫,蜘蛛丝,丝,蛛",
        "emojiLength": 3
      }, {
        "emoji": "🦂",
        "emojiKeyword": "动物,蝎子,蝎子,天蝎座,沙漠",
        "emojiLength": 2
      }, {
        "emoji": "🐢",
        "emojiKeyword": "动物,乌龟,慢,龟,爬,爬行,爬行动物",
        "emojiLength": 2
      }, {
        "emoji": "🐍",
        "emojiKeyword": "动物,宠物,生肖,蛇,青蛇,爬,爬行,爬行动物",
        "emojiLength": 2
      }, {
        "emoji": "🦎",
        "emojiKeyword": "动物,蜥蜴,壁虎,爬,爬行,爬行动物",
        "emojiLength": 2
      }, {
        "emoji": "🦖",
        "emojiKeyword": "动物,侏罗纪,恐龙,霸王龙,爬,爬行,爬行动物",
        "emojiLength": 2
      }, {
        "emoji": "🦕",
        "emojiKeyword": "动物,侏罗纪,恐龙,腕龙,雷龙,爬,爬行,爬行动物,蓝",
        "emojiLength": 2
      }, {
        "emoji": "🐙",
        "emojiKeyword": "动物,鱼,章鱼,八爪鱼,海洋动物,海,海产",
        "emojiLength": 2
      }, {
        "emoji": "🦑",
        "emojiKeyword": "动物,鱼,鱿鱼,乌贼,海洋动物,海,海产",
        "emojiLength": 2
      }, {
        "emoji": "🦐",
        "emojiKeyword": "动物,海洋动物,海,海产,虾",
        "emojiLength": 2
      }, {
        "emoji": "🦞",
        "emojiKeyword": "动物,海洋动物,海,海产,虾,龙虾",
        "emojiLength": 2
      }, {
        "emoji": "🦀",
        "emojiKeyword": "动物,海洋动物,海,海产,蟹,螃蟹",
        "emojiLength": 2
      }, {
        "emoji": "🐡",
        "emojiKeyword": "动物,海洋动物,海,水产,河豚,鱼",
        "emojiLength": 2
      }, {
        "emoji": "🐠",
        "emojiKeyword": "动物,海洋动物,海,热带鱼,鱼,热带,水族馆",
        "emojiLength": 2
      }, {
        "emoji": "🐟",
        "emojiKeyword": "动物,海洋动物,海,水产,鱼,蓝",
        "emojiLength": 2
      }, {
        "emoji": "🐬",
        "emojiKeyword": "动物,海洋动物,海,海豚,哺乳,哺乳动物,蓝",
        "emojiLength": 2
      }, {
        "emoji": "🐳",
        "emojiKeyword": "动物,海洋动物,海,鲸,鲸鱼,哺乳,哺乳动物,蓝",
        "emojiLength": 2
      }, {
        "emoji": "🐋",
        "emojiKeyword": "动物,海洋动物,海,鲸,鲸鱼,哺乳,哺乳动物,蓝",
        "emojiLength": 2
      }, {
        "emoji": "🦈",
        "emojiKeyword": "动物,海洋动物,海,鲨鱼",
        "emojiLength": 2
      }, {
        "emoji": "🐊",
        "emojiKeyword": "动物,两栖,鳄鱼,爬,爬行,爬行动物",
        "emojiLength": 2
      }, {
        "emoji": "🐅",
        "emojiKeyword": "动物,生肖,哺乳,哺乳动物,老虎,虎",
        "emojiLength": 2
      }, {
        "emoji": "🐆",
        "emojiKeyword": "动物,哺乳,哺乳动物,豹,豹子,金钱豹",
        "emojiLength": 2
      }, {
        "emoji": "🦓",
        "emojiKeyword": "动物,哺乳,哺乳动物,马,斑马",
        "emojiLength": 2
      }, {
        "emoji": "🦍",
        "emojiKeyword": "动物,哺乳,哺乳动物,猩猩,大猩猩,猿,猴",
        "emojiLength": 2
      }, {
        "emoji": "🐘",
        "emojiKeyword": "动物,哺乳,哺乳动物,象,大象",
        "emojiLength": 2
      }, {
        "emoji": "🦛",
        "emojiKeyword": "动物,哺乳,哺乳动物,河马",
        "emojiLength": 2
      }, {
        "emoji": "🦏",
        "emojiKeyword": "动物,哺乳,哺乳动物,犀牛",
        "emojiLength": 2
      }, {
        "emoji": "🐪",
        "emojiKeyword": "动物,哺乳,哺乳动物,骆驼,沙漠,单峰骆驼,单峰",
        "emojiLength": 2
      }, {
        "emoji": "🐫",
        "emojiKeyword": "动物,哺乳,哺乳动物,骆驼,沙漠,双峰骆驼,双峰",
        "emojiLength": 2
      }, {
        "emoji": "🦒",
        "emojiKeyword": "动物,哺乳,哺乳动物,长颈鹿,鹿",
        "emojiLength": 2
      }, {
        "emoji": "🦘",
        "emojiKeyword": "动物,哺乳,哺乳动物,袋鼠,澳大利亚,澳洲",
        "emojiLength": 2
      }, {
        "emoji": "🐃",
        "emojiKeyword": "动物,哺乳,哺乳动物,牛,水牛,野牛",
        "emojiLength": 2
      }, {
        "emoji": "🐂",
        "emojiKeyword": "动物,生肖,哺乳,哺乳动物,牛,家畜",
        "emojiLength": 2
      }, {
        "emoji": "🐄",
        "emojiKeyword": "动物,哺乳,哺乳动物,牛,家畜,奶牛",
        "emojiLength": 2
      }, {
        "emoji": "🐎",
        "emojiKeyword": "动物,生肖,哺乳,哺乳动物,马,赛马,家畜",
        "emojiLength": 2
      }, {
        "emoji": "🐖",
        "emojiKeyword": "动物,生肖,哺乳,哺乳动物,家畜,猪",
        "emojiLength": 2
      }, {
        "emoji": "🐏",
        "emojiKeyword": "动物,哺乳,哺乳动物,家畜,羊,绵羊,羊毛",
        "emojiLength": 2
      }, {
        "emoji": "🐑",
        "emojiKeyword": "动物,哺乳,哺乳动物,家畜,羊,绵羊,羊毛",
        "emojiLength": 2
      }, {
        "emoji": "🦙",
        "emojiKeyword": "动物,哺乳,哺乳动物,家畜,宠物,羊驼,草泥马",
        "emojiLength": 2
      }, {
        "emoji": "🐐",
        "emojiKeyword": "动物,生肖,哺乳,哺乳动物,羊,山羊,家畜",
        "emojiLength": 2
      }, {
        "emoji": "🦌",
        "emojiKeyword": "动物,哺乳,哺乳动物,鹿",
        "emojiLength": 2
      }, {
        "emoji": "🐕",
        "emojiKeyword": "动物,宠物,生肖,狗,哺乳,哺乳动物,家畜",
        "emojiLength": 2
      }, {
        "emoji": "🐩",
        "emojiKeyword": "动物,宠物,狗,哺乳,哺乳动物,贵宾,贵宾犬,贵妇犬",
        "emojiLength": 2
      }, {
        "emoji": "🐈",
        "emojiKeyword": "动物,宠物,猫,哺乳,哺乳动物,橘猫",
        "emojiLength": 2
      }, {
        "emoji": "🐓",
        "emojiKeyword": "动物,生肖,禽,家禽,鸡,公鸡,打鸣",
        "emojiLength": 2
      }, {
        "emoji": "🦃",
        "emojiKeyword": "动物,禽,家禽,火鸡,感恩节,鸡",
        "emojiLength": 2
      }, {
        "emoji": "🦚",
        "emojiKeyword": "动物,禽,孔雀,开屏,孔雀开屏",
        "emojiLength": 2
      }, {
        "emoji": "🦜",
        "emojiKeyword": "动物,宠物,禽,鹦鹉",
        "emojiLength": 2
      }, {
        "emoji": "🦢",
        "emojiKeyword": "动物,禽,鹅,天鹅",
        "emojiLength": 2
      }, {
        "emoji": "🕊️",
        "emojiKeyword": "动物,禽,鸽子,和平,和平鸽",
        "emojiLength": 3
      }, {
        "emoji": "🐇",
        "emojiKeyword": "动物,生肖,兔,兔子,小白兔",
        "emojiLength": 2
      }, {
        "emoji": "🦝",
        "emojiKeyword": "动物,哺乳,哺乳动物,浣熊,小浣熊,干脆面",
        "emojiLength": 2
      }, {
        "emoji": "🦡",
        "emojiKeyword": "动物,哺乳,哺乳动物,獾,蜜獾,平头,平头哥",
        "emojiLength": 2
      }, {
        "emoji": "🐁",
        "emojiKeyword": "动物,鼠,小白鼠,老鼠,白鼠,耗子",
        "emojiLength": 2
      }, {
        "emoji": "🐀",
        "emojiKeyword": "动物,生肖,鼠,老鼠,耗子",
        "emojiLength": 2
      }, {
        "emoji": "🐿️",
        "emojiKeyword": "动物,鼠,松鼠",
        "emojiLength": 3
      }, {
        "emoji": "🦔",
        "emojiKeyword": "动物,宠物,哺乳,哺乳动物,刺猬,刺",
        "emojiLength": 2
      }, {
        "emoji": "🐾",
        "emojiKeyword": "动物,脚印,足迹,踪迹",
        "emojiLength": 2
      }, {
        "emoji": "🐉",
        "emojiKeyword": "动物,生肖,传说,龙,端午",
        "emojiLength": 2
      }, {
        "emoji": "🐲",
        "emojiKeyword": "动物,传说,龙,端午",
        "emojiLength": 2
      }]
    }, {
      "categoryName": "植物",
      "emojiCategoryEntities": [{
        "emoji": "🌵",
        "emojiKeyword": "植物,绿色,仙人掌,沙漠",
        "emojiLength": 2
      }, {
        "emoji": "🎄",
        "emojiKeyword": "植物,绿色,圣诞,松树,圣诞树,圣诞节",
        "emojiLength": 2
      }, {
        "emoji": "🌲",
        "emojiKeyword": "植物,绿色,松树,森林,常青树",
        "emojiLength": 2
      }, {
        "emoji": "🌳",
        "emojiKeyword": "植物,绿色,乔木,灌木,森林",
        "emojiLength": 2
      }, {
        "emoji": "🌴",
        "emojiKeyword": "植物,绿色,沙滩,热带,椰树,海边,树,椰子",
        "emojiLength": 2
      }, {
        "emoji": "🌱",
        "emojiKeyword": "植物,绿色,树苗,幼苗,苗,发芽,种草",
        "emojiLength": 2
      }, {
        "emoji": "🌿",
        "emojiKeyword": "植物,绿色,草药,香草,药草,药材",
        "emojiLength": 2
      }, {
        "emoji": "☘️",
        "emojiKeyword": "植物,绿色,三叶草,草",
        "emojiLength": 2
      }, {
        "emoji": "🍀",
        "emojiKeyword": "植物,绿色,四叶草,幸运,草",
        "emojiLength": 2
      }, {
        "emoji": "🎍",
        "emojiKeyword": "植物,绿色,庆祝,日本,松树,盆栽,竹,门松",
        "emojiLength": 2
      }, {
        "emoji": "🎋",
        "emojiKeyword": "植物,绿色,竹子,竹,日本,七夕,庆祝,许愿",
        "emojiLength": 2
      }, {
        "emoji": "🍃",
        "emojiKeyword": "植物,绿色,落叶,叶子",
        "emojiLength": 2
      }, {
        "emoji": "🍂",
        "emojiKeyword": "植物,落叶,叶子,秋,秋天,枯",
        "emojiLength": 2
      }, {
        "emoji": "🍁",
        "emojiKeyword": "植物,落叶,叶子,枫叶,秋,秋天,红",
        "emojiLength": 2
      }, {
        "emoji": "🍄",
        "emojiKeyword": "植物,蘑菇,菇",
        "emojiLength": 2
      }, {
        "emoji": "🐚",
        "emojiKeyword": "海螺,贝壳,沙滩,海滩,海",
        "emojiLength": 2
      }, {
        "emoji": "🌾",
        "emojiKeyword": "植物,粮食,稻子,水稻,大米,米,稻,麦子,小麦",
        "emojiLength": 2
      }, {
        "emoji": "💐",
        "emojiKeyword": "植物,花,花束,祝贺,鲜花,庆祝",
        "emojiLength": 2
      }, {
        "emoji": "🌷",
        "emojiKeyword": "植物,花,郁金香,粉",
        "emojiLength": 2
      }, {
        "emoji": "🌹",
        "emojiKeyword": "植物,花,玫瑰,玫瑰花,红",
        "emojiLength": 2
      }, {
        "emoji": "🥀",
        "emojiKeyword": "植物,花,玫瑰,凋谢,枯萎,枯",
        "emojiLength": 2
      }, {
        "emoji": "🌺",
        "emojiKeyword": "植物,花,芙蓉,木槿,红花,红",
        "emojiLength": 2
      }, {
        "emoji": "🌸",
        "emojiKeyword": "植物,花,日本,樱花,粉,春天",
        "emojiLength": 2
      }, {
        "emoji": "🌼",
        "emojiKeyword": "植物,花,黄,菊花,雏菊",
        "emojiLength": 2
      }]
    }, {
      "categoryName": "天气",
      "emojiCategoryEntities": [{
        "emoji": "🌞",
        "emojiKeyword": "太阳,日,阳光,晴天,微笑,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌝",
        "emojiKeyword": "月球,月亮,满月,微笑,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌛",
        "emojiKeyword": "月亮,月牙,微笑,上弦月,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌜",
        "emojiKeyword": "月亮,月牙,微笑,下弦月,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌚",
        "emojiKeyword": "月球,月亮,新月,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌕",
        "emojiKeyword": "月球,月亮,满月,圆月,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌖",
        "emojiKeyword": "月球,月亮,月食,亏凸月,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌗",
        "emojiKeyword": "月球,月亮,半月,月食,下弦月,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌘",
        "emojiKeyword": "月球,月亮,新月,残月,月食,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌑",
        "emojiKeyword": "月球,月亮,新月,月食,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌒",
        "emojiKeyword": "月球,月亮,新月,残月,峨眉月,月食,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌓",
        "emojiKeyword": "月球,月亮,半月,月食,上弦月,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌔",
        "emojiKeyword": "月球,月亮,月食,盈凸月,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌙",
        "emojiKeyword": "月亮,新月,残月,月牙,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌎",
        "emojiKeyword": "世界,地球,美洲,地球仪",
        "emojiLength": 2
      }, {
        "emoji": "🌍",
        "emojiKeyword": "世界,地球,欧洲,非洲,地球仪",
        "emojiLength": 2
      }, {
        "emoji": "🌏",
        "emojiKeyword": "星球,世界,地球,亚洲,澳洲,地球仪",
        "emojiLength": 2
      }, {
        "emoji": "💫",
        "emojiKeyword": "星,星星,流星,许愿",
        "emojiLength": 2
      }, {
        "emoji": "⭐️",
        "emojiKeyword": "星,星星,天文",
        "emojiLength": 2
      }, {
        "emoji": "🌟",
        "emojiKeyword": "星,星星,天文,闪,闪亮",
        "emojiLength": 2
      }, {
        "emoji": "✨",
        "emojiKeyword": "星,星星,闪烁,闪,闪亮",
        "emojiLength": 1
      }, {
        "emoji": "⚡️",
        "emojiKeyword": "天气,闪电,电,高压,电流",
        "emojiLength": 2
      }, {
        "emoji": "☄️",
        "emojiKeyword": "天文,星,火球,彗星",
        "emojiLength": 2
      }, {
        "emoji": "💥",
        "emojiKeyword": "炸,爆炸,爆,炸裂",
        "emojiLength": 2
      }, {
        "emoji": "🔥",
        "emojiKeyword": "火,着火,火苗,点火,燃,流星,热烈,热血",
        "emojiLength": 2
      }, {
        "emoji": "🌪️",
        "emojiKeyword": "天气,风,旋风,龙卷风,飓风",
        "emojiLength": 3
      }, {
        "emoji": "🌈",
        "emojiKeyword": "天气,彩虹,放晴,雨后",
        "emojiLength": 2
      }, {
        "emoji": "☀️",
        "emojiKeyword": "天气,太阳,日,晴,晴天,白天,晴朗",
        "emojiLength": 2
      }, {
        "emoji": "🌤️",
        "emojiKeyword": "天气,云,太阳,多云",
        "emojiLength": 3
      }, {
        "emoji": "⛅️",
        "emojiKeyword": "天气,云,太阳,阴,阴天,多云",
        "emojiLength": 2
      }, {
        "emoji": "🌥️",
        "emojiKeyword": "天气,云,阴天,多云",
        "emojiLength": 3
      }, {
        "emoji": "☁️",
        "emojiKeyword": "天气,云,阴天,多云",
        "emojiLength": 2
      }, {
        "emoji": "🌦️",
        "emojiKeyword": "天气,云,太阳,雨,下雨",
        "emojiLength": 3
      }, {
        "emoji": "🌧️",
        "emojiKeyword": "天气,云,多云,雨,下雨",
        "emojiLength": 3
      }, {
        "emoji": "⛈️",
        "emojiKeyword": "天气,云,雷阵雨,雨,下雨,雷,闪电",
        "emojiLength": 2
      }, {
        "emoji": "🌩️",
        "emojiKeyword": "天气,云,多云,雷,闪电",
        "emojiLength": 3
      }, {
        "emoji": "🌨️",
        "emojiKeyword": "天气,云,多云,雪,下雪",
        "emojiLength": 3
      }, {
        "emoji": "❄️",
        "emojiKeyword": "天气,雪,下雪,雪花,冬,冰,结冰",
        "emojiLength": 2
      }, {
        "emoji": "☃️",
        "emojiKeyword": "天气,雪,下雪,冬,雪人",
        "emojiLength": 2
      }, {
        "emoji": "⛄️",
        "emojiKeyword": "天气,雪,冬,雪人",
        "emojiLength": 2
      }, {
        "emoji": "🌬️",
        "emojiKeyword": "天气,风,大风,吹,刮风",
        "emojiLength": 3
      }, {
        "emoji": "💨",
        "emojiKeyword": "吹,排气,尾气,快速",
        "emojiLength": 2
      }, {
        "emoji": "💧",
        "emojiKeyword": "天气,水,水滴,雨,眼泪,汗,雨天,泪,蓝",
        "emojiLength": 2
      }, {
        "emoji": "💦",
        "emojiKeyword": "天气,忙,水,水滴,雨,眼泪,汗,雨天,泪,蓝",
        "emojiLength": 2
      }, {
        "emoji": "☔️",
        "emojiKeyword": "天气,雨,下雨,打伞,雨天,伞",
        "emojiLength": 2
      }, {
        "emoji": "☂️",
        "emojiKeyword": "天气,伞,打伞,遮阳",
        "emojiLength": 2
      }, {
        "emoji": "🌊",
        "emojiKeyword": "天气,海浪,海,浪花,冲浪,波浪,海啸",
        "emojiLength": 2
      }, {
        "emoji": "🌫️",
        "emojiKeyword": "天气,雾,迷茫,雾霾,霾,模糊",
        "emojiLength": 3
      }]
    }, {
      "categoryName": "食物与饮料",
      "emojiCategoryEntities": [{
        "emoji": "🍏",
        "emojiKeyword": "水果,苹果,青苹果,绿,素",
        "emojiLength": 2
      }, {
        "emoji": "🍎",
        "emojiKeyword": "水果,苹果,红苹果,红,红富士,素",
        "emojiLength": 2
      }, {
        "emoji": "🍐",
        "emojiKeyword": "水果,梨,鸭梨,素",
        "emojiLength": 2
      }, {
        "emoji": "🍊",
        "emojiKeyword": "水果,橘子,橙子,橘色,橙色,柑橘,素",
        "emojiLength": 2
      }, {
        "emoji": "🍋",
        "emojiKeyword": "水果,柠檬,酸,黄,素",
        "emojiLength": 2
      }, {
        "emoji": "🍌",
        "emojiKeyword": "水果,香蕉,香蕉皮,黄,素",
        "emojiLength": 2
      }, {
        "emoji": "🍉",
        "emojiKeyword": "水果,西瓜,夏天,瓜,素",
        "emojiLength": 2
      }, {
        "emoji": "🍇",
        "emojiKeyword": "水果,葡萄,酸,素",
        "emojiLength": 2
      }, {
        "emoji": "🍓",
        "emojiKeyword": "水果,草莓,红,素",
        "emojiLength": 2
      }, {
        "emoji": "🍈",
        "emojiKeyword": "水果,瓜,哈密瓜,香瓜,素",
        "emojiLength": 2
      }, {
        "emoji": "🍒",
        "emojiKeyword": "水果,樱桃,车厘子,红,素",
        "emojiLength": 2
      }, {
        "emoji": "🍑",
        "emojiKeyword": "水果,桃,桃子,水蜜桃,蜜桃,素",
        "emojiLength": 2
      }, {
        "emoji": "🥭",
        "emojiKeyword": "水果,芒果,热带水果,素",
        "emojiLength": 2
      }, {
        "emoji": "🍍",
        "emojiKeyword": "水果,菠萝,酸,凤梨,热带水果,素",
        "emojiLength": 2
      }, {
        "emoji": "🥥",
        "emojiKeyword": "水果,椰子,椰树,海边,椰汁,椰,素",
        "emojiLength": 2
      }, {
        "emoji": "🥝",
        "emojiKeyword": "水果,猕猴桃,奇异果,绿,素",
        "emojiLength": 2
      }, {
        "emoji": "🍅",
        "emojiKeyword": "水果,蔬菜,西红柿,番茄,红,柿子,素",
        "emojiLength": 2
      }, {
        "emoji": "🍆",
        "emojiKeyword": "蔬菜,茄子,茄,紫,素",
        "emojiLength": 2
      }, {
        "emoji": "🥑",
        "emojiKeyword": "水果,牛油果,鳄梨,绿,素",
        "emojiLength": 2
      }, {
        "emoji": "🥦",
        "emojiKeyword": "蔬菜,花椰菜,花菜,西蓝花,绿,素",
        "emojiLength": 2
      }, {
        "emoji": "🥬",
        "emojiKeyword": "蔬菜,素,白菜,油菜,生菜,莴苣",
        "emojiLength": 2
      }, {
        "emoji": "🥒",
        "emojiKeyword": "蔬菜,素,黄瓜,黄瓜片",
        "emojiLength": 2
      }, {
        "emoji": "🌶️",
        "emojiKeyword": "蔬菜,素,辣椒,辣,尖椒,椒",
        "emojiLength": 3
      }, {
        "emoji": "🌽",
        "emojiKeyword": "蔬菜,素,玉米,苞米",
        "emojiLength": 2
      }, {
        "emoji": "🥕",
        "emojiKeyword": "蔬菜,素,萝卜,胡萝卜",
        "emojiLength": 2
      }, {
        "emoji": "🥔",
        "emojiKeyword": "蔬菜,素,土豆,洋芋",
        "emojiLength": 2
      }, {
        "emoji": "🍠",
        "emojiKeyword": "蔬菜,素,红薯,地瓜",
        "emojiLength": 2
      }, {
        "emoji": "🥐",
        "emojiKeyword": "面包,素,牛角包,牛角,羊角包,羊角,牛角面包,羊角面包,烘焙,甜食",
        "emojiLength": 2
      }, {
        "emoji": "🥯",
        "emojiKeyword": "面包,素,贝果,面包圈,烘焙,甜食",
        "emojiLength": 2
      }, {
        "emoji": "🍞",
        "emojiKeyword": "面包,素,烘焙,早餐",
        "emojiLength": 2
      }, {
        "emoji": "🥖",
        "emojiKeyword": "面包,素,法棍,烘焙",
        "emojiLength": 2
      }, {
        "emoji": "🥨",
        "emojiKeyword": "面包,素,烘焙,椒盐,卷饼,椒盐卷饼",
        "emojiLength": 2
      }, {
        "emoji": "🧀",
        "emojiKeyword": "素,起司,奶酪,芝士,乳制品",
        "emojiLength": 2
      }, {
        "emoji": "🥚",
        "emojiKeyword": "蛋,鸡蛋,鸭蛋,鹅蛋,水煮蛋,早餐",
        "emojiLength": 2
      }, {
        "emoji": "🍳",
        "emojiKeyword": "煎蛋,煎鸡蛋,平底锅,早餐,做",
        "emojiLength": 2
      }, {
        "emoji": "🥞",
        "emojiKeyword": "素,饼,烙饼,煎饼,烘焙,早餐",
        "emojiLength": 2
      }, {
        "emoji": "🥓",
        "emojiKeyword": "肉,培根,猪",
        "emojiLength": 2
      }, {
        "emoji": "🥩",
        "emojiKeyword": "肉,牛排,肉块,排骨",
        "emojiLength": 2
      }, {
        "emoji": "🍗",
        "emojiKeyword": "肉,鸡腿",
        "emojiLength": 2
      }, {
        "emoji": "🍖",
        "emojiKeyword": "肉,骨,肉块,排骨",
        "emojiLength": 2
      }, {
        "emoji": "🦴",
        "emojiKeyword": "骨头,骨",
        "emojiLength": 2
      }, {
        "emoji": "🌭",
        "emojiKeyword": "肉,热狗,面包,烤肠,垃圾食品,快餐",
        "emojiLength": 2
      }, {
        "emoji": "🍔",
        "emojiKeyword": "肉,汉堡,汉堡包,面包,肉饼,垃圾食品,快餐",
        "emojiLength": 2
      }, {
        "emoji": "🍟",
        "emojiKeyword": "素,薯条,土豆条,土豆片,炸薯条,垃圾食品,快餐",
        "emojiLength": 2
      }, {
        "emoji": "🍕",
        "emojiKeyword": "披萨,比萨,饼,垃圾食品,熟食,快餐",
        "emojiLength": 2
      }, {
        "emoji": "🥪",
        "emojiKeyword": "面包,素,三明治,早餐,熟食",
        "emojiLength": 2
      }, {
        "emoji": "🥙",
        "emojiKeyword": "饼,肉夹馍,馅饼,熟食",
        "emojiLength": 2
      }, {
        "emoji": "🌮",
        "emojiKeyword": "饼,卷饼,垃圾食品,塔可,墨西哥,墨西哥卷饼,熟食",
        "emojiLength": 2
      }, {
        "emoji": "🌯",
        "emojiKeyword": "饼,卷饼,卷,熟食",
        "emojiLength": 2
      }, {
        "emoji": "🥗",
        "emojiKeyword": "素菜,沙拉,蔬菜沙拉,色拉,凉拌菜,绿色",
        "emojiLength": 2
      }, {
        "emoji": "🥘",
        "emojiKeyword": "熟食,汤,烩菜,烩肉,煎锅,砂锅",
        "emojiLength": 2
      }, {
        "emoji": "🥫",
        "emojiKeyword": "罐头,番茄,番茄酱,酱料",
        "emojiLength": 2
      }, {
        "emoji": "🍝",
        "emojiKeyword": "熟食,面,意面,意大利面,番茄酱,肉酱面",
        "emojiLength": 2
      }, {
        "emoji": "🍜",
        "emojiKeyword": "拉面,方便面,熟食,面",
        "emojiLength": 2
      }, {
        "emoji": "🍲",
        "emojiKeyword": "砂锅,锅,汤,煲汤",
        "emojiLength": 2
      }, {
        "emoji": "🍛",
        "emojiKeyword": "米饭,熟食,咖喱,咖喱饭,印度",
        "emojiLength": 2
      }, {
        "emoji": "🍣",
        "emojiKeyword": "米饭,熟食,寿司,刺身,日料,日本料理",
        "emojiLength": 2
      }, {
        "emoji": "🍱",
        "emojiKeyword": "饭,熟食,寿司,刺身,日料,日本料理",
        "emojiLength": 2
      }, {
        "emoji": "🥟",
        "emojiKeyword": "饺子,过年",
        "emojiLength": 2
      }, {
        "emoji": "🍤",
        "emojiKeyword": "海鲜,海产,肉,虾,天妇罗,日料,日本料理",
        "emojiLength": 2
      }, {
        "emoji": "🍙",
        "emojiKeyword": "素,米饭,饭团",
        "emojiLength": 2
      }, {
        "emoji": "🍚",
        "emojiKeyword": "素,米饭,饭",
        "emojiLength": 2
      }, {
        "emoji": "🍘",
        "emojiKeyword": "素,仙贝,米饼,饼,零食",
        "emojiLength": 2
      }, {
        "emoji": "🍥",
        "emojiKeyword": "素,鱼板,鱼排,鱼饼,关东煮",
        "emojiLength": 2
      }, {
        "emoji": "🥠",
        "emojiKeyword": "熟食,饼干,零食,幸运饼干",
        "emojiLength": 2
      }, {
        "emoji": "🥮",
        "emojiKeyword": "饼,馅饼,月饼,中秋",
        "emojiLength": 2
      }, {
        "emoji": "🍢",
        "emojiKeyword": "熟食,关东煮,鱼丸,丸子",
        "emojiLength": 2
      }, {
        "emoji": "🍡",
        "emojiKeyword": "熟食,丸子,甜食",
        "emojiLength": 2
      }, {
        "emoji": "🍧",
        "emojiKeyword": "素,甜食,冰,刨冰,沙冰",
        "emojiLength": 2
      }, {
        "emoji": "🍨",
        "emojiKeyword": "素,甜食,冰淇淋,雪糕,冷饮",
        "emojiLength": 2
      }, {
        "emoji": "🍦",
        "emojiKeyword": "素,甜食,甜筒,雪糕,冷饮,冰淇淋",
        "emojiLength": 2
      }, {
        "emoji": "🥧",
        "emojiKeyword": "面包,蛋糕,派,馅饼,甜食,烘焙",
        "emojiLength": 2
      }, {
        "emoji": "🧁",
        "emojiKeyword": "面包,蛋糕,甜食,杯子,杯子蛋糕",
        "emojiLength": 2
      }, {
        "emoji": "🍰",
        "emojiKeyword": "面包,蛋糕,甜食,下午茶,草莓,草莓蛋糕",
        "emojiLength": 2
      }, {
        "emoji": "🎂",
        "emojiKeyword": "面包,蛋糕,甜食,生日蛋糕,草莓,草莓蛋糕",
        "emojiLength": 2
      }, {
        "emoji": "🍮",
        "emojiKeyword": "素,甜食,布丁,焦糖,焦糖布丁",
        "emojiLength": 2
      }, {
        "emoji": "🍭",
        "emojiKeyword": "素,甜食,棒棒糖,糖",
        "emojiLength": 2
      }, {
        "emoji": "🍬",
        "emojiKeyword": "甜食,糖,糖果",
        "emojiLength": 2
      }, {
        "emoji": "🍫",
        "emojiKeyword": "素,甜食,糖,巧克力",
        "emojiLength": 2
      }, {
        "emoji": "🍿",
        "emojiKeyword": "素,零食,电影,玉米,爆米花",
        "emojiLength": 2
      }, {
        "emoji": "🍩",
        "emojiKeyword": "素,甜食,巧克力,甜甜圈,面包圈,烘焙",
        "emojiLength": 2
      }, {
        "emoji": "🍪",
        "emojiKeyword": "素,甜食,曲奇,饼干,巧克力,巧克力曲奇",
        "emojiLength": 2
      }, {
        "emoji": "🌰",
        "emojiKeyword": "素,栗子,板栗",
        "emojiLength": 2
      }, {
        "emoji": "🥜",
        "emojiKeyword": "素,花生,坚果",
        "emojiLength": 2
      }, {
        "emoji": "🍯",
        "emojiKeyword": "素,甜食,蜂蜜,蜜",
        "emojiLength": 2
      }, {
        "emoji": "🥛",
        "emojiKeyword": "饮品,素,乳制品,牛奶,奶",
        "emojiLength": 2
      }, {
        "emoji": "🍼",
        "emojiKeyword": "奶,宝宝,婴儿,奶瓶,喂奶",
        "emojiLength": 2
      }, {
        "emoji": "☕️",
        "emojiKeyword": "饮品,杯,茶杯,咖啡,下午茶",
        "emojiLength": 2
      }, {
        "emoji": "🍵",
        "emojiKeyword": "饮品,茶,杯,喝茶,饮茶,绿茶,茶杯",
        "emojiLength": 2
      }, {
        "emoji": "🥤",
        "emojiKeyword": "饮品,饮料,可乐,快餐,垃圾食品,吸管",
        "emojiLength": 2
      }, {
        "emoji": "🍶",
        "emojiKeyword": "饮品,酒,日本,清酒,白酒,酒杯,酒壶,烧酒,喝酒,酒",
        "emojiLength": 2
      }, {
        "emoji": "🍺",
        "emojiKeyword": "饮品,杯,啤酒,啤酒杯,干杯,喝酒,酒吧,酒",
        "emojiLength": 2
      }, {
        "emoji": "🍻",
        "emojiKeyword": "饮品,杯,啤酒,啤酒杯,干杯,聚会,喝酒,碰杯,酒吧,酒",
        "emojiLength": 2
      }, {
        "emoji": "🥂",
        "emojiKeyword": "饮品,杯,香槟,高脚杯,碰杯,葡萄酒,酒会,聚会,酒吧,酒",
        "emojiLength": 2
      }, {
        "emoji": "🍷",
        "emojiKeyword": "饮品,杯,红酒,红酒杯,高脚杯,酒吧,酒",
        "emojiLength": 2
      }, {
        "emoji": "🥃",
        "emojiKeyword": "饮品,杯,洋酒,威士忌,烈酒,玻璃杯,酒吧,酒",
        "emojiLength": 2
      }, {
        "emoji": "🍸",
        "emojiKeyword": "饮品,杯,鸡尾酒,莫吉托,调酒,酒吧,酒",
        "emojiLength": 2
      }, {
        "emoji": "🍹",
        "emojiKeyword": "饮品,饮料,杯,果汁,鸡尾酒,酒吧,酒",
        "emojiLength": 2
      }, {
        "emoji": "🍾",
        "emojiKeyword": "饮品,香槟,庆祝,开瓶,酒",
        "emojiLength": 2
      }, {
        "emoji": "🥄",
        "emojiKeyword": "餐具,勺子,勺,汤匙",
        "emojiLength": 2
      }, {
        "emoji": "🍴",
        "emojiKeyword": "餐具,刀叉,刀,叉,叉子,西餐",
        "emojiLength": 2
      }, {
        "emoji": "🍽️",
        "emojiKeyword": "餐具,刀叉,刀,叉,叉子,西餐,盘子",
        "emojiLength": 3
      }, {
        "emoji": "🥣",
        "emojiKeyword": "碗,勺子,勺,汤匙",
        "emojiLength": 2
      }, {
        "emoji": "🥡",
        "emojiKeyword": "纸盒,外卖,包装,快餐",
        "emojiLength": 2
      }, {
        "emoji": "🥢",
        "emojiKeyword": "筷子,夹,中餐",
        "emojiLength": 2
      }, {
        "emoji": "🧂",
        "emojiKeyword": "调味,盐,瓶,调味品",
        "emojiLength": 2
      }]
    }, {
      "categoryName": "运动",
      "emojiCategoryEntities": [{
        "emoji": "⚽️",
        "emojiKeyword": "运动,球,足球",
        "emojiLength": 2
      }, {
        "emoji": "🏀",
        "emojiKeyword": "运动,球,篮球,打篮球",
        "emojiLength": 2
      }, {
        "emoji": "🏈",
        "emojiKeyword": "运动,球,橄榄球,美式,美式足球",
        "emojiLength": 2
      }, {
        "emoji": "⚾️",
        "emojiKeyword": "运动,球,棒球",
        "emojiLength": 2
      }, {
        "emoji": "🥎",
        "emojiKeyword": "运动,球,棒球,垒球",
        "emojiLength": 2
      }, {
        "emoji": "🎾",
        "emojiKeyword": "运动,球,网球",
        "emojiLength": 2
      }, {
        "emoji": "🏐",
        "emojiKeyword": "运动,球,排球",
        "emojiLength": 2
      }, {
        "emoji": "🏉",
        "emojiKeyword": "运动,球,橄榄球,英式,英式橄榄球",
        "emojiLength": 2
      }, {
        "emoji": "🥏",
        "emojiKeyword": "运动,飞盘,盘",
        "emojiLength": 2
      }, {
        "emoji": "🎱",
        "emojiKeyword": "运动,球,台球,斯诺克,桌球",
        "emojiLength": 2
      }, {
        "emoji": "🏓",
        "emojiKeyword": "运动,球,乒乓,乒乓球,球拍,乒乓球拍",
        "emojiLength": 2
      }, {
        "emoji": "🏸",
        "emojiKeyword": "运动,球,羽毛球,球拍,羽毛球拍",
        "emojiLength": 2
      }, {
        "emoji": "🏒",
        "emojiKeyword": "运动,球,球棍,冰球",
        "emojiLength": 2
      }, {
        "emoji": "🏑",
        "emojiKeyword": "运动,球,球棍,曲棍球",
        "emojiLength": 2
      }, {
        "emoji": "🥍",
        "emojiKeyword": "运动,球,球棍,马球,袋棍球,袋棍",
        "emojiLength": 2
      }, {
        "emoji": "🏏",
        "emojiKeyword": "运动,球,球拍,板球",
        "emojiLength": 2
      }, {
        "emoji": "🥅",
        "emojiKeyword": "运动,球,球门,足球,射门",
        "emojiLength": 2
      }, {
        "emoji": "⛳️",
        "emojiKeyword": "运动,球,高尔夫",
        "emojiLength": 2
      }, {
        "emoji": "🏹",
        "emojiKeyword": "运动,射击,箭,射箭,弓,弓箭",
        "emojiLength": 2
      }, {
        "emoji": "🎣",
        "emojiKeyword": "鱼,钓鱼,海钓",
        "emojiLength": 2
      }, {
        "emoji": "🥊",
        "emojiKeyword": "运动,拳,拳击,手套,拳击手套",
        "emojiLength": 2
      }, {
        "emoji": "🥋",
        "emojiKeyword": "运动,武术,跆拳道,制服,柔道,空手道",
        "emojiLength": 2
      }, {
        "emoji": "🎽",
        "emojiKeyword": "运动,跑步,上衣,背心,运动背心,蓝",
        "emojiLength": 2
      }, {
        "emoji": "🛹",
        "emojiKeyword": "运动,滑板,滑",
        "emojiLength": 2
      }, {
        "emoji": "🛷",
        "emojiKeyword": "运动,滑,滑冰,滑雪,雪橇",
        "emojiLength": 2
      }, {
        "emoji": "⛸️",
        "emojiKeyword": "运动,滑,溜冰,鞋,溜冰鞋",
        "emojiLength": 2
      }, {
        "emoji": "🥌",
        "emojiKeyword": "运动,滑,冰壶",
        "emojiLength": 2
      }, {
        "emoji": "🎿",
        "emojiKeyword": "运动,滑雪,雪,双板",
        "emojiLength": 2
      }, {
        "emoji": "⛷️",
        "emojiKeyword": "运动,滑雪,雪,双板",
        "emojiLength": 2
      }, {
        "emoji": "🏂",
        "emojiKeyword": "运动,滑雪,雪,单板",
        "emojiLength": 2
      }, {
        "emoji": "🏋️‍♀️",
        "emojiKeyword": "运动,举,举重,举重女",
        "emojiLength": 6
      }, {
        "emoji": "🏋️",
        "emojiKeyword": "运动,举,举重",
        "emojiLength": 3
      }, {
        "emoji": "🏋️‍♂️",
        "emojiKeyword": "运动,举,举重,举重男",
        "emojiLength": 6
      }, {
        "emoji": "🤼‍♀️",
        "emojiKeyword": "运动,摔跤,摔跤女",
        "emojiLength": 5
      }, {
        "emoji": "🤼",
        "emojiKeyword": "运动,摔跤",
        "emojiLength": 2
      }, {
        "emoji": "🤼‍♂️",
        "emojiKeyword": "运动,摔跤,摔跤男",
        "emojiLength": 5
      }, {
        "emoji": "🤸‍♀️",
        "emojiKeyword": "运动,体操,体操女,倒立",
        "emojiLength": 5
      }, {
        "emoji": "🤸",
        "emojiKeyword": "运动,体操,倒立",
        "emojiLength": 2
      }, {
        "emoji": "🤸‍♂️",
        "emojiKeyword": "运动,体操,倒立,体操男",
        "emojiLength": 5
      }, {
        "emoji": "⛹️‍♀️",
        "emojiKeyword": "运动,篮球,打篮球,篮球女,打篮球女",
        "emojiLength": 5
      }, {
        "emoji": "⛹️",
        "emojiKeyword": "运动,篮球,打篮球",
        "emojiLength": 2
      }, {
        "emoji": "⛹️‍♂️",
        "emojiKeyword": "运动,篮球,打篮球,篮球男,打篮球男",
        "emojiLength": 5
      }, {
        "emoji": "🤺",
        "emojiKeyword": "运动,击剑,剑",
        "emojiLength": 2
      }, {
        "emoji": "🤾‍♀️",
        "emojiKeyword": "运动,手球,女子手球",
        "emojiLength": 5
      }, {
        "emoji": "🤾",
        "emojiKeyword": "运动,手球",
        "emojiLength": 2
      }, {
        "emoji": "🤾‍♂️",
        "emojiKeyword": "运动,手球,男子手球",
        "emojiLength": 5
      }, {
        "emoji": "🏌️‍♀️",
        "emojiKeyword": "运动,高尔夫,高尔夫女",
        "emojiLength": 6
      }, {
        "emoji": "🏌️",
        "emojiKeyword": "运动,高尔夫",
        "emojiLength": 3
      }, {
        "emoji": "🏌️‍♂️",
        "emojiKeyword": "运动,高尔夫,高尔夫男",
        "emojiLength": 6
      }, {
        "emoji": "🏇",
        "emojiKeyword": "运动,马,赛马,骑马,马术",
        "emojiLength": 2
      }, {
        "emoji": "🧘‍♀️",
        "emojiKeyword": "运动,瑜伽,冥想,瑜伽女,冥想女",
        "emojiLength": 5
      }, {
        "emoji": "🧘",
        "emojiKeyword": "运动,瑜伽,冥想",
        "emojiLength": 2
      }, {
        "emoji": "🧘‍♂️",
        "emojiKeyword": "运动,瑜伽,冥想,瑜伽男,冥想男",
        "emojiLength": 5
      }, {
        "emoji": "🏄‍♀️",
        "emojiKeyword": "运动,冲浪,冲浪女",
        "emojiLength": 5
      }, {
        "emoji": "🏄",
        "emojiKeyword": "运动,冲浪",
        "emojiLength": 2
      }, {
        "emoji": "🏄‍♂️",
        "emojiKeyword": "运动,冲浪,冲浪男",
        "emojiLength": 5
      }, {
        "emoji": "🏊‍♀️",
        "emojiKeyword": "运动,游泳,游,游泳女",
        "emojiLength": 5
      }, {
        "emoji": "🏊",
        "emojiKeyword": "运动,游泳,游",
        "emojiLength": 2
      }, {
        "emoji": "🏊‍♂️",
        "emojiKeyword": "运动,游泳,游,游泳男",
        "emojiLength": 5
      }, {
        "emoji": "🤽‍♀️",
        "emojiKeyword": "运动,水球,女子水球,水球女",
        "emojiLength": 5
      }, {
        "emoji": "🤽",
        "emojiKeyword": "运动,水球",
        "emojiLength": 2
      }, {
        "emoji": "🤽‍♂️",
        "emojiKeyword": "运动,水球,男子水球,水球男",
        "emojiLength": 5
      }, {
        "emoji": "🚣‍♀️",
        "emojiKeyword": "运动,船,划船,划艇,赛艇,赛艇女",
        "emojiLength": 5
      }, {
        "emoji": "🚣",
        "emojiKeyword": "运动,船,划船,划艇,赛艇",
        "emojiLength": 2
      }, {
        "emoji": "🚣‍♂️",
        "emojiKeyword": "运动,船,划船,划艇,赛艇,赛艇男",
        "emojiLength": 5
      }, {
        "emoji": "🧗‍♀️",
        "emojiKeyword": "运动,攀岩,攀登,女子攀岩,攀岩女",
        "emojiLength": 5
      }, {
        "emoji": "🧗",
        "emojiKeyword": "运动,攀岩,攀登",
        "emojiLength": 2
      }, {
        "emoji": "🧗‍♂️",
        "emojiKeyword": "运动,攀岩,攀登,男子攀岩,攀岩男",
        "emojiLength": 5
      }, {
        "emoji": "🚵‍♀️",
        "emojiKeyword": "运动,自行车,山地,山地自行车,山地自行车女,骑行,骑",
        "emojiLength": 5
      }, {
        "emoji": "🚵",
        "emojiKeyword": "运动,自行车,山地,山地自行车,骑行,骑",
        "emojiLength": 2
      }, {
        "emoji": "🚵‍♂️",
        "emojiKeyword": "运动,自行车,山地,山地自行车,山地自行车男,骑行,骑",
        "emojiLength": 5
      }, {
        "emoji": "🚴‍♀️",
        "emojiKeyword": "运动,自行车,骑行,骑,自行车女",
        "emojiLength": 5
      }, {
        "emoji": "🚴",
        "emojiKeyword": "运动,自行车,骑行,骑",
        "emojiLength": 2
      }, {
        "emoji": "🚴‍♂️",
        "emojiKeyword": "运动,自行车,骑行,骑,自行车男",
        "emojiLength": 5
      }, {
        "emoji": "🏆",
        "emojiKeyword": "运动,奖杯,冠军,金,金奖,获奖",
        "emojiLength": 2
      }, {
        "emoji": "🥇",
        "emojiKeyword": "运动,获奖,奖牌,金奖,金,金牌,第一,一等,一,一等奖",
        "emojiLength": 2
      }, {
        "emoji": "🥈",
        "emojiKeyword": "运动,获奖,奖牌,银奖,银,银牌,第二,二等,二,二等奖",
        "emojiLength": 2
      }, {
        "emoji": "🥉",
        "emojiKeyword": "运动,获奖,奖牌,铜奖,铜,铜牌,第三,三等,三,三等奖",
        "emojiLength": 2
      }, {
        "emoji": "🏅",
        "emojiKeyword": "运动,获奖,奖牌,勋章,奖章",
        "emojiLength": 2
      }, {
        "emoji": "🎖️",
        "emojiKeyword": "运动,获奖,勋章,奖章,军功",
        "emojiLength": 3
      }, {
        "emoji": "🏵️",
        "emojiKeyword": "花,花饰,黄",
        "emojiLength": 3
      }, {
        "emoji": "🎗️",
        "emojiKeyword": "丝带,丝,黄丝带,黄",
        "emojiLength": 3
      }, {
        "emoji": "🎫",
        "emojiKeyword": "票,券,门票,入场券,票据",
        "emojiLength": 2
      }, {
        "emoji": "🎟️",
        "emojiKeyword": "票,券,门票,入场券,票据,游乐场",
        "emojiLength": 3
      }, {
        "emoji": "🎪",
        "emojiKeyword": "杂技,马戏团,马戏,游乐园,帐篷",
        "emojiLength": 2
      }, {
        "emoji": "🤹‍♀️",
        "emojiKeyword": "杂技,杂耍,颠球,接球,杂技女,杂耍女,马戏团,游乐园",
        "emojiLength": 5
      }, {
        "emoji": "🤹",
        "emojiKeyword": "杂技,杂耍,颠球,接球,马戏团,游乐园",
        "emojiLength": 2
      }, {
        "emoji": "🤹‍♂️",
        "emojiKeyword": "杂技,杂耍,颠球,接球,杂技男,杂耍男,马戏团,游乐园",
        "emojiLength": 5
      }, {
        "emoji": "🎭",
        "emojiKeyword": "剧院,戏剧,表演,艺术,面具",
        "emojiLength": 2
      }, {
        "emoji": "🎨",
        "emojiKeyword": "颜料,画画,画板,调色板,艺术,美术,调色盘,调色",
        "emojiLength": 2
      }, {
        "emoji": "🎬",
        "emojiKeyword": "场记,打板,拍电影,开始,停止,拍摄,电影",
        "emojiLength": 2
      }, {
        "emoji": "🎤",
        "emojiKeyword": "麦克风,唱歌,表演,话筒,发言,演讲,歌手,演唱会,卡拉OK",
        "emojiLength": 2
      }, {
        "emoji": "🎧",
        "emojiKeyword": "耳机,听歌,头戴式,头戴式耳机,听,音乐",
        "emojiLength": 2
      }, {
        "emoji": "🎼",
        "emojiKeyword": "音乐,乐谱,五线谱,音符,谱曲",
        "emojiLength": 2
      }, {
        "emoji": "🎹",
        "emojiKeyword": "音乐,乐器,表演,演奏,弹,钢琴,弹钢琴,电子琴,琴键",
        "emojiLength": 2
      }, {
        "emoji": "🥁",
        "emojiKeyword": "音乐,乐器,表演,演奏,鼓点,打鼓,敲鼓,鼓手,鼓槌,鼓,打击乐器",
        "emojiLength": 2
      }, {
        "emoji": "🎷",
        "emojiKeyword": "音乐,乐器,表演,演奏,吹,萨克斯,萨克斯风,爵士,吹奏,管弦乐器",
        "emojiLength": 2
      }, {
        "emoji": "🎺",
        "emojiKeyword": "音乐,乐器,表演,演奏,吹,小号,长号,喇叭,吹奏,管弦乐器",
        "emojiLength": 2
      }, {
        "emoji": "🎸",
        "emojiKeyword": "音乐,乐器,表演,演奏,吉他,贝斯,电吉他,摇滚,弹奏,乐队,弦,弦乐器",
        "emojiLength": 2
      }, {
        "emoji": "🎻",
        "emojiKeyword": "音乐,乐器,表演,演奏,小提琴,弦,弦乐器",
        "emojiLength": 2
      }, {
        "emoji": "🎲",
        "emojiKeyword": "娱乐,游戏,赌博,骰子,掷骰子,掷,赌博,酒桌游戏",
        "emojiLength": 2
      }, {
        "emoji": "♟️",
        "emojiKeyword": "娱乐,游戏,象棋,国际象棋,益智,国际",
        "emojiLength": 2
      }, {
        "emoji": "🎯",
        "emojiKeyword": "娱乐,游戏,飞镖,靶子,命中,靶心",
        "emojiLength": 2
      }, {
        "emoji": "🎳",
        "emojiKeyword": "娱乐,游戏,球,运动,保龄球",
        "emojiLength": 2
      }, {
        "emoji": "🎮",
        "emojiKeyword": "娱乐,游戏,游戏机,打游戏,手柄",
        "emojiLength": 2
      }, {
        "emoji": "🎰",
        "emojiKeyword": "娱乐,游戏,赌博,老虎机,赌场,中奖",
        "emojiLength": 2
      }, {
        "emoji": "🧩",
        "emojiKeyword": "娱乐,游戏,拼图,玩具,益智游戏,拼",
        "emojiLength": 2
      }]
    }, {
      "categoryName": "交通",
      "emojiCategoryEntities": [{
        "emoji": "🚗",
        "emojiKeyword": "车,交通,运输,交通运输,驾驶,汽车,轿车,机动车,红,通勤,出行",
        "emojiLength": 2
      }, {
        "emoji": "🚕",
        "emojiKeyword": "车,交通,运输,交通运输,驾驶,汽车,出租车,机动车,打车,出租,通勤,出行",
        "emojiLength": 2
      }, {
        "emoji": "🚙",
        "emojiKeyword": "车,交通,运输,交通运输,驾驶,汽车,轿车,机动车,蓝,通勤,出行",
        "emojiLength": 2
      }, {
        "emoji": "🚌",
        "emojiKeyword": "车,交通,运输,交通运输,驾驶,汽车,大巴,公交,公共汽车,机动车,通勤,公共,出行",
        "emojiLength": 2
      }, {
        "emoji": "🚎",
        "emojiKeyword": "车,交通,运输,交通运输,驾驶,汽车,大巴,公交,公共汽车,电车,无轨,无轨电车,机动车,通勤,公共,出行",
        "emojiLength": 2
      }, {
        "emoji": "🏎️",
        "emojiKeyword": "车,交通,运输,交通运输,驾驶,赛车,跑车,汽车,竞速,赛车手",
        "emojiLength": 3
      }, {
        "emoji": "🚓",
        "emojiKeyword": "车,交通,运输,交通运输,汽车,警车,报警,警察,巡逻",
        "emojiLength": 2
      }, {
        "emoji": "🚑",
        "emojiKeyword": "车,交通,运输,交通运输,医院,救护车,抢救,救援,急救",
        "emojiLength": 2
      }, {
        "emoji": "🚒",
        "emojiKeyword": "车,交通,运输,交通运输,消防,消防车,灭火,救援,火警,消防员,火灾,着火",
        "emojiLength": 2
      }, {
        "emoji": "🚐",
        "emojiKeyword": "车,交通,运输,交通运输,小巴,公共,面包车,出行,通勤",
        "emojiLength": 2
      }, {
        "emoji": "🚚",
        "emojiKeyword": "车,交通,运输,交通运输,货车,卡车,厢式货车,运货",
        "emojiLength": 2
      }, {
        "emoji": "🚛",
        "emojiKeyword": "车,交通,运输,交通运输,货车,卡车,厢式货车,运货,拖车",
        "emojiLength": 2
      }, {
        "emoji": "🚜",
        "emojiKeyword": "车,交通,运输,交通运输,拖拉机,工业",
        "emojiLength": 2
      }, {
        "emoji": "🛴",
        "emojiKeyword": "车,滑板,滑板车,玩具,娱乐,出行",
        "emojiLength": 2
      }, {
        "emoji": "🚲",
        "emojiKeyword": "车,交通,运输,交通运输,自行车,骑行,骑车,通勤,山地车,车",
        "emojiLength": 2
      }, {
        "emoji": "🛵",
        "emojiKeyword": "车,交通,运输,交通运输,摩托车,机动车,摩托,踏板",
        "emojiLength": 2
      }, {
        "emoji": "🏍️",
        "emojiKeyword": "车,交通,运输,交通运输,摩托车,机动车,摩托,",
        "emojiLength": 3
      }, {
        "emoji": "🚨",
        "emojiKeyword": "报警,警报,灯,警车灯,警示,警察,警灯",
        "emojiLength": 2
      }, {
        "emoji": "🚔",
        "emojiKeyword": "车,交通,运输,交通运输,汽车,警车,报警,警察,巡逻",
        "emojiLength": 2
      }, {
        "emoji": "🚍",
        "emojiKeyword": "车,交通,运输,交通运输,货车,卡车,厢式货车,运货,汽车,大巴,公交,公共汽车,机动车,通勤,公共,出行",
        "emojiLength": 2
      }, {
        "emoji": "🚘",
        "emojiKeyword": "车,交通,运输,交通运输,汽车,轿车,机动车,红,通勤,出行",
        "emojiLength": 2
      }, {
        "emoji": "🚖",
        "emojiKeyword": "车,交通,运输,交通运输,出租车,机动车,打车,出租,通勤,出行",
        "emojiLength": 2
      }, {
        "emoji": "🚡",
        "emojiKeyword": "交通,运输,交通运输,缆车,空中,索道,观光,旅游",
        "emojiLength": 2
      }, {
        "emoji": "🚠",
        "emojiKeyword": "交通,运输,交通运输,缆车,空中,索道,观光,旅游",
        "emojiLength": 2
      }, {
        "emoji": "🚟",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,空轨,列车,轨道,通勤",
        "emojiLength": 2
      }, {
        "emoji": "🚃",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,汽车,大巴,公交,公共汽车,电车,轨道,有轨,有轨电车,机动车,通勤",
        "emojiLength": 2
      }, {
        "emoji": "🚋",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,电车,轨道,有轨,有轨电车,机动车,通勤",
        "emojiLength": 2
      }, {
        "emoji": "🚞",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,火车,铁路,山路,山区",
        "emojiLength": 2
      }, {
        "emoji": "🚝",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,动车,火车,高铁,新干线,高速,列车,铁路",
        "emojiLength": 2
      }, {
        "emoji": "🚄",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,动车,火车,高铁,新干线,高速,列车,铁路,地铁",
        "emojiLength": 2
      }, {
        "emoji": "🚅",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,动车,火车,高铁,新干线,高速,列车,子弹头,铁路",
        "emojiLength": 2
      }, {
        "emoji": "🚈",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,动车,火车,高铁,新干线,高速,列车,子弹头,铁路,轻轨,地铁",
        "emojiLength": 2
      }, {
        "emoji": "🚂",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,火车,复古,蒸汽,列车,铁路,蒸汽火车",
        "emojiLength": 2
      }, {
        "emoji": "🚆",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,动车,火车,高铁,新干线,高速,列车,铁路",
        "emojiLength": 2
      }, {
        "emoji": "🚇",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,动车,火车,高铁,新干线,高速,列车,子弹头,铁路,轻轨,地铁,隧道",
        "emojiLength": 2
      }, {
        "emoji": "🚊",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,动车,火车,高铁,新干线,高速,列车,子弹头,铁路,轻轨,地铁",
        "emojiLength": 2
      }, {
        "emoji": "🚉",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,动车,火车,高铁,新干线,高速,列车,子弹头,铁路,轻轨,地铁,到站,站牌,停车",
        "emojiLength": 2
      }, {
        "emoji": "✈️",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,航空,航班,飞行,飞机,航线,飞",
        "emojiLength": 2
      }, {
        "emoji": "🛫",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,航空,航班,飞行,飞机,航线,飞,起飞,出发",
        "emojiLength": 2
      }, {
        "emoji": "🛬",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,航空,航班,飞行,飞机,航线,飞,降落,到达",
        "emojiLength": 2
      }, {
        "emoji": "🛩️",
        "emojiKeyword": "交通,运输,交通运输,通勤,公共,出行,航空,航班,飞行,飞机,航线,飞,客机",
        "emojiLength": 3
      }, {
        "emoji": "💺",
        "emojiKeyword": "交通,运输,交通运输,座椅,座位,车座,飞机,飞机座椅",
        "emojiLength": 2
      }, {
        "emoji": "🛰️",
        "emojiKeyword": "太空,卫星,航天,宇宙",
        "emojiLength": 3
      }, {
        "emoji": "🚀",
        "emojiKeyword": "交通,运输,交通运输,太空,火箭,航天,宇宙,发射,飞船",
        "emojiLength": 2
      }, {
        "emoji": "🛸",
        "emojiKeyword": "太空,外星,航天,宇宙,外星人,飞船,宇宙飞船,飞碟",
        "emojiLength": 2
      }, {
        "emoji": "🚁",
        "emojiKeyword": "交通,运输,交通运输,航空,飞机,飞,直升飞机,直升机",
        "emojiLength": 2
      }, {
        "emoji": "🛶",
        "emojiKeyword": "交通,运输,交通运输,船,划船,艇,赛艇,舟,独木舟,水上交通",
        "emojiLength": 2
      }, {
        "emoji": "⛵️",
        "emojiKeyword": "交通,运输,交通运输,海,航行,远航,帆船,水上交通",
        "emojiLength": 2
      }, {
        "emoji": "🚤",
        "emojiKeyword": "交通,运输,交通运输,海,航海,艇,快艇,游艇,度假,水上交通",
        "emojiLength": 2
      }, {
        "emoji": "🛥️",
        "emojiKeyword": "交通,运输,交通运输,海,航海,艇,快艇,游艇,度假,豪华快艇,摩托艇,水上交通",
        "emojiLength": 3
      }, {
        "emoji": "🛳️",
        "emojiKeyword": "交通,运输,交通运输,船,轮船,客轮,客船,水上交通",
        "emojiLength": 3
      }, {
        "emoji": "⛴️",
        "emojiKeyword": "交通,运输,交通运输,船,轮船,客轮,客船,水上交通,渡轮",
        "emojiLength": 2
      }, {
        "emoji": "🚢",
        "emojiKeyword": "交通,运输,交通运输,船,轮船,客轮,客船,水上交通,渡轮,邮轮,豪华邮轮",
        "emojiLength": 2
      }, {
        "emoji": "⚓️",
        "emojiKeyword": "船,锚,锚点,停泊,停船",
        "emojiLength": 2
      }, {
        "emoji": "⛽️",
        "emojiKeyword": "汽油,加油,加油站,汽车,柴油,燃油,油",
        "emojiLength": 2
      }, {
        "emoji": "🚧",
        "emojiKeyword": "路,交通,封闭,路障,施工,注意,工地",
        "emojiLength": 2
      }, {
        "emoji": "🚦",
        "emojiKeyword": "交通,灯,信号,信号灯,红绿灯,马路,通行,等待,交通灯",
        "emojiLength": 2
      }, {
        "emoji": "🚥",
        "emojiKeyword": "交通,灯,信号,信号灯,红绿灯,马路,通行,等待,交通灯",
        "emojiLength": 2
      }, {
        "emoji": "🚏",
        "emojiKeyword": "交通,路牌,指示牌,站台,站点,车站,公交车站,等车",
        "emojiLength": 2
      }, {
        "emoji": "🗺️",
        "emojiKeyword": "地图,旅游,游览,世界,地理,旅行",
        "emojiLength": 3
      }, {
        "emoji": "🗿",
        "emojiKeyword": "巨石像,旅游,摩艾,摩艾石像,复活岛,复活节岛,石像,景点",
        "emojiLength": 2
      }, {
        "emoji": "🗽",
        "emojiKeyword": "旅游,景点,雕像,美国,自由,自由女神,女神,自由女神像,建筑",
        "emojiLength": 2
      }, {
        "emoji": "🗼",
        "emojiKeyword": "旅游,景点,塔,巴黎,法国,埃菲尔,铁塔,埃菲尔铁塔,日本,东京,东京塔,建筑",
        "emojiLength": 2
      }, {
        "emoji": "🏰",
        "emojiKeyword": "旅游,景点,欧洲,城堡,堡垒,城楼,建筑",
        "emojiLength": 2
      }, {
        "emoji": "🏯",
        "emojiKeyword": "旅游,景点,城堡,城楼,古代,古建筑,日本,城邦,建筑",
        "emojiLength": 2
      }, {
        "emoji": "🏟️",
        "emojiKeyword": "体育馆,竞技场,足球,足球场,足球比赛,露天,竞技,建筑",
        "emojiLength": 3
      }, {
        "emoji": "🎡",
        "emojiKeyword": "旅游,景点,游乐场,摩天轮,游乐园,游乐",
        "emojiLength": 2
      }, {
        "emoji": "🎢",
        "emojiKeyword": "旅游,景点,游乐场,过山车,游乐园,游乐",
        "emojiLength": 2
      }, {
        "emoji": "🎠",
        "emojiKeyword": "旅游,景点,游乐场,木马,旋转木马,游乐园,游乐",
        "emojiLength": 2
      }, {
        "emoji": "⛲️",
        "emojiKeyword": "旅游,景点,喷泉,公园,广场,喷水",
        "emojiLength": 2
      }, {
        "emoji": "⛱️",
        "emojiKeyword": "旅游,伞,遮阳,沙滩,海边,度假,夏,夏天",
        "emojiLength": 2
      }, {
        "emoji": "🏖️",
        "emojiKeyword": "旅游,伞,遮阳,沙滩,海边,度假,夏,夏天",
        "emojiLength": 3
      }, {
        "emoji": "🏝️",
        "emojiKeyword": "旅游,沙滩,海边,度假,夏,夏天,椰树,椰",
        "emojiLength": 3
      }, {
        "emoji": "🏜️",
        "emojiKeyword": "旅游,沙漠,荒漠,炎热,干燥,西部,日落",
        "emojiLength": 3
      }, {
        "emoji": "🌋",
        "emojiKeyword": "旅游,火山,喷发,爆发,火,岩浆,活火山",
        "emojiLength": 2
      }, {
        "emoji": "⛰️",
        "emojiKeyword": "旅游,山,山峰,爬山,山丘,攀登,高山",
        "emojiLength": 2
      }, {
        "emoji": "🏔️",
        "emojiKeyword": "旅游,山,山峰,爬山,山丘,攀登,高山,雪山,寒冷",
        "emojiLength": 3
      }, {
        "emoji": "🗻",
        "emojiKeyword": "旅游,景点,山,山峰,爬山,高山,富士,富士山,日本,雪山",
        "emojiLength": 2
      }, {
        "emoji": "🏕️",
        "emojiKeyword": "帐篷,野营,野炊,露营,森林,野外",
        "emojiLength": 3
      }, {
        "emoji": "⛺️",
        "emojiKeyword": "帐篷,野营,野炊,露营",
        "emojiLength": 2
      }, {
        "emoji": "🏠",
        "emojiKeyword": "住所,住宅,房子,房屋,建筑,小屋",
        "emojiLength": 2
      }, {
        "emoji": "🏡",
        "emojiKeyword": "住所,住宅,房子,房屋,建筑,小屋,树屋",
        "emojiLength": 2
      }, {
        "emoji": "🏘️",
        "emojiKeyword": "住所,住宅,房子,房屋,建筑,小屋,街道,街区,邻居,小路",
        "emojiLength": 3
      }, {
        "emoji": "🏚️",
        "emojiKeyword": "住所,住宅,房子,房屋,建筑,小屋,破败,破,废弃,废墟,荒废,鬼屋",
        "emojiLength": 3
      }, {
        "emoji": "🏗️",
        "emojiKeyword": "施工,起重机,搬砖,搬运,工地,工程,建造",
        "emojiLength": 3
      }, {
        "emoji": "🏭",
        "emojiKeyword": "建筑,房屋,工厂,工业,制造",
        "emojiLength": 2
      }, {
        "emoji": "🏢",
        "emojiKeyword": "建筑,大楼,楼,大厦,办公楼,写字楼,上班",
        "emojiLength": 2
      }, {
        "emoji": "🏬",
        "emojiKeyword": "建筑,大楼,楼,大厦,商场,商超,购物,写字楼,办公楼,百货大楼",
        "emojiLength": 2
      }, {
        "emoji": "🏣",
        "emojiKeyword": "建筑,日本,邮政,邮局,日本邮局",
        "emojiLength": 2
      }, {
        "emoji": "🏤",
        "emojiKeyword": "建筑,欧洲,邮政,邮局,欧洲邮局",
        "emojiLength": 2
      }, {
        "emoji": "🏥",
        "emojiKeyword": "建筑,医院,医生,看病,住院,医疗,生病",
        "emojiLength": 2
      }, {
        "emoji": "🏦",
        "emojiKeyword": "建筑,银行,存钱,取钱,金融,财政,钱",
        "emojiLength": 2
      }, {
        "emoji": "🏨",
        "emojiKeyword": "建筑,旅馆,宾馆,住宿,酒店,旅游,假日",
        "emojiLength": 2
      }, {
        "emoji": "🏪",
        "emojiKeyword": "建筑,商店,超市,商超,便利店",
        "emojiLength": 2
      }, {
        "emoji": "🏫",
        "emojiKeyword": "建筑,学校,教学楼,毕业,大学,高中,小学,初中,上学",
        "emojiLength": 2
      }, {
        "emoji": "🏩",
        "emojiKeyword": "建筑,旅馆,宾馆,住宿,酒店,旅游,假日,情人旅馆,情侣,情侣酒店",
        "emojiLength": 2
      }, {
        "emoji": "💒",
        "emojiKeyword": "建筑,教堂,浪漫,结婚,婚礼",
        "emojiLength": 2
      }, {
        "emoji": "🏛️",
        "emojiKeyword": "旅游,景点,建筑,古典,古建筑,罗马,历史",
        "emojiLength": 3
      }, {
        "emoji": "⛪️",
        "emojiKeyword": "建筑,教堂,天主教,基督教,礼拜,祈祷,忏悔,宗教",
        "emojiLength": 2
      }, {
        "emoji": "🕌",
        "emojiKeyword": "建筑,宗教,伊斯兰,穆斯林,清真寺,清真",
        "emojiLength": 2
      }, {
        "emoji": "🕍",
        "emojiKeyword": "建筑,教堂,犹太教堂,会堂,宗教,犹太",
        "emojiLength": 2
      }, {
        "emoji": "🕋",
        "emojiKeyword": "建筑,旅游,景点,伊斯兰,天房,宗教,穆斯林,克尔白",
        "emojiLength": 2
      }, {
        "emoji": "⛩️",
        "emojiKeyword": "建筑,旅游,景点,宗教,日本,神道教,神社",
        "emojiLength": 2
      }, {
        "emoji": "🛤️",
        "emojiKeyword": "铁路,轨道,铁轨,火车,道路,路,交通,旅行",
        "emojiLength": 3
      }, {
        "emoji": "🛣️",
        "emojiKeyword": "公路,道路,马路,行驶,交通,旅行,高速,高速公路",
        "emojiLength": 3
      }, {
        "emoji": "🗾",
        "emojiKeyword": "图片,图,地图,日本,日本地图,岛国",
        "emojiLength": 2
      }, {
        "emoji": "🎑",
        "emojiKeyword": "图片,图,中秋,庆祝,月亮,节日,中秋节,赏月",
        "emojiLength": 2
      }, {
        "emoji": "🏞️",
        "emojiKeyword": "图片,图,公园,自然,风景,野营,生态",
        "emojiLength": 3
      }, {
        "emoji": "🌅",
        "emojiKeyword": "图片,图,太阳,海面,日出,清晨,早晨,海上日出",
        "emojiLength": 2
      }, {
        "emoji": "🌄",
        "emojiKeyword": "图片,图,太阳,日出,清晨,山,山顶日出",
        "emojiLength": 2
      }, {
        "emoji": "🌠",
        "emojiKeyword": "图片,图,星,流星,许愿",
        "emojiLength": 2
      }, {
        "emoji": "🎇",
        "emojiKeyword": "图片,图,烟花,庆祝,火花,焰火,仙女棒",
        "emojiLength": 2
      }, {
        "emoji": "🎆",
        "emojiKeyword": "图片,图,烟花,庆祝,火花,焰火",
        "emojiLength": 2
      }, {
        "emoji": "🌇",
        "emojiKeyword": "图片,图,傍晚,日落,都市,黄昏,城市",
        "emojiLength": 2
      }, {
        "emoji": "🌆",
        "emojiKeyword": "图片,图,夜晚,日落,都市,黄昏,城市",
        "emojiLength": 2
      }, {
        "emoji": "🏙️",
        "emojiKeyword": "图片,图,城市,都市,都市景观,高楼大厦,大厦",
        "emojiLength": 3
      }, {
        "emoji": "🌃",
        "emojiKeyword": "图片,图,城市,都市,都市景观,高楼大厦,大厦,夜晚,晚上",
        "emojiLength": 2
      }, {
        "emoji": "🌌",
        "emojiKeyword": "图片,图,天空,夜晚,星空,星星,宇宙,银河,星河,晚上",
        "emojiLength": 2
      }, {
        "emoji": "🌉",
        "emojiKeyword": "图片,图,桥,大桥,夜晚,晚上",
        "emojiLength": 2
      }, {
        "emoji": "🌁",
        "emojiKeyword": "图片,图,桥,大桥,雾,起雾,雾霾,霾",
        "emojiLength": 2
      }]
    }, {
      "categoryName": "物品",
      "emojiCategoryEntities": [{
        "emoji": "⌚️",
        "emojiKeyword": "首饰,手表,时间,表,腕表",
        "emojiLength": 2
      }, {
        "emoji": "📱",
        "emojiKeyword": "电子产品,手机,智能,智能手机,电话,通讯",
        "emojiLength": 2
      }, {
        "emoji": "📲",
        "emojiKeyword": "电子产品,手机,接收,智能手机,来电,电话,打电话,通讯",
        "emojiLength": 2
      }, {
        "emoji": "💻",
        "emojiKeyword": "电子产品,电脑,笔记本,笔记本电脑",
        "emojiLength": 2
      }, {
        "emoji": "⌨️",
        "emojiKeyword": "电子产品,键盘,电脑,打字",
        "emojiLength": 2
      }, {
        "emoji": "🖥️",
        "emojiKeyword": "电子产品,电脑,台式电脑",
        "emojiLength": 3
      }, {
        "emoji": "🖨️",
        "emojiKeyword": "电子产品,打印,打印机",
        "emojiLength": 3
      }, {
        "emoji": "🖱️",
        "emojiKeyword": "电子产品,鼠标,电脑",
        "emojiLength": 3
      }, {
        "emoji": "🖲️",
        "emojiKeyword": "电子产品,有线鼠标,电脑,追踪球,鼠标,轨迹球",
        "emojiLength": 3
      }, {
        "emoji": "🕹️",
        "emojiKeyword": "电子产品,操控杆,电子游戏,游戏,电子",
        "emojiLength": 3
      }, {
        "emoji": "🗜️",
        "emojiKeyword": "夹具,工具,紧固,配件,夹",
        "emojiLength": 3
      }, {
        "emoji": "💽",
        "emojiKeyword": "电子产品,光盘,电脑光盘,光碟",
        "emojiLength": 2
      }, {
        "emoji": "💾",
        "emojiKeyword": "电子产品,软盘,磁盘,存储,保存",
        "emojiLength": 2
      }, {
        "emoji": "💿",
        "emojiKeyword": "电子产品,光盘,电脑光盘,光碟,专辑,存储,影片,音乐,打碟",
        "emojiLength": 2
      }, {
        "emoji": "📀",
        "emojiKeyword": "电子产品,光盘,电脑光盘,光碟,专辑,存储,影片,音乐,打碟",
        "emojiLength": 2
      }, {
        "emoji": "📼",
        "emojiKeyword": "电子产品,磁带,录音,留声,卡带,录像带,记录",
        "emojiLength": 2
      }, {
        "emoji": "📷",
        "emojiKeyword": "电子产品,相机,照相机,拍照,摄影,摄像,照相,照片",
        "emojiLength": 2
      }, {
        "emoji": "📸",
        "emojiKeyword": "电子产品,相机,照相机,拍照,摄影,摄像,照相,照片,闪光灯,闪光",
        "emojiLength": 2
      }, {
        "emoji": "📹",
        "emojiKeyword": "电子产品,录像,录影,拍摄,摄影机,视频,录像机,记录",
        "emojiLength": 2
      }, {
        "emoji": "🎥",
        "emojiKeyword": "电子产品,摄像机,摄录机,摄影,摄影机,电影,拍电影,摄影师,导演",
        "emojiLength": 2
      }, {
        "emoji": "📽️",
        "emojiKeyword": "电子产品,影片,投影仪,放映机,电影,视频,上映,放映",
        "emojiLength": 3
      }, {
        "emoji": "🎞️",
        "emojiKeyword": "帧,电影,电影胶片,胶卷,胶片,放映,交卷,底片",
        "emojiLength": 3
      }, {
        "emoji": "📞",
        "emojiKeyword": "电子产品,电话,听筒,话筒,打电话,接听,固话,通讯",
        "emojiLength": 2
      }, {
        "emoji": "☎️",
        "emojiKeyword": "电子产品,座机,电话,固话,固定电话,通讯",
        "emojiLength": 2
      }, {
        "emoji": "📟",
        "emojiKeyword": "电子产品,BB机,传呼机,呼机,通讯",
        "emojiLength": 2
      }, {
        "emoji": "📠",
        "emojiKeyword": "电子产品,传真,传真机,办公,发传真",
        "emojiLength": 2
      }, {
        "emoji": "📺",
        "emojiKeyword": "电子产品,电视,电视机,看电视,视频,节目",
        "emojiLength": 2
      }, {
        "emoji": "📻",
        "emojiKeyword": "电子产品,广播,广播电台,无线电,电台,录音机,收音机",
        "emojiLength": 2
      }, {
        "emoji": "🎙️",
        "emojiKeyword": "电子产品,录音室,音乐,麦,麦克,麦克风,录歌,配音",
        "emojiLength": 3
      }, {
        "emoji": "🎚️",
        "emojiKeyword": "滑块,电平,调节,音乐,控制",
        "emojiLength": 3
      }, {
        "emoji": "🎛️",
        "emojiKeyword": "控制,旋钮,调节,音乐,按钮,音响",
        "emojiLength": 3
      }, {
        "emoji": "🧭",
        "emojiKeyword": "工具,指针,指南针,定向,导航,磁性",
        "emojiLength": 2
      }, {
        "emoji": "⏱️",
        "emojiKeyword": "工具,秒表,时间,计时,码表,计时器",
        "emojiLength": 2
      }, {
        "emoji": "⏲️",
        "emojiKeyword": "工具,时间,定时,定时器",
        "emojiLength": 2
      }, {
        "emoji": "⏰",
        "emojiKeyword": "工具,时间,闹钟,闹铃,表",
        "emojiLength": 1
      }, {
        "emoji": "🕰️",
        "emojiKeyword": "工具,时间,表,钟,钟表,座钟",
        "emojiLength": 3
      }, {
        "emoji": "⌛️",
        "emojiKeyword": "工具,时间,沙漏,计时,倒计时",
        "emojiLength": 2
      }, {
        "emoji": "⏳",
        "emojiKeyword": "工具,时间,沙漏,计时,倒计时",
        "emojiLength": 1
      }, {
        "emoji": "📡",
        "emojiKeyword": "信号,信号接收,卫星,天线,卫星接收天线,天线,通讯",
        "emojiLength": 2
      }, {
        "emoji": "🔋",
        "emojiKeyword": "电池,电量,充足,充电,满,能源",
        "emojiLength": 2
      }, {
        "emoji": "🔌",
        "emojiKeyword": "电,插头,充电,接电,插销",
        "emojiLength": 2
      }, {
        "emoji": "💡",
        "emojiKeyword": "电,亮,灯泡,电灯泡,发明,想法,点子,照明",
        "emojiLength": 2
      }, {
        "emoji": "🔦",
        "emojiKeyword": "电,亮,手电筒,工具,手电,亮,照光,照亮,照明",
        "emojiLength": 2
      }, {
        "emoji": "🕯️",
        "emojiKeyword": "火,蜡烛,祈祷,祈福,祝愿,哀悼,烛光,烛火,照明,照亮",
        "emojiLength": 3
      }, {
        "emoji": "🧯",
        "emojiKeyword": "工具,消防,灭火,防火,灭火器,火灾",
        "emojiLength": 2
      }, {
        "emoji": "🛢️",
        "emojiKeyword": "油,石油,原油,油桶,桶,能源",
        "emojiLength": 3
      }, {
        "emoji": "💸",
        "emojiKeyword": "钱,翅膀,美元,金钱,钞票,纸钞,纸币,现金,货币",
        "emojiLength": 2
      }, {
        "emoji": "💵",
        "emojiKeyword": "钱,美元,金钱,钞票,纸钞,纸币,现金,货币",
        "emojiLength": 2
      }, {
        "emoji": "💴",
        "emojiKeyword": "钱,人民币,金钱,钞票,纸钞,纸币,元,现金,货币",
        "emojiLength": 2
      }, {
        "emoji": "💶",
        "emojiKeyword": "钱,欧元,金钱,钞票,纸钞,纸币,现金,货币",
        "emojiLength": 2
      }, {
        "emoji": "💷",
        "emojiKeyword": "钱,欧元,金钱,钞票,纸钞,纸币,现金,货币",
        "emojiLength": 2
      }, {
        "emoji": "💰",
        "emojiKeyword": "钱,美元,袋子,钱袋",
        "emojiLength": 2
      }, {
        "emoji": "💳",
        "emojiKeyword": "银行,支付,信用卡,借记卡,刷卡,卡,贷记卡,银行卡,购物",
        "emojiLength": 2
      }, {
        "emoji": "💎",
        "emojiKeyword": "钻石,宝石,价值,昂贵,首饰,饰品",
        "emojiLength": 2
      }, {
        "emoji": "⚖️",
        "emojiKeyword": "秤,公平,公正,正义,法律,秤,平衡,天平,天秤座",
        "emojiLength": 2
      }, {
        "emoji": "🧰",
        "emojiKeyword": "工具,机修,箱子,维修,修理,工具箱",
        "emojiLength": 2
      }, {
        "emoji": "🔧",
        "emojiKeyword": "工具,维修,修理,扳手,扳子",
        "emojiLength": 2
      }, {
        "emoji": "🔨",
        "emojiKeyword": "工具,维修,修理,锤,锤子,铁锤,砸,敲",
        "emojiLength": 2
      }, {
        "emoji": "⚒️",
        "emojiKeyword": "工具,维修,修理,铁锤,铁镐,锤子,镐子,交叉",
        "emojiLength": 2
      }, {
        "emoji": "🛠️",
        "emojiKeyword": "工具,维修,修理,扳手,扳子,锤,锤子,铁锤,交叉",
        "emojiLength": 3
      }, {
        "emoji": "⛏️",
        "emojiKeyword": "工具,维修,修理,挖掘,采矿,锄头,开采,矿工",
        "emojiLength": 2
      }, {
        "emoji": "🔩",
        "emojiKeyword": "工具,维修,修理,螺丝,螺帽,螺栓,螺母,配件,维修,金属",
        "emojiLength": 2
      }, {
        "emoji": "⚙️",
        "emojiKeyword": "工具,维修,修理,传动,机械,零件,维修,齿轮,金属",
        "emojiLength": 2
      }, {
        "emoji": "🧱",
        "emojiKeyword": "砖,砖块,墙,工地,施工,砌墙",
        "emojiLength": 2
      }, {
        "emoji": "⛓️",
        "emojiKeyword": "金属,铁,链条,铁链,链子,锁链,拴",
        "emojiLength": 2
      }, {
        "emoji": "🧲",
        "emojiKeyword": "磁铁,吸铁石,磁力,吸引,马蹄铁,引力",
        "emojiLength": 2
      }, {
        "emoji": "🔫",
        "emojiKeyword": "玩具,水枪,枪,水,游戏",
        "emojiLength": 2
      }, {
        "emoji": "💣",
        "emojiKeyword": "工具,地雷,炸弹,火药,爆炸",
        "emojiLength": 2
      }, {
        "emoji": "🧨",
        "emojiKeyword": "炸药,烟花,爆炸,喜庆,除夕,过年,炮仗,鞭炮,爆竹,庆祝",
        "emojiLength": 2
      }, {
        "emoji": "🔪",
        "emojiKeyword": "工具,刀,水果刀,菜刀,切,砍,剁",
        "emojiLength": 2
      }, {
        "emoji": "🗡️",
        "emojiKeyword": "工具,刀,匕首,小刀,短剑,武器",
        "emojiLength": 3
      }, {
        "emoji": "⚔️",
        "emojiKeyword": "工具,交叉,剑,双剑,纹章,武器",
        "emojiLength": 2
      }, {
        "emoji": "🛡️",
        "emojiKeyword": "武器,护具,防卫,盾,保护,抵挡,盾牌",
        "emojiLength": 3
      }, {
        "emoji": "🚬",
        "emojiKeyword": "烟,吸烟,烟草,烟雾",
        "emojiLength": 2
      }, {
        "emoji": "⚰️",
        "emojiKeyword": "棺材,下葬,棺木,去世,死亡,死",
        "emojiLength": 2
      }, {
        "emoji": "⚱️",
        "emojiKeyword": "瓮,缸,葬礼,花瓶,古董,骨灰,坛,骨灰盒,骨灰坛,死,死亡",
        "emojiLength": 2
      }, {
        "emoji": "🏺",
        "emojiKeyword": "壶,罐,瓶,双耳瓶,水瓶,古董,花瓶,水瓶座",
        "emojiLength": 2
      }, {
        "emoji": "🔮",
        "emojiKeyword": "命运,工具,水晶,球,巫师,魔法,巫婆,水晶球",
        "emojiLength": 2
      }, {
        "emoji": "📿",
        "emojiKeyword": "宗教,珠子,祈祷,项链,手串,手链",
        "emojiLength": 2
      }, {
        "emoji": "🧿",
        "emojiKeyword": "土耳其,装饰品,恶魔之眼,护身符,珠子,眼睛",
        "emojiLength": 2
      }, {
        "emoji": "💈",
        "emojiKeyword": "旋转,柱,理发,灯柱,头发,发廊,理发店",
        "emojiLength": 2
      }, {
        "emoji": "⚗️",
        "emojiKeyword": "实验,蒸馏,蒸馏瓶,蒸馏器,实验,净化,化学",
        "emojiLength": 2
      }, {
        "emoji": "🔭",
        "emojiKeyword": "天体,天文,天文学,工具,观星,观测,望远镜",
        "emojiLength": 2
      }, {
        "emoji": "🔬",
        "emojiKeyword": "工具,实验,生物,显微镜,镜,科学,微生物",
        "emojiLength": 2
      }, {
        "emoji": "🕳️",
        "emojiKeyword": "洞,坑,陷阱,下水道",
        "emojiLength": 3
      }, {
        "emoji": "💊",
        "emojiKeyword": "药,药丸,医药,生病,治疗,吃药",
        "emojiLength": 2
      }, {
        "emoji": "💉",
        "emojiKeyword": "医生,医疗,治疗,注射,针,针管,打针",
        "emojiLength": 2
      }, {
        "emoji": "🧬",
        "emojiKeyword": "基因,遗传,生物,DNA,生命",
        "emojiLength": 2
      }, {
        "emoji": "🦠",
        "emojiKeyword": "病毒,细菌,微生物,感染,细胞,生物,生化,新冠,疫情",
        "emojiLength": 2
      }, {
        "emoji": "🧫",
        "emojiKeyword": "生物,实验,器皿,培养皿,细菌,培养,器皿,生物学,实验室,器材",
        "emojiLength": 2
      }, {
        "emoji": "🧪",
        "emojiKeyword": "实验室,器皿,实验,滴管,化学,生物,器材",
        "emojiLength": 2
      }, {
        "emoji": "🌡️",
        "emojiKeyword": "测量,工具,温度,温度计,体温计,实验,器材",
        "emojiLength": 3
      }, {
        "emoji": "🧹",
        "emojiKeyword": "工具,打扫,清洁,扫把,笤帚,扫地",
        "emojiLength": 2
      }, {
        "emoji": "🧺",
        "emojiKeyword": "筐,筐子,篮,篮子,衣物,脏,脏衣服,洗衣服,清洗,洗涤",
        "emojiLength": 2
      }, {
        "emoji": "🧻",
        "emojiKeyword": "卷纸,纸,厕纸,手纸,卫生纸,厕所,上厕所,擦,清洁",
        "emojiLength": 2
      }, {
        "emoji": "🚽",
        "emojiKeyword": "厕所,马桶,卫生间,上厕所",
        "emojiLength": 2
      }, {
        "emoji": "🚰",
        "emojiKeyword": "水,喝水,自来水,水龙头,水阀",
        "emojiLength": 2
      }, {
        "emoji": "🚿",
        "emojiKeyword": "水,花洒,浴室,洗澡,冲澡,淋浴,沐浴,清洁",
        "emojiLength": 2
      }, {
        "emoji": "🛁",
        "emojiKeyword": "水,浴室,洗澡,浴缸,泡澡,沐浴,泡泡",
        "emojiLength": 2
      }, {
        "emoji": "🛀",
        "emojiKeyword": "水,浴室,洗澡,浴缸,泡澡,沐浴",
        "emojiLength": 2
      }, {
        "emoji": "🧼",
        "emojiKeyword": "肥皂,皂,香皂,皂角,泡泡,清洁",
        "emojiLength": 2
      }, {
        "emoji": "🧽",
        "emojiKeyword": "海绵,搓澡,搓澡巾,洗澡,吸水,清洁",
        "emojiLength": 2
      }, {
        "emoji": "🧴",
        "emojiKeyword": "洗澡,清洁,护理,沐浴露,洗发露,香波,护肤,乳液,防晒霜",
        "emojiLength": 2
      }, {
        "emoji": "🛎️",
        "emojiKeyword": "铃铛,铃,酒店,服务,服务铃,呼叫,提醒",
        "emojiLength": 3
      }, {
        "emoji": "🔑",
        "emojiKeyword": "钥匙,打开,密码,密钥,开锁,解锁",
        "emojiLength": 2
      }, {
        "emoji": "🗝️",
        "emojiKeyword": "钥匙,打开,密码,密钥,开锁,解锁,老式,老式钥匙,复古钥匙",
        "emojiLength": 3
      }, {
        "emoji": "🚪",
        "emojiKeyword": "门,木门,关门,关闭",
        "emojiLength": 2
      }, {
        "emoji": "🛋️",
        "emojiKeyword": "家具,沙发,休闲,休息,双人,双人沙发,客厅",
        "emojiLength": 3
      }, {
        "emoji": "🛏️",
        "emojiKeyword": "家具,床,卧室",
        "emojiLength": 3
      }, {
        "emoji": "🛌",
        "emojiKeyword": "家具,床,卧室,睡觉,休息,晚安",
        "emojiLength": 2
      }, {
        "emoji": "🧸",
        "emojiKeyword": "玩具,毛绒玩具,熊,玩具熊,泰迪熊",
        "emojiLength": 2
      }, {
        "emoji": "🖼️",
        "emojiKeyword": "画,艺术,油画,装饰,画框",
        "emojiLength": 3
      }, {
        "emoji": "🛍️",
        "emojiKeyword": "购物,逛街,手袋,礼品,伴手礼,商品,商场",
        "emojiLength": 3
      }, {
        "emoji": "🛒",
        "emojiKeyword": "购物,车,购物车,手推车,商场,超市",
        "emojiLength": 2
      }, {
        "emoji": "🎁",
        "emojiKeyword": "礼物,生日,惊喜,赠送,包装,蝴蝶结,圣诞节",
        "emojiLength": 2
      }, {
        "emoji": "🎈",
        "emojiKeyword": "气球,娱乐,游乐场,派对,聚会,节日,庆祝",
        "emojiLength": 2
      }, {
        "emoji": "🎏",
        "emojiKeyword": "庆祝,日本,男孩节,长旗,鲤鱼旗",
        "emojiLength": 2
      }, {
        "emoji": "🎀",
        "emojiKeyword": "粉,粉色,装饰,可爱,蝴蝶结,蝴蝶,打结",
        "emojiLength": 2
      }, {
        "emoji": "🎊",
        "emojiKeyword": "庆祝,聚会,五彩,纸屑,彩带,五彩纸屑,五彩纸屑球,球,派对",
        "emojiLength": 2
      }, {
        "emoji": "🎉",
        "emojiKeyword": "庆祝,聚会,五彩,纸屑,彩带,五彩纸屑,拉炮彩带,派对",
        "emojiLength": 2
      }, {
        "emoji": "🎎",
        "emojiKeyword": "人偶,日本,日本人偶,节日,庆祝,日本人",
        "emojiLength": 2
      }, {
        "emoji": "🏮",
        "emojiKeyword": "灯笼,红,喜庆,节日,过年,照明",
        "emojiLength": 2
      }, {
        "emoji": "🎐",
        "emojiKeyword": "日本,风铃,装饰,庆祝,铃铛,微风,夏天",
        "emojiLength": 2
      }, {
        "emoji": "🧧",
        "emojiKeyword": "红包,过年,钱,压岁钱,福,祝福",
        "emojiLength": 2
      }, {
        "emoji": "✉️",
        "emojiKeyword": "信件,信息,来信,邮件,信,信封,书信",
        "emojiLength": 2
      }, {
        "emoji": "📩",
        "emojiKeyword": "收件,收邮件,信件,信封,接收,邮件,收",
        "emojiLength": 2
      }, {
        "emoji": "📨",
        "emojiKeyword": "接收,收信,来信,收邮件,电子邮件,收,短信",
        "emojiLength": 2
      }, {
        "emoji": "📧",
        "emojiKeyword": "邮件,收件,电子邮件,信封,信件",
        "emojiLength": 2
      }, {
        "emoji": "💌",
        "emojiKeyword": "信件,书信,情书,告白",
        "emojiLength": 2
      }, {
        "emoji": "📥",
        "emojiKeyword": "办公用品,信箱,收件箱,收件,下载",
        "emojiLength": 2
      }, {
        "emoji": "📤",
        "emojiKeyword": "办公用品,信箱,发件箱,发件,上传",
        "emojiLength": 2
      }, {
        "emoji": "📦",
        "emojiKeyword": "快递,纸箱,箱子,网购,包裹,邮寄,货物",
        "emojiLength": 2
      }, {
        "emoji": "🏷️",
        "emojiKeyword": "标签,吊牌,标记,行李牌,价签",
        "emojiLength": 3
      }, {
        "emoji": "📪",
        "emojiKeyword": "信箱,信件,收件,收信",
        "emojiLength": 2
      }, {
        "emoji": "📫",
        "emojiKeyword": "信箱,信件,收件,收信",
        "emojiLength": 2
      }, {
        "emoji": "📬",
        "emojiKeyword": "信箱,信件,收件,收信",
        "emojiLength": 2
      }, {
        "emoji": "📭",
        "emojiKeyword": "信箱,信件,收件,收信",
        "emojiLength": 2
      }, {
        "emoji": "📮",
        "emojiKeyword": "邮箱,寄出,邮寄,寄信,寄出",
        "emojiLength": 2
      }, {
        "emoji": "📯",
        "emojiKeyword": "音乐,乐器,号,号角,喇叭,邮政,大号,邮号",
        "emojiLength": 2
      }, {
        "emoji": "📜",
        "emojiKeyword": "办公用品,纸,书,画卷,纸,纸卷,羊皮纸,复古,古书,古画,牛皮纸,卷轴",
        "emojiLength": 2
      }, {
        "emoji": "📃",
        "emojiKeyword": "办公用品,纸,纸张,卷边,文书,文件,文档,通告,合同",
        "emojiLength": 2
      }, {
        "emoji": "📄",
        "emojiKeyword": "办公用品,纸,纸张,文书,文档,通告,合同",
        "emojiLength": 2
      }, {
        "emoji": "📑",
        "emojiKeyword": "办公用品,纸,纸张,文书,文档,书签,标记,记号,论文,报告,证书,标签页",
        "emojiLength": 2
      }, {
        "emoji": "🧾",
        "emojiKeyword": "纸,纸张,小票,票据,凭据,发票,记账,证明 账单,收据",
        "emojiLength": 2
      }, {
        "emoji": "📊",
        "emojiKeyword": "办公用品,条形图,柱状图,图表,柱形图,直方图,表格",
        "emojiLength": 2
      }, {
        "emoji": "📈",
        "emojiKeyword": "办公用品,图表,趋势,上升,上涨,上涨图表,向上,表格",
        "emojiLength": 2
      }, {
        "emoji": "📉",
        "emojiKeyword": "办公用品,图表,趋势,下降,下跌,下跌图表,向下,表格",
        "emojiLength": 2
      }, {
        "emoji": "🗒️",
        "emojiKeyword": "办公用品,文具,笔记本,记事本,线圈本,线圈",
        "emojiLength": 3
      }, {
        "emoji": "🗓️",
        "emojiKeyword": "办公用品,文具,笔记本,记事本,线圈本,线圈,日历,线圈日历",
        "emojiLength": 3
      }, {
        "emoji": "📆",
        "emojiKeyword": "办公用品,文具,日期,计划,行程,纪念日,日历,手撕日历",
        "emojiLength": 2
      }, {
        "emoji": "📅",
        "emojiKeyword": "办公用品,文具,日期,计划,行程,纪念日,日历",
        "emojiLength": 2
      }, {
        "emoji": "🗑️",
        "emojiKeyword": "垃圾桶,垃圾,桶,废纸篓,纸篓,办公室",
        "emojiLength": 3
      }, {
        "emoji": "📇",
        "emojiKeyword": "办公用品,卡,卡片,索引,卡片索引",
        "emojiLength": 2
      }, {
        "emoji": "🗃️",
        "emojiKeyword": "办公用品,文件,箱,盒,文件箱,卡片盒,文件盒",
        "emojiLength": 3
      }, {
        "emoji": "🗳️",
        "emojiKeyword": "办公用品,投票箱,投票,选举,选票,大选,候选人,选民",
        "emojiLength": 3
      }, {
        "emoji": "🗄️",
        "emojiKeyword": "办公用品,柜,文件柜,存储,归档,文件,抽屉",
        "emojiLength": 3
      }, {
        "emoji": "📋",
        "emojiKeyword": "办公用品,剪贴板,写字板,剪贴簿,夹子,纸张",
        "emojiLength": 2
      }, {
        "emoji": "📁",
        "emojiKeyword": "办公用品,文件,文件夹,文具,硬纸夹",
        "emojiLength": 2
      }, {
        "emoji": "📂",
        "emojiKeyword": "办公用品,打开,文件,文件夹,文具,硬纸夹",
        "emojiLength": 2
      }, {
        "emoji": "🗂️",
        "emojiKeyword": "办公用品,文具,文件夹,文件,索引,分类",
        "emojiLength": 3
      }, {
        "emoji": "🗞️",
        "emojiKeyword": "报纸卷,卷,卷起,报纸,新闻,纸",
        "emojiLength": 3
      }, {
        "emoji": "📰",
        "emojiKeyword": "报道,新闻,看报,读报,报纸,纸",
        "emojiLength": 2
      }, {
        "emoji": "📓",
        "emojiKeyword": "文具,笔记本,纸,日记本,本子,笔记,记事本,记录,书本",
        "emojiLength": 2
      }, {
        "emoji": "📔",
        "emojiKeyword": "文具,笔记本,纸,日记本,本子,笔记,记事本,记录,精装,书本",
        "emojiLength": 2
      }, {
        "emoji": "📒",
        "emojiKeyword": "文具,账本,笔记本,纸,,本子,笔记,记事本,记录,书本",
        "emojiLength": 2
      }, {
        "emoji": "📕",
        "emojiKeyword": "书本,纸,阅读,书,红,红色书本,书籍",
        "emojiLength": 2
      }, {
        "emoji": "📗",
        "emojiKeyword": "书本,纸,阅读,书,绿,绿色书本,书籍",
        "emojiLength": 2
      }, {
        "emoji": "📘",
        "emojiKeyword": "书本,纸,阅读,书,蓝,蓝色书本,书籍",
        "emojiLength": 2
      }, {
        "emoji": "📙",
        "emojiKeyword": "书本,纸,阅读,书,橙,橙色书本,书籍",
        "emojiLength": 2
      }, {
        "emoji": "📚",
        "emojiKeyword": "书本,书籍,书",
        "emojiLength": 2
      }, {
        "emoji": "📖",
        "emojiKeyword": "看书,书本,书籍,书,打开,阅读",
        "emojiLength": 2
      }, {
        "emoji": "🔖",
        "emojiKeyword": "读书,书签,标签,标记",
        "emojiLength": 2
      }, {
        "emoji": "🧷",
        "emojiKeyword": "别针,安全别针,针,缝合",
        "emojiLength": 2
      }, {
        "emoji": "🔗",
        "emojiKeyword": "办公用品,文具,链接,网址,链条,锁链",
        "emojiLength": 2
      }, {
        "emoji": "📎",
        "emojiKeyword": "办公用品,文具,回形针,回纹针,曲别针,纸夹,固定",
        "emojiLength": 2
      }, {
        "emoji": "🖇️",
        "emojiKeyword": "办公用品,文具,回形针,回纹针,曲别针,纸夹,固定",
        "emojiLength": 3
      }, {
        "emoji": "📐",
        "emojiKeyword": "办公用品,文具,尺子,尺,三角,三角尺,测量,数学,几何,角度",
        "emojiLength": 2
      }, {
        "emoji": "📏",
        "emojiKeyword": "办公用品,文具,尺子,尺,直尺,测量,数学",
        "emojiLength": 2
      }, {
        "emoji": "🧮",
        "emojiKeyword": "办公用品,算盘,算数,计算",
        "emojiLength": 2
      }, {
        "emoji": "📌",
        "emojiKeyword": "办公用品,文具,图钉,固定",
        "emojiLength": 2
      }, {
        "emoji": "📍",
        "emojiKeyword": "办公用品,文具,图钉,固定,圆图钉,位置,标记",
        "emojiLength": 2
      }, {
        "emoji": "✂️",
        "emojiKeyword": "办公用品,文具,剪刀,剪切,裁剪,剪裁",
        "emojiLength": 2
      }, {
        "emoji": "🖊️",
        "emojiKeyword": "办公用品,文具,笔,写字,书写,圆珠笔,水性笔",
        "emojiLength": 3
      }, {
        "emoji": "🖋️",
        "emojiKeyword": "办公用品,文具,笔,写字,书写,钢笔,右撇子,右",
        "emojiLength": 3
      }, {
        "emoji": "✒️",
        "emojiKeyword": "办公用品,文具,笔,写字,书写,钢笔,左撇子,左",
        "emojiLength": 2
      }, {
        "emoji": "🖌️",
        "emojiKeyword": "办公用品,文具,笔,画笔,毛笔,画画,书法",
        "emojiLength": 3
      }, {
        "emoji": "🖍️",
        "emojiKeyword": "办公用品,文具,笔,蜡笔,油画,画画,画棒",
        "emojiLength": 3
      }, {
        "emoji": "📝",
        "emojiKeyword": "办公用品,文具,备忘录,便条,便条簿,便笺,便签,备忘,写信,书写",
        "emojiLength": 2
      }, {
        "emoji": "✏️",
        "emojiKeyword": "办公用品,文具,笔,铅笔,画画,写字,素描",
        "emojiLength": 2
      }, {
        "emoji": "🔍",
        "emojiKeyword": "办公用品,工具,放大镜,放大,查找,搜索,左",
        "emojiLength": 2
      }, {
        "emoji": "🔎",
        "emojiKeyword": "办公用品,工具,放大镜,放大,查找,搜索,右",
        "emojiLength": 2
      }, {
        "emoji": "🔏",
        "emojiKeyword": "笔,锁,钢笔,编辑,锁定,锁头,锁子",
        "emojiLength": 2
      }, {
        "emoji": "🔐",
        "emojiKeyword": "钥匙,锁,锁上,安全,锁头,锁子",
        "emojiLength": 2
      }, {
        "emoji": "🔒",
        "emojiKeyword": "锁,锁定,锁住,锁头,锁子",
        "emojiLength": 2
      }, {
        "emoji": "🔓",
        "emojiKeyword": "锁,开锁,解锁,解开,锁头,锁子",
        "emojiLength": 2
      }]
    }, {
      "categoryName": "符号",
      "emojiCategoryEntities": [{
        "emoji": "❤️",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,红色,红,红色的心",
        "emojiLength": 2
      }, {
        "emoji": "🧡",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,橙,橙色,橙色的心",
        "emojiLength": 2
      }, {
        "emoji": "💛",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,黄,黄色,黄色的心",
        "emojiLength": 2
      }, {
        "emoji": "💚",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,绿,绿色,绿色的心",
        "emojiLength": 2
      }, {
        "emoji": "💙",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,蓝,蓝色,蓝色的心",
        "emojiLength": 2
      }, {
        "emoji": "💜",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,紫,紫色,紫色的心",
        "emojiLength": 2
      }, {
        "emoji": "🖤",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,黑,黑色,黑色的心",
        "emojiLength": 2
      }, {
        "emoji": "💔",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,红色,红,红色的心,裂开,心碎,破碎",
        "emojiLength": 2
      }, {
        "emoji": "❤️‍🔥",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,红色,红,红色的心,火,着火,燃烧,热烈,炙热",
        "emojiLength": 5
      }, {
        "emoji": "❣️",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,红色,红,红色的心,心叹号,叹号,心动",
        "emojiLength": 2
      }, {
        "emoji": "💕",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,粉红,粉,粉色,粉色的心,两颗心,相爱,爱情,浪漫",
        "emojiLength": 2
      }, {
        "emoji": "💞",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,粉红,粉,粉色,粉色的心,两颗心,旋转的心,旋转",
        "emojiLength": 2
      }, {
        "emoji": "💓",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,粉红,粉,粉色,粉色的心,心动,爱情,跳动",
        "emojiLength": 2
      }, {
        "emoji": "💗",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,粉红,粉,粉色,粉色的心,心动,爱情,心跳",
        "emojiLength": 2
      }, {
        "emoji": "💖",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,粉红,粉,粉色,粉色的心,星,星星,闪亮的心,闪亮",
        "emojiLength": 2
      }, {
        "emoji": "💘",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,粉红,粉,粉色,粉色的心,丘比特,浪漫,爱情,箭,红心,中箭",
        "emojiLength": 2
      }, {
        "emoji": "💝",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,粉红,粉,粉色,粉色的心,礼物,爱的礼物,缎带,蝴蝶结,包装",
        "emojiLength": 2
      }, {
        "emoji": "💟",
        "emojiKeyword": "符,符号,心,爱心,桃心,心形,喜欢,爱,可爱,紫色,心型,心型装饰,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "☮️",
        "emojiKeyword": "符,符号,紫色,和平,和平符号,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "✝️",
        "emojiKeyword": "符,符号,紫色,基督,天主教,宗教,耶稣,十字架,十字架符号,紫色正方形,正方形,拉丁",
        "emojiLength": 2
      }, {
        "emoji": "☪️",
        "emojiKeyword": "符,符号,紫色,星月,伊斯兰,宗教,穆斯林,信仰,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "🕉️",
        "emojiKeyword": "符,符号,紫色,印度,宗教,瑜伽,奥姆,印度教,奥,佛,紫色正方形,正方形",
        "emojiLength": 3
      }, {
        "emoji": "☸️",
        "emojiKeyword": "符,符号,紫色,佛,宗教,达摩,法轮,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "✡️",
        "emojiKeyword": "符,符号,紫色,六芒星,大卫,大卫之星,宗教,犹太,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "🔯",
        "emojiKeyword": "符,符号,紫色,六芒星,大卫,大卫之星,宗教,犹太,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "🕎",
        "emojiKeyword": "符,符号,紫色,光明节,宗教,灯台,光明节 蜡烛,宗教,犹太,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "☯️",
        "emojiKeyword": "符,符号,紫色,阴阳,太极,宗教,道,道教,阳,阴,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "☦️",
        "emojiKeyword": "符,符号,紫色,东正教十字架,东正教,十字架,基督,宗教,信仰,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "🛐",
        "emojiKeyword": "符,符号,紫色,地点,礼拜,祈祷,礼拜堂,宗教场所,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "⛎",
        "emojiKeyword": "符,符号,紫色,星座,蛇,蛇夫座,紫色正方形,正方形",
        "emojiLength": 1
      }, {
        "emoji": "♈️",
        "emojiKeyword": "符,符号,紫色,星座,白羊,白羊座,牡羊座,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "♉️",
        "emojiKeyword": "符,符号,紫色,星座,金牛,金牛座,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "♊️",
        "emojiKeyword": "符,符号,紫色,星座,双子,双子座,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "♋️",
        "emojiKeyword": "符,符号,紫色,星座,巨蟹,巨蟹座,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "♌️",
        "emojiKeyword": "符,符号,紫色,星座,狮子,狮子座,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "♍️",
        "emojiKeyword": "符,符号,紫色,星座,处女,处女座,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "♎️",
        "emojiKeyword": "符,符号,紫色,星座,天秤,天秤座,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "♏️",
        "emojiKeyword": "符,符号,紫色,星座,天蝎,天蝎座,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "♐️",
        "emojiKeyword": "符,符号,紫色,星座,射手,射手座,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "♑️",
        "emojiKeyword": "符,符号,紫色,星座,摩羯,摩羯座,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "♒️",
        "emojiKeyword": "符,符号,紫色,星座,水瓶,水瓶座,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "♓️",
        "emojiKeyword": "符,符号,紫色,星座,双鱼,双鱼座,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "🆔",
        "emojiKeyword": "符,符号,紫色,ID,识别,身份,紫色正方形,正方形,id",
        "emojiLength": 2
      }, {
        "emoji": "⚛️",
        "emojiKeyword": "符,符号,紫色,物质,原子,原子符号,紫色正方形,正方形",
        "emojiLength": 2
      }, {
        "emoji": "🉑",
        "emojiKeyword": "符,符号,橙色,可,可以,许可,OK,ok",
        "emojiLength": 2
      }, {
        "emoji": "☢️",
        "emojiKeyword": "符,符号,橙色,辐射,放射,放射性,危险",
        "emojiLength": 2
      }, {
        "emoji": "☣️",
        "emojiKeyword": "符,符号,橙色,生物危害,感染,生化危机,生化",
        "emojiLength": 2
      }, {
        "emoji": "📴",
        "emojiKeyword": "符,符号,橙色,橙色正方形,正方形,手机,手机关机,关闭手机,关闭,关机",
        "emojiLength": 2
      }, {
        "emoji": "📳",
        "emojiKeyword": "符,符号,橙色,橙色正方形,正方形,手机,振动,静音,振动模式,静音模式",
        "emojiLength": 2
      }, {
        "emoji": "🈶",
        "emojiKeyword": "符,符号,橙色,橙色正方形,正方形,有,日文,收费",
        "emojiLength": 2
      }, {
        "emoji": "🈚️",
        "emojiKeyword": "符,符号,橙色,橙色正方形,正方形,无,没有,日文,免费",
        "emojiLength": 3
      }, {
        "emoji": "🈸",
        "emojiKeyword": "符,符号,橙色,橙色正方形,正方形,申请,日文,申,申诉",
        "emojiLength": 2
      }, {
        "emoji": "🈺",
        "emojiKeyword": "符,符号,橙色,橙色正方形,正方形,日文,营业,营业中,开业,开始营业",
        "emojiLength": 2
      }, {
        "emoji": "🈷️",
        "emojiKeyword": "符,符号,橙色,橙色正方形,正方形,日文,月,月度,月总量",
        "emojiLength": 3
      }, {
        "emoji": "✴️",
        "emojiKeyword": "符,符号,橙色,橙色正方形,正方形,八角星,星,星号,闪亮",
        "emojiLength": 2
      }, {
        "emoji": "🆚",
        "emojiKeyword": "符,符号,橙色,橙色正方形,正方形,VS,vs,对决,比赛,比,对抗",
        "emojiLength": 2
      }, {
        "emoji": "💮",
        "emojiKeyword": "符,符号,红色,花,白花,表扬",
        "emojiLength": 2
      }, {
        "emoji": "🉐",
        "emojiKeyword": "符,符号,红色,日文,得,议价",
        "emojiLength": 2
      }, {
        "emoji": "㊙️",
        "emojiKeyword": "符,符号,红色,日文,秘密,保密,机密,保守,私密,私人",
        "emojiLength": 2
      }, {
        "emoji": "㊗️",
        "emojiKeyword": "符,符号,红色,日文,祝,祝贺,祝愿,祝福",
        "emojiLength": 2
      }, {
        "emoji": "🈴",
        "emojiKeyword": "符,符号,红色,红色正方形,正方形,日文,合,合格,通过",
        "emojiLength": 2
      }, {
        "emoji": "🈵",
        "emojiKeyword": "符,符号,红色,红色正方形,正方形,日文,满,满足,没空,满席,满座,满员,充满",
        "emojiLength": 2
      }, {
        "emoji": "🈹",
        "emojiKeyword": "符,符号,红色,红色正方形,正方形,日文,割,优惠,打折",
        "emojiLength": 2
      }, {
        "emoji": "🈲",
        "emojiKeyword": "符,符号,红色,红色正方形,正方形,日文,禁止,严禁,禁,封禁,禁地",
        "emojiLength": 2
      }, {
        "emoji": "🅰️",
        "emojiKeyword": "符,符号,红色,红色正方形,正方形,A,a,A型血,血,血型",
        "emojiLength": 3
      }, {
        "emoji": "🅱️",
        "emojiKeyword": "符,符号,红色,红色正方形,正方形,B,b,B型血,血,血型",
        "emojiLength": 3
      }, {
        "emoji": "🆎",
        "emojiKeyword": "符,符号,红色,红色正方形,正方形,AB,ab,AB型血,血,血型",
        "emojiLength": 2
      }, {
        "emoji": "🆑",
        "emojiKeyword": "符,符号,红色,红色正方形,正方形,CL,cl,清,清除",
        "emojiLength": 2
      }, {
        "emoji": "🅾️",
        "emojiKeyword": "符,符号,红色,红色正方形,正方形,O,o,O型血,血,血型",
        "emojiLength": 3
      }, {
        "emoji": "🆘",
        "emojiKeyword": "符,符号,红色,红色正方形,正方形,SOS,求救,呼救,救助,信号",
        "emojiLength": 2
      }, {
        "emoji": "❌",
        "emojiKeyword": "符,符号,红色,叉,错,不对,错误,关闭,禁止,禁",
        "emojiLength": 1
      }, {
        "emoji": "⭕️",
        "emojiKeyword": "符,符号,红色,圆,圆圈,圈,红色圆圈,对,标记",
        "emojiLength": 2
      }, {
        "emoji": "🛑",
        "emojiKeyword": "符,符号,红色,标志,停止,八边形",
        "emojiLength": 2
      }, {
        "emoji": "⛔️",
        "emojiKeyword": "符,符号,红色,交通,禁止,禁行,禁止通行,禁止入内",
        "emojiLength": 2
      }, {
        "emoji": "📛",
        "emojiKeyword": "姓名牌,胸牌,证章,名字牌,牌,红色",
        "emojiLength": 2
      }, {
        "emoji": "🚫",
        "emojiKeyword": "符,符号,红色,禁止,不准,不许,严禁,阻止,警告",
        "emojiLength": 2
      }, {
        "emoji": "💯",
        "emojiKeyword": "符,符号,红色,考试,满分,一百,一百分",
        "emojiLength": 2
      }, {
        "emoji": "💢",
        "emojiKeyword": "符,符号,红色,怒,生气,火大,发怒,青筋",
        "emojiLength": 2
      }, {
        "emoji": "♨️",
        "emojiKeyword": "符,符号,红色,旅游,水,温泉,汤泉,暖,泡,泡温泉",
        "emojiLength": 2
      }, {
        "emoji": "🚷",
        "emojiKeyword": "符,符号,禁止,禁,行人,行人通行,禁止行人通行",
        "emojiLength": 2
      }, {
        "emoji": "🚯",
        "emojiKeyword": "符,符号,禁止,禁,垃圾,扔垃圾,乱扔垃圾,禁止乱扔,禁止乱扔垃圾",
        "emojiLength": 2
      }, {
        "emoji": "🚳",
        "emojiKeyword": "符,符号,禁止,禁,自行车,通行,禁止自行车",
        "emojiLength": 2
      }, {
        "emoji": "🚱",
        "emojiKeyword": "符,符号,禁止,禁,水,饮用水,非饮用水",
        "emojiLength": 2
      }, {
        "emoji": "🔞",
        "emojiKeyword": "符,符号,禁止,禁,成人,18禁,未成年,少儿不宜",
        "emojiLength": 2
      }, {
        "emoji": "📵",
        "emojiKeyword": "符,符号,禁止,禁,手机,手机关机,关闭手机,关闭,关机",
        "emojiLength": 2
      }, {
        "emoji": "🚭",
        "emojiKeyword": "符,符号,禁止,禁,烟,吸烟,禁止吸烟,请勿吸烟,禁烟",
        "emojiLength": 2
      }, {
        "emoji": "❗️",
        "emojiKeyword": "符,符号,叹号,感叹号,惊讶,提醒,红,红色,标点符号",
        "emojiLength": 2
      }, {
        "emoji": "❕",
        "emojiKeyword": "符,符号,叹号,感叹号,惊讶,提醒,白,白色,标点符号",
        "emojiLength": 1
      }, {
        "emoji": "❓",
        "emojiKeyword": "符,符号,问号,疑问,疑惑,问题,红,红色,标点符号",
        "emojiLength": 1
      }, {
        "emoji": "❔",
        "emojiKeyword": "符,符号,问号,疑问,疑惑,问题,白,白色,标点符号",
        "emojiLength": 1
      }, {
        "emoji": "‼️",
        "emojiKeyword": "符,符号,叹号,感叹号,惊讶,提醒,红,红色,标点符号,双叹号,震惊,吃惊",
        "emojiLength": 2
      }, {
        "emoji": "⁉️",
        "emojiKeyword": "符,符号,叹号,感叹号,惊讶,提醒,红,红色,标点符号,问号,疑问,震惊,难以置信",
        "emojiLength": 2
      }, {
        "emoji": "🔅",
        "emojiKeyword": "符,符号,黄色,亮度,手机,电脑,低,低亮度",
        "emojiLength": 2
      }, {
        "emoji": "🔆",
        "emojiKeyword": "符,符号,黄色,亮度,手机,电脑,高,高亮度",
        "emojiLength": 2
      }, {
        "emoji": "〽️",
        "emojiKeyword": "符,符号,黄色,庵点,折线,曲折",
        "emojiLength": 2
      }, {
        "emoji": "⚠️",
        "emojiKeyword": "符,符号,黄色,警告,黄,警示,注意,危险,预警",
        "emojiLength": 2
      }, {
        "emoji": "🚸",
        "emojiKeyword": "符,符号,黄色,交通,安全,指示牌,行人,儿童,儿童过街",
        "emojiLength": 2
      }, {
        "emoji": "🔱",
        "emojiKeyword": "符,符号,工具,船,锚,海神,海王,波塞冬,三叉戟,徽章,三叉戟徽章",
        "emojiLength": 2
      }, {
        "emoji": "⚜️",
        "emojiKeyword": "花,花饰,鸢尾花,皇家,王室,贵族",
        "emojiLength": 2
      }, {
        "emoji": "🔰",
        "emojiKeyword": "符,符号,绿色,黄色,叶状,实习,箭尾,黄色,日本,新手驾驶,标志,新手",
        "emojiLength": 2
      }, {
        "emoji": "♻️",
        "emojiKeyword": "符,符号,绿色,环保,循环,绿,回收,可回收,再利用",
        "emojiLength": 2
      }, {
        "emoji": "✅",
        "emojiKeyword": "符,符号,绿色,绿色正方形,正方形,对,正确,勾选,对号,对钩",
        "emojiLength": 1
      }, {
        "emoji": "🈯️",
        "emojiKeyword": "符,符号,绿色,绿色正方形,正方形,日文,指,指定,预留,预定,预订",
        "emojiLength": 3
      }, {
        "emoji": "💹",
        "emojiKeyword": "符,符号,绿色,绿色正方形,正方形,上扬,上涨,上升,汇率,图表,走势,金融,K线,股市,股票",
        "emojiLength": 2
      }, {
        "emoji": "❇️",
        "emojiKeyword": "符,符号,绿色,绿色正方形,正方形,星号,闪亮,四角星",
        "emojiLength": 2
      }, {
        "emoji": "✳️",
        "emojiKeyword": "符,符号,绿色,绿色正方形,正方形,星号,闪亮,乘,乘方,乘号",
        "emojiLength": 2
      }, {
        "emoji": "❎",
        "emojiKeyword": "符,符号,绿色,绿色正方形,正方形,叉号,错误,乘号,乘,乘方",
        "emojiLength": 1
      }, {
        "emoji": "🌐",
        "emojiKeyword": "符,符号,蓝色,世界,地球,子午线,经纬,地理,经纬线",
        "emojiLength": 2
      }, {
        "emoji": "💠",
        "emojiKeyword": "符,符号,蓝色,钻石,水晶,冰块",
        "emojiLength": 2
      }, {
        "emoji": "Ⓜ️",
        "emojiKeyword": "符,符号,蓝色,m,M,字母,圆,圈",
        "emojiLength": 2
      }, {
        "emoji": "🌀",
        "emojiKeyword": "符,符号,蓝色,圈,旋转,风,天气,台风",
        "emojiLength": 2
      }, {
        "emoji": "💤",
        "emojiKeyword": "符,符号,蓝色,z,困,睡觉,打呼,睡眠,晚安,休息,呼噜",
        "emojiLength": 2
      }, {
        "emoji": "🏧",
        "emojiKeyword": "符,符号,蓝色,蓝色正方形,正方形,ATM,柜员机,银行,取钱,取款,存款",
        "emojiLength": 2
      }, {
        "emoji": "🚾",
        "emojiKeyword": "符,符号,蓝色,蓝色正方形,正方形,WC,厕所,卫生间,洗手间,公共厕所",
        "emojiLength": 2
      }, {
        "emoji": "♿️",
        "emojiKeyword": "符,符号,蓝色,蓝色正方形,正方形,轮椅,残疾,残障,无障碍",
        "emojiLength": 2
      }, {
        "emoji": "🅿️",
        "emojiKeyword": "符,符号,蓝色,蓝色正方形,正方形,停车,停车场,停泊,泊车",
        "emojiLength": 3
      }, {
        "emoji": "🈳",
        "emojiKeyword": "符,符号,蓝色,蓝色正方形,正方形,日文,空,空虚,有空,空位,空座,空闲,无人",
        "emojiLength": 2
      }, {
        "emoji": "🈂️",
        "emojiKeyword": "符,符号,蓝色,蓝色正方形,正方形,日文,服务费,小费,费用,收费,服务",
        "emojiLength": 3
      }, {
        "emoji": "🛂",
        "emojiKeyword": "符,符号,蓝色,蓝色正方形,正方形,护照检查,安检,检查,通行证,入境检查,出境,入境,海关检查,机场",
        "emojiLength": 2
      }, {
        "emoji": "🛃",
        "emojiKeyword": "符,符号,蓝色,蓝色正方形,正方形,海关,安检,检查,通行证,入境检查,出境,入境,海关检查,机场",
        "emojiLength": 2
      }, {
        "emoji": "🛄",
        "emojiKeyword": "符,符号,蓝色,蓝色正方形,正方形,提取行李,提取,行李,托运,行李寄存,机场",
        "emojiLength": 2
      }, {
        "emoji": "🛅",
        "emojiKeyword": "符,符号,蓝色,蓝色正方形,正方形,寄存行李,寄存,行李,机场,商场,火车站,高铁站",
        "emojiLength": 2
      }, {
        "emoji": "🚹",
        "emojiKeyword": "符,符号,蓝色,蓝色正方形,正方形,厕所,男厕,公共厕所,卫生间,男",
        "emojiLength": 2
      }, {
        "emoji": "🚺",
        "emojiKeyword": "符,符号,紫色,紫色正方形,正方形,厕所,女厕,公共厕所,卫生间,女",
        "emojiLength": 2
      }, {
        "emoji": "🚼",
        "emojiKeyword": "符,符号,橙色,橙色正方形,正方形,宝宝,婴儿,母婴室,小孩,幼儿,哺乳室",
        "emojiLength": 2
      }, {
        "emoji": "⚧️",
        "emojiKeyword": "符号,方,正方形,性别,跨性别,变性",
        "emojiLength": 2
      }, {
        "emoji": "🚻",
        "emojiKeyword": "标志,方,正方形,WC,厕所,卫生间,洗手间,公共厕所",
        "emojiLength": 2
      }, {
        "emoji": "🚮",
        "emojiKeyword": "标志,方,正方形,垃圾桶,垃圾,扔垃圾,倒垃圾,垃圾入篓,丢垃圾",
        "emojiLength": 2
      }, {
        "emoji": "🎦",
        "emojiKeyword": "场所,方,正方形,电影院,影片,放映,点播,电影",
        "emojiLength": 2
      }, {
        "emoji": "📶",
        "emojiKeyword": "按钮,方,正方形,手机,信号,网络,移动",
        "emojiLength": 2
      }, {
        "emoji": "🈁",
        "emojiKeyword": "按钮,方,正方形,这里,日文,此处,这",
        "emojiLength": 2
      }, {
        "emoji": "🔣",
        "emojiKeyword": "按钮,方,正方形,输入符号,字符,打字,键盘,符号",
        "emojiLength": 2
      }, {
        "emoji": "ℹ️",
        "emojiKeyword": "按钮,方,正方形,信息,查询,资料,消息,资讯,说明,备注",
        "emojiLength": 2
      }, {
        "emoji": "🔤",
        "emojiKeyword": "按钮,方,正方形,字母,拉丁,英文,英语",
        "emojiLength": 2
      }, {
        "emoji": "🔡",
        "emojiKeyword": "按钮,方,正方形,字母,拉丁,英文,英语",
        "emojiLength": 2
      }, {
        "emoji": "🔠",
        "emojiKeyword": "按钮,方,正方形,字母,拉丁,英文,大写,英语",
        "emojiLength": 2
      }, {
        "emoji": "🆖",
        "emojiKeyword": "按钮,方,正方形,NG,按键,重拍,重复,花絮,不行",
        "emojiLength": 2
      }, {
        "emoji": "🆗",
        "emojiKeyword": "按钮,方,正方形,OK,ok,可以,通过,好的,没问题",
        "emojiLength": 2
      }, {
        "emoji": "🆙",
        "emojiKeyword": "按钮,方,正方形,向上,按键,上升,增加,置顶,顶",
        "emojiLength": 2
      }, {
        "emoji": "🆒",
        "emojiKeyword": "按钮,方,正方形,按键,酷,喜欢,赞,帅",
        "emojiLength": 2
      }, {
        "emoji": "🆕",
        "emojiKeyword": "按钮,方,正方形,新的,全新,新品,new,上新",
        "emojiLength": 2
      }, {
        "emoji": "🆓",
        "emojiKeyword": "按钮,方,正方形,免费,优惠,赠送,赠品",
        "emojiLength": 2
      }, {
        "emoji": "0️⃣",
        "emojiKeyword": "按钮,方,正方形,按键,数字,0,零,无,空",
        "emojiLength": 3
      }, {
        "emoji": "1️⃣",
        "emojiKeyword": "按钮,方,正方形,按键,数字,1,一",
        "emojiLength": 3
      }, {
        "emoji": "2️⃣",
        "emojiKeyword": "按钮,方,正方形,按键,数字,2,二",
        "emojiLength": 3
      }, {
        "emoji": "3️⃣",
        "emojiKeyword": "按钮,方,正方形,按键,数字,3,三",
        "emojiLength": 3
      }, {
        "emoji": "4️⃣",
        "emojiKeyword": "按钮,方,正方形,按键,数字,4,四",
        "emojiLength": 3
      }, {
        "emoji": "5️⃣",
        "emojiKeyword": "按钮,方,正方形,按键,数字,5,五",
        "emojiLength": 3
      }, {
        "emoji": "6️⃣",
        "emojiKeyword": "按钮,方,正方形,按键,数字,6,六",
        "emojiLength": 3
      }, {
        "emoji": "7️⃣",
        "emojiKeyword": "按钮,方,正方形,按键,数字,7,七",
        "emojiLength": 3
      }, {
        "emoji": "8️⃣",
        "emojiKeyword": "按钮,方,正方形,按键,数字,8,八",
        "emojiLength": 3
      }, {
        "emoji": "9️⃣",
        "emojiKeyword": "按钮,方,正方形,按键,数字,9,九",
        "emojiLength": 3
      }, {
        "emoji": "🔟",
        "emojiKeyword": "按钮,方,正方形,按键,数字,0,十",
        "emojiLength": 2
      }, {
        "emoji": "🔢",
        "emojiKeyword": "按钮,方,正方形,按键,数字,计算器,计算",
        "emojiLength": 2
      }, {
        "emoji": "#️⃣",
        "emojiKeyword": "按钮,方,正方形,按键,井号,井号键,井",
        "emojiLength": 3
      }, {
        "emoji": "*️⃣",
        "emojiKeyword": "按钮,方,正方形,按键,星号,星号键,星",
        "emojiLength": 3
      }, {
        "emoji": "⏏️",
        "emojiKeyword": "按钮,方,正方形,按键,视频,磁带,弹出,取出,取碟",
        "emojiLength": 2
      }, {
        "emoji": "▶️",
        "emojiKeyword": "按钮,方,正方形,按键,视频,播放,三角,向右,箭头,开始,右,下一个",
        "emojiLength": 2
      }, {
        "emoji": "⏸️",
        "emojiKeyword": "按钮,方,正方形,按键,暂停,视频,音乐,播放",
        "emojiLength": 2
      }, {
        "emoji": "⏯️",
        "emojiKeyword": "按钮,方,正方形,按键,视频,音乐,播放,暂停",
        "emojiLength": 2
      }, {
        "emoji": "⏹️",
        "emojiKeyword": "按钮,方,正方形,按键,停止,方形,终止,停止按钮",
        "emojiLength": 2
      }, {
        "emoji": "⏺️",
        "emojiKeyword": "按钮,方,正方形,按键,录制按钮,圆形,拍摄,记录",
        "emojiLength": 2
      }, {
        "emoji": "⏭️",
        "emojiKeyword": "按钮,方,正方形,按键,下一个,三角,箭头,向右,右",
        "emojiLength": 2
      }, {
        "emoji": "⏮️",
        "emojiKeyword": "按钮,方,正方形,按键,上一个,后,三角,箭头,向左,左",
        "emojiLength": 2
      }, {
        "emoji": "⏩️",
        "emojiKeyword": "按钮,方,正方形,按键,三角,向右,箭头,右,双箭头,快进",
        "emojiLength": 2
      }, {
        "emoji": "⏪️",
        "emojiKeyword": "按钮,方,正方形,按键,三角,向左,箭头,左,双箭头,快退,后",
        "emojiLength": 2
      }, {
        "emoji": "⏫️",
        "emojiKeyword": "按钮,方,正方形,按键,上升,快速上升,箭头,双箭头,向上,上",
        "emojiLength": 2
      }, {
        "emoji": "⏬️",
        "emojiKeyword": "按钮,方,正方形,按键,下降,快速下降,箭头,双箭头,向下,下",
        "emojiLength": 2
      }, {
        "emoji": "◀️",
        "emojiKeyword": "按钮,方,正方形,按键,三角,向左,箭头,左,后退,上一个",
        "emojiLength": 2
      }, {
        "emoji": "🔼",
        "emojiKeyword": "按钮,方,正方形,按键,三角,向上,箭头,上,上升",
        "emojiLength": 2
      }, {
        "emoji": "🔽",
        "emojiKeyword": "按钮,方,正方形,按键,三角,向下,箭头,下,下降",
        "emojiLength": 2
      }, {
        "emoji": "➡️",
        "emojiKeyword": "按钮,方,正方形,箭头,方向,向,向右,右",
        "emojiLength": 2
      }, {
        "emoji": "⬅️",
        "emojiKeyword": "按钮,方,正方形,箭头,方向,向,向左,左",
        "emojiLength": 2
      }, {
        "emoji": "⬆️",
        "emojiKeyword": "按钮,方,正方形,箭头,方向,向,向上,上",
        "emojiLength": 2
      }, {
        "emoji": "⬇️",
        "emojiKeyword": "按钮,方,正方形,箭头,方向,向,向下,下",
        "emojiLength": 2
      }, {
        "emoji": "↗️",
        "emojiKeyword": "按钮,方,正方形,箭头,方向,向,右上,右,上,右上角",
        "emojiLength": 2
      }, {
        "emoji": "↘️",
        "emojiKeyword": "按钮,方,正方形,箭头,方向,向,右下,右,下,右下角",
        "emojiLength": 2
      }, {
        "emoji": "↙️",
        "emojiKeyword": "按钮,方,正方形,箭头,方向,向,左下,左,下,左下角",
        "emojiLength": 2
      }, {
        "emoji": "↖️",
        "emojiKeyword": "按钮,方,正方形,箭头,方向,向,左上,左,上,左上角",
        "emojiLength": 2
      }, {
        "emoji": "↕️",
        "emojiKeyword": "按钮,方,正方形,箭头,双箭头,上下,纵向,竖,纵,上,下",
        "emojiLength": 2
      }, {
        "emoji": "↔️",
        "emojiKeyword": "按钮,方,正方形,箭头,双箭头,左右,横向,横,左,右",
        "emojiLength": 2
      }, {
        "emoji": "↪️",
        "emojiKeyword": "按钮,方,正方形,箭头,左,左转弯,左转,下一步,重做",
        "emojiLength": 2
      }, {
        "emoji": "↩️",
        "emojiKeyword": "按钮,方,正方形,箭头,右,右转弯,右转,上一步,撤销",
        "emojiLength": 2
      }, {
        "emoji": "⤴️",
        "emojiKeyword": "按钮,方,正方形,箭头,右上弯,右上弯箭头",
        "emojiLength": 2
      }, {
        "emoji": "⤵️",
        "emojiKeyword": "按钮,方,正方形,箭头,右下弯,右下弯箭头",
        "emojiLength": 2
      }, {
        "emoji": "🔀",
        "emojiKeyword": "按钮,方,正方形,箭头,双箭头,随机,播放",
        "emojiLength": 2
      }, {
        "emoji": "🔁",
        "emojiKeyword": "按钮,方,正方形,箭头,双箭头,循环,顺时针,顺,播放",
        "emojiLength": 2
      }, {
        "emoji": "🔂",
        "emojiKeyword": "按钮,方,正方形,箭头,双箭头,循环,顺时针,顺,单曲循环,播放",
        "emojiLength": 2
      }, {
        "emoji": "🔄",
        "emojiKeyword": "按钮,方,正方形,箭头,双箭头,逆时针,逆转,逆",
        "emojiLength": 2
      }, {
        "emoji": "🔃",
        "emojiKeyword": "按钮,方,正方形,箭头,双箭头,切换,顺时针,顺",
        "emojiLength": 2
      }, {
        "emoji": "🎵",
        "emojiKeyword": "符号,音乐,音符,乐谱,五线谱,八分音符",
        "emojiLength": 2
      }, {
        "emoji": "🎶",
        "emojiKeyword": "符号,音乐,音符,乐谱,五线谱,八分音符",
        "emojiLength": 2
      }, {
        "emoji": "➕",
        "emojiKeyword": "符号,数学,数学符号,加号,相加,加上,加,加法,运算,运算符号",
        "emojiLength": 1
      }, {
        "emoji": "➖",
        "emojiKeyword": "符号,数学,数学符号,减号,减去,减,减法,运算,运算符号",
        "emojiLength": 1
      }, {
        "emoji": "➗",
        "emojiKeyword": "符号,数学,数学符号,除号,除以,除法,运算,运算符号",
        "emojiLength": 1
      }, {
        "emoji": "✖️",
        "emojiKeyword": "符号,数学,数学符号,乘号,乘以,乘法,运算,运算符号",
        "emojiLength": 2
      }, {
        "emoji": "♾️",
        "emojiKeyword": "符号,数学,数学符号,无限",
        "emojiLength": 2
      }, {
        "emoji": "💲",
        "emojiKeyword": "符号,货币,美元,美刀,美国",
        "emojiLength": 2
      }, {
        "emoji": "💱",
        "emojiKeyword": "货币兑换,符号,兑换,外汇,换汇,汇率,出国",
        "emojiLength": 2
      }, {
        "emoji": "™️",
        "emojiKeyword": "标记,商标,产品,标志,商品",
        "emojiLength": 2
      }, {
        "emoji": "©️",
        "emojiKeyword": "符号,版权,出版,作品",
        "emojiLength": 2
      }, {
        "emoji": "®️",
        "emojiKeyword": "注册,符号,标记,商品,注册标记",
        "emojiLength": 2
      }, {
        "emoji": "👁️‍🗨️",
        "emojiKeyword": "对话框,眼睛,眼睛对话框,气泡",
        "emojiLength": 7
      }, {
        "emoji": "🔚",
        "emojiKeyword": "箭头,结束,关闭,完结,结束箭头,end,END",
        "emojiLength": 2
      }, {
        "emoji": "🔙",
        "emojiKeyword": "回退,箭头,返回,退回,返回箭头,back,BACK,后",
        "emojiLength": 2
      }, {
        "emoji": "🔛",
        "emojiKeyword": "箭头,双箭头,开始,开始箭头,on,ON",
        "emojiLength": 2
      }, {
        "emoji": "🔝",
        "emojiKeyword": "箭头,向上,上,置顶,置顶箭头,top,TOP",
        "emojiLength": 2
      }, {
        "emoji": "🔜",
        "emojiKeyword": "箭头,稍候,稍等,马上,马上箭头,soon,SOON",
        "emojiLength": 2
      }, {
        "emoji": "〰️",
        "emojiKeyword": "标记,符号,波浪,曲线,波浪线",
        "emojiLength": 2
      }, {
        "emoji": "➰",
        "emojiKeyword": "标记,单环,标志,卷,波浪线,曲,猪尾巴",
        "emojiLength": 1
      }, {
        "emoji": "➿",
        "emojiKeyword": "标记,双环,标志,曲线,波浪线,双卷曲,双卷曲环,卷",
        "emojiLength": 1
      }, {
        "emoji": "✔️",
        "emojiKeyword": "对,对钩,对号,正确,打钩,勾选,标记",
        "emojiLength": 2
      }, {
        "emoji": "☑️",
        "emojiKeyword": "按钮,勾选框,选中,打钩,复选框,勾选",
        "emojiLength": 2
      }, {
        "emoji": "🔘",
        "emojiKeyword": "按钮,单选,单选按钮,选中,圆,圈",
        "emojiLength": 2
      }, {
        "emoji": "🔴",
        "emojiKeyword": "形状,圆,圆形,红,红色,红色圆,圆圈",
        "emojiLength": 2
      }, {
        "emoji": "🔵",
        "emojiKeyword": "形状,圆,圆形,蓝,蓝色,蓝色圆,圆圈",
        "emojiLength": 2
      }, {
        "emoji": "⚫️",
        "emojiKeyword": "形状,圆,圆形,黑,黑色,黑色圆,圆圈",
        "emojiLength": 2
      }, {
        "emoji": "⚪️",
        "emojiKeyword": "形状,圆,圆形,白,白色,白色圆,圆圈",
        "emojiLength": 2
      }, {
        "emoji": "🔺",
        "emojiKeyword": "形状,三角,上,三角形,红,小",
        "emojiLength": 2
      }, {
        "emoji": "🔻",
        "emojiKeyword": "形状,三角,下,三角形,红,小",
        "emojiLength": 2
      }, {
        "emoji": "🔸",
        "emojiKeyword": "形状,菱形,橙色,小,橙",
        "emojiLength": 2
      }, {
        "emoji": "🔹",
        "emojiKeyword": "形状,菱形,蓝色,小,蓝",
        "emojiLength": 2
      }, {
        "emoji": "🔶",
        "emojiKeyword": "形状,菱形,橙色,大,橙",
        "emojiLength": 2
      }, {
        "emoji": "🔷",
        "emojiKeyword": "形状,菱形,蓝色,大,蓝",
        "emojiLength": 2
      }, {
        "emoji": "🔳",
        "emojiKeyword": "形状,方形,白色,白色方形,白色方形按钮,按钮",
        "emojiLength": 2
      }, {
        "emoji": "🔲",
        "emojiKeyword": "形状,方形,黑色,黑色方形,黑色方形按钮,按钮",
        "emojiLength": 2
      }, {
        "emoji": "▪️",
        "emojiKeyword": "形状,方块,正方形,小,黑,黑色,黑色小方块",
        "emojiLength": 2
      }, {
        "emoji": "▫️",
        "emojiKeyword": "形状,方块,正方形,小,白,白色,白色小方块",
        "emojiLength": 2
      }, {
        "emoji": "◾️",
        "emojiKeyword": "形状,方块,正方形,中小,黑,黑色,黑色中小方块",
        "emojiLength": 2
      }, {
        "emoji": "◽️",
        "emojiKeyword": "形状,方块,正方形,中小,白,白色,白色中小方块",
        "emojiLength": 2
      }, {
        "emoji": "◼️",
        "emojiKeyword": "形状,方块,正方形,中,黑,黑色,黑色中方块",
        "emojiLength": 2
      }, {
        "emoji": "◻️",
        "emojiKeyword": "形状,方块,正方形,中,白,白色,白色中方块",
        "emojiLength": 2
      }, {
        "emoji": "⬛️",
        "emojiKeyword": "形状,方块,正方形,大,黑,黑色,黑色方块,黑色正方形",
        "emojiLength": 2
      }, {
        "emoji": "⬜️",
        "emojiKeyword": "形状,方块,正方形,中,白,白色,白色方块,白色正方形",
        "emojiLength": 2
      }, {
        "emoji": "🔈",
        "emojiKeyword": "扬声器,音量,放大,扩音,外放,低音量,小声",
        "emojiLength": 2
      }, {
        "emoji": "🔇",
        "emojiKeyword": "扬声器,静音,安静,关闭",
        "emojiLength": 2
      }, {
        "emoji": "🔉",
        "emojiKeyword": "扬声器,喇叭,音量,播放,中等音量,中等",
        "emojiLength": 2
      }, {
        "emoji": "🔊",
        "emojiKeyword": "扬声器,喇叭,音量,播放,高音量,广播,大声",
        "emojiLength": 2
      }, {
        "emoji": "🔔",
        "emojiKeyword": "铃铛,铃声,提醒,响铃,叮当,圣诞",
        "emojiLength": 2
      }, {
        "emoji": "🔕",
        "emojiKeyword": "铃铛,铃声,静音,静音模式,提醒,免打扰,无声,安静,关闭响铃",
        "emojiLength": 2
      }, {
        "emoji": "📣",
        "emojiKeyword": "扩音筒,喇叭,宣传,扩音器,喊,宣传,通知,呼喊,大声",
        "emojiLength": 2
      }, {
        "emoji": "📢",
        "emojiKeyword": "喇叭,扩音,广告,宣传,广播,通知,提醒,大声",
        "emojiLength": 2
      }, {
        "emoji": "💬",
        "emojiKeyword": "对话,气泡,对话框,说话",
        "emojiLength": 2
      }, {
        "emoji": "💭",
        "emojiKeyword": "气泡,想法,思考,对话框,思想",
        "emojiLength": 2
      }, {
        "emoji": "🗯️",
        "emojiKeyword": "语气,对话,气泡,愤怒,对话框",
        "emojiLength": 3
      }, {
        "emoji": "♠️",
        "emojiKeyword": "游戏,娱乐,牌,打牌,卡牌,扑克,纸牌,桃,黑桃",
        "emojiLength": 2
      }, {
        "emoji": "♣️",
        "emojiKeyword": "游戏,娱乐,牌,打牌,卡牌,扑克,纸牌,梅花,黑",
        "emojiLength": 2
      }, {
        "emoji": "♥️",
        "emojiKeyword": "游戏,娱乐,牌,打牌,卡牌,扑克,纸牌,桃,桃心,红桃,红",
        "emojiLength": 2
      }, {
        "emoji": "♦️",
        "emojiKeyword": "游戏,娱乐,牌,打牌,卡牌,扑克,纸牌,形状,方形,方块,方片,菱形,红色,小,红",
        "emojiLength": 2
      }, {
        "emoji": "🃏",
        "emojiKeyword": "游戏,娱乐,牌,打牌,卡牌,扑克,纸牌,赌博,斗地主,小王,小丑",
        "emojiLength": 2
      }, {
        "emoji": "🎴",
        "emojiKeyword": "花札,游戏,娱乐,牌,卡牌,日本,花牌,歌留多",
        "emojiLength": 2
      }, {
        "emoji": "🀄️",
        "emojiKeyword": "游戏,娱乐,牌,打牌,麻将,红中,中风,中",
        "emojiLength": 3
      }, {
        "emoji": "🕐",
        "emojiKeyword": "表,钟,时钟,时间,一点,中午,凌晨",
        "emojiLength": 2
      }, {
        "emoji": "🕑",
        "emojiKeyword": "表,钟,时钟,时间,两点,下午,凌晨",
        "emojiLength": 2
      }, {
        "emoji": "🕒",
        "emojiKeyword": "表,钟,时钟,时间,三点,凌晨",
        "emojiLength": 2
      }, {
        "emoji": "🕓",
        "emojiKeyword": "表,钟,时钟,时间,四点,清晨",
        "emojiLength": 2
      }, {
        "emoji": "🕔",
        "emojiKeyword": "表,钟,时钟,时间,五点,清晨",
        "emojiLength": 2
      }, {
        "emoji": "🕕",
        "emojiKeyword": "表,钟,时钟,时间,六点,清晨,早上,上午",
        "emojiLength": 2
      }, {
        "emoji": "🕖",
        "emojiKeyword": "表,钟,时钟,时间,七点,清晨,早上,上午",
        "emojiLength": 2
      }, {
        "emoji": "🕗",
        "emojiKeyword": "表,钟,时钟,时间,八点,早上,上午",
        "emojiLength": 2
      }, {
        "emoji": "🕘",
        "emojiKeyword": "表,钟,时钟,时间,九点,早上,上午",
        "emojiLength": 2
      }, {
        "emoji": "🕙",
        "emojiKeyword": "表,钟,时钟,时间,十点,早上,上午",
        "emojiLength": 2
      }, {
        "emoji": "🕚",
        "emojiKeyword": "表,钟,时钟,时间,十一点,中午",
        "emojiLength": 2
      }, {
        "emoji": "🕛",
        "emojiKeyword": "表,钟,时钟,时间,十二点,中午,半夜",
        "emojiLength": 2
      }, {
        "emoji": "🕜",
        "emojiKeyword": "表,钟,时钟,时间,一点半,中午",
        "emojiLength": 2
      }, {
        "emoji": "🕝",
        "emojiKeyword": "表,钟,时钟,时间,两点半,凌晨,下午",
        "emojiLength": 2
      }, {
        "emoji": "🕞",
        "emojiKeyword": "表,钟,时钟,时间,三点半,凌晨,下午",
        "emojiLength": 2
      }, {
        "emoji": "🕟",
        "emojiKeyword": "表,钟,时钟,时间,四点半,清晨,下午",
        "emojiLength": 2
      }, {
        "emoji": "🕠",
        "emojiKeyword": "表,钟,时钟,时间,五点半,清晨,下午",
        "emojiLength": 2
      }, {
        "emoji": "🕡",
        "emojiKeyword": "表,钟,时钟,时间,六点半,清晨,晚上",
        "emojiLength": 2
      }, {
        "emoji": "🕢",
        "emojiKeyword": "表,钟,时钟,时间,七点半,清晨,晚上",
        "emojiLength": 2
      }, {
        "emoji": "🕣",
        "emojiKeyword": "表,钟,时钟,时间,八点半,早上,上午,晚上",
        "emojiLength": 2
      }, {
        "emoji": "🕤",
        "emojiKeyword": "表,钟,时钟,时间,九点半,早上,上午,晚上",
        "emojiLength": 2
      }, {
        "emoji": "🕥",
        "emojiKeyword": "表,钟,时钟,时间,十点半,早上,上午,晚上",
        "emojiLength": 2
      }, {
        "emoji": "🕦",
        "emojiKeyword": "表,钟,时钟,时间,十一点半,中午,晚上",
        "emojiLength": 2
      }, {
        "emoji": "🕧",
        "emojiKeyword": "表,钟,时钟,时间,十二点半,中午,半夜",
        "emojiLength": 2
      }]
    }, {
      "categoryName": "旗帜",
      "emojiCategoryEntities": [{
        "emoji": "🏳️",
        "emojiKeyword": "旗,旗子,旗帜,白旗,举白旗,投降,认输,失败,败北,白,白色",
        "emojiLength": 3
      }, {
        "emoji": "🏴",
        "emojiKeyword": "旗,旗子,旗帜,黑旗,举黑旗,黑,黑色",
        "emojiLength": 2
      }, {
        "emoji": "🏴‍☠️",
        "emojiKeyword": "旗,旗子,旗帜,海盗,海盗旗,骷髅,海贼",
        "emojiLength": 5
      }, {
        "emoji": "🏁",
        "emojiKeyword": "旗,旗子,旗帜,黑白格,终点,终点旗,到达",
        "emojiLength": 2
      }, {
        "emoji": "🚩",
        "emojiKeyword": "旗,旗子,旗帜,红旗,三角旗,flag",
        "emojiLength": 2
      }, {
        "emoji": "🏳️‍🌈",
        "emojiKeyword": "旗,旗子,旗帜,彩虹旗,少数群体,同性,同性恋",
        "emojiLength": 6
      }, {
        "emoji": "🏳️‍⚧️",
        "emojiKeyword": "旗,旗子,旗帜,跨性别旗,跨性别",
        "emojiLength": 6
      }, {
        "emoji": "🇺🇳",
        "emojiKeyword": "旗,旗子,旗帜,联合国",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇱",
        "emojiKeyword": "旗,旗子,旗帜,阿尔巴尼亚",
        "emojiLength": 4
      }, {
        "emoji": "🇩🇿",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,阿尔及利亚",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇫",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,阿富汗",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,阿根廷",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,阿拉伯,阿拉伯联合酋长国",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇼",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,阿鲁巴",
        "emojiLength": 4
      }, {
        "emoji": "🇴🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,阿曼",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇿",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,阿塞拜疆",
        "emojiLength": 4
      }, {
        "emoji": "🇪🇬",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,埃及",
        "emojiLength": 4
      }, {
        "emoji": "🇪🇹",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,埃塞俄比亚",
        "emojiLength": 4
      }, {
        "emoji": "🇮🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,爱尔兰",
        "emojiLength": 4
      }, {
        "emoji": "🇪🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,爱沙尼亚",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇩",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,安道尔",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇴",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,安哥拉",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇮",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,安圭拉",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇬",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,安提瓜和巴布达",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇹",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,奥地利",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇽",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,奥兰群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇺",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,澳大利亚",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇴",
        "emojiKeyword": "旗,旗子,旗帜,中国澳门特别行政区,澳门",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇧",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,巴巴多斯",
        "emojiLength": 4
      }, {
        "emoji": "🇵🇬",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,巴布亚新几内亚",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇸",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,巴哈马",
        "emojiLength": 4
      }, {
        "emoji": "🇵🇰",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,巴基斯坦",
        "emojiLength": 4
      }, {
        "emoji": "🇵🇾",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,巴拉圭",
        "emojiLength": 4
      }, {
        "emoji": "🇵🇸",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,巴勒斯坦,巴勒斯坦领土",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇭",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,巴林",
        "emojiLength": 4
      }, {
        "emoji": "🇵🇦",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,巴拿马",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,巴西",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇾",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,白俄罗斯",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,百慕大",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇬",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,保加利亚",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇵",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,北马里亚纳群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇰",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,北马其顿",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇯",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,贝宁",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,比利时",
        "emojiLength": 4
      }, {
        "emoji": "🇵🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,秘鲁",
        "emojiLength": 4
      }, {
        "emoji": "🇮🇸",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,冰岛",
        "emojiLength": 4
      }, {
        "emoji": "🇵🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,波多黎各",
        "emojiLength": 4
      }, {
        "emoji": "🇵🇱",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,波兰",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇦",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,波斯尼亚,波黑,波斯尼亚和黑塞哥维那",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇴",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,玻利维亚",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇿",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,伯利兹",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇼",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,博茨瓦纳",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇹",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,不丹",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇫",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,布基纳法索",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇮",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,布隆迪",
        "emojiLength": 4
      }, {
        "emoji": "🇮🇴",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,英属印度洋领地",
        "emojiLength": 4
      }, {
        "emoji": "🇰🇵",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,朝鲜",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇶",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,赤道几内亚",
        "emojiLength": 4
      }, {
        "emoji": "🇩🇰",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,丹麦",
        "emojiLength": 4
      }, {
        "emoji": "🇩🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,德国,德意志",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇱",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,东帝汶",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇬",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,多哥",
        "emojiLength": 4
      }, {
        "emoji": "🇩🇴",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,多米尼加,多米尼加共和国",
        "emojiLength": 4
      }, {
        "emoji": "🇩🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,多米尼克",
        "emojiLength": 4
      }, {
        "emoji": "🇷🇺",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,俄罗斯",
        "emojiLength": 4
      }, {
        "emoji": "🇪🇨",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,厄瓜多尔",
        "emojiLength": 4
      }, {
        "emoji": "🇪🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,厄立特里亚",
        "emojiLength": 4
      }, {
        "emoji": "🇫🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,法国",
        "emojiLength": 4
      }, {
        "emoji": "🇫🇴",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,法罗群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇵🇫",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,法属波利尼西亚",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇫",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,法属圭亚那",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇫",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,法属南部领地",
        "emojiLength": 4
      }, {
        "emoji": "🇻🇦",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,梵蒂冈",
        "emojiLength": 4
      }, {
        "emoji": "🇵🇭",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,菲律宾",
        "emojiLength": 4
      }, {
        "emoji": "🇫🇯",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,斐济",
        "emojiLength": 4
      }, {
        "emoji": "🇫🇮",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,芬兰",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇻",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,佛得角",
        "emojiLength": 4
      }, {
        "emoji": "🇫🇰",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,福克兰群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,冈比亚",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇬",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,刚果",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇩",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,刚果",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇴",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,哥伦比亚",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,哥斯达黎加",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇩",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,格林纳达",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇱",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,格陵兰",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,格鲁吉亚",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇬",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,根西岛",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇺",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,古巴",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇵",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,瓜德罗普",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇺",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,关岛",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇾",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,圭亚那",
        "emojiLength": 4
      }, {
        "emoji": "🇰🇿",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,哈萨克斯坦",
        "emojiLength": 4
      }, {
        "emoji": "🇭🇹",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,海地",
        "emojiLength": 4
      }, {
        "emoji": "🇰🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,韩国",
        "emojiLength": 4
      }, {
        "emoji": "🇳🇱",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,荷兰",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇶",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,荷属加勒比区",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇽",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,荷属圣马丁",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,黑山",
        "emojiLength": 4
      }, {
        "emoji": "🇭🇳",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,洪都拉斯",
        "emojiLength": 4
      }, {
        "emoji": "🇰🇮",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,基里巴斯",
        "emojiLength": 4
      }, {
        "emoji": "🇩🇯",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,吉布提",
        "emojiLength": 4
      }, {
        "emoji": "🇰🇬",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,吉尔吉斯斯坦",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇳",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,几内亚",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇼",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,几内亚比绍",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇦",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,加拿大",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇭",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,加纳",
        "emojiLength": 4
      }, {
        "emoji": "🇮🇨",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,加纳利群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇦",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,加蓬",
        "emojiLength": 4
      }, {
        "emoji": "🇰🇭",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,柬埔寨",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇿",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,捷克",
        "emojiLength": 4
      }, {
        "emoji": "🇿🇼",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,津巴布韦",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,喀麦隆",
        "emojiLength": 4
      }, {
        "emoji": "🇶🇦",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,卡塔尔",
        "emojiLength": 4
      }, {
        "emoji": "🇰🇾",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,开曼群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇨",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,科科斯",
        "emojiLength": 4
      }, {
        "emoji": "🇰🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,科摩罗群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇽🇰",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,科索沃",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇮",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,科特迪瓦",
        "emojiLength": 4
      }, {
        "emoji": "🇰🇼",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,科威特",
        "emojiLength": 4
      }, {
        "emoji": "🇭🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,克罗地亚",
        "emojiLength": 4
      }, {
        "emoji": "🇰🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,肯尼亚",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇰",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,库克群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇼",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,库拉索",
        "emojiLength": 4
      }, {
        "emoji": "🇱🇻",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,拉脱维亚",
        "emojiLength": 4
      }, {
        "emoji": "🇱🇸",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,莱索托",
        "emojiLength": 4
      }, {
        "emoji": "🇱🇦",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,老挝",
        "emojiLength": 4
      }, {
        "emoji": "🇱🇧",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,黎巴嫩",
        "emojiLength": 4
      }, {
        "emoji": "🇱🇹",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,立陶宛",
        "emojiLength": 4
      }, {
        "emoji": "🇱🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,利比里亚",
        "emojiLength": 4
      }, {
        "emoji": "🇱🇾",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,利比亚",
        "emojiLength": 4
      }, {
        "emoji": "🇱🇮",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,列支敦士登",
        "emojiLength": 4
      }, {
        "emoji": "🇷🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,留尼汪",
        "emojiLength": 4
      }, {
        "emoji": "🇱🇺",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,卢森堡",
        "emojiLength": 4
      }, {
        "emoji": "🇷🇼",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,卢旺达",
        "emojiLength": 4
      }, {
        "emoji": "🇷🇴",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,罗马尼亚",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇬",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,马达加斯加",
        "emojiLength": 4
      }, {
        "emoji": "🇮🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,马恩岛",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇻",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,马尔代夫",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇹",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,马耳他",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇼",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,马拉维",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇾",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,马来西亚",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇱",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,马里",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇭",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,马绍尔群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇶",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,马提尼克",
        "emojiLength": 4
      }, {
        "emoji": "🇾🇹",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,马约特",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇺",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,毛里求斯",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,毛里塔尼亚",
        "emojiLength": 4
      }, {
        "emoji": "🇺🇸",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,美国",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇸",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,美属于萨摩亚,萨摩亚",
        "emojiLength": 4
      }, {
        "emoji": "🇻🇮",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,美属维尔京群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇳",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,蒙古",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇸",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,蒙特塞拉特",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇩",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,孟加拉国",
        "emojiLength": 4
      }, {
        "emoji": "🇫🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,密克罗尼西亚",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,缅甸",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇩",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,摩尔多瓦",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇦",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,摩洛哥",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇨",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,摩纳哥",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇿",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,莫桑比克",
        "emojiLength": 4
      }, {
        "emoji": "🇲🇽",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,墨西哥",
        "emojiLength": 4
      }, {
        "emoji": "🇳🇦",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,纳米比亚",
        "emojiLength": 4
      }, {
        "emoji": "🇿🇦",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,南非",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇶",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,南极洲,南极",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇸",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,南乔治亚和南桑威奇群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇸",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,南苏丹",
        "emojiLength": 4
      }, {
        "emoji": "🇳🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,瑙鲁",
        "emojiLength": 4
      }, {
        "emoji": "🇳🇮",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,尼加拉瓜",
        "emojiLength": 4
      }, {
        "emoji": "🇳🇵",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,尼泊尔",
        "emojiLength": 4
      }, {
        "emoji": "🇳🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,尼日尔",
        "emojiLength": 4
      }, {
        "emoji": "🇳🇬",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,尼日利亚",
        "emojiLength": 4
      }, {
        "emoji": "🇳🇺",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,纽埃",
        "emojiLength": 4
      }, {
        "emoji": "🇳🇴",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,挪威",
        "emojiLength": 4
      }, {
        "emoji": "🇳🇫",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,诺福克岛",
        "emojiLength": 4
      }, {
        "emoji": "🇪🇺",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,欧盟",
        "emojiLength": 4
      }, {
        "emoji": "🇵🇼",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,帕劳",
        "emojiLength": 4
      }, {
        "emoji": "🇵🇳",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,皮特凯恩群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇵🇹",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,葡萄牙",
        "emojiLength": 4
      }, {
        "emoji": "🇯🇵",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,日本",
        "emojiLength": 4
      }, {
        "emoji": "🎌",
        "emojiKeyword": "旗,旗子,旗帜,交叉旗,日章旗,红日旗,日本",
        "emojiLength": 2
      }, {
        "emoji": "🇸🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,瑞典",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇭",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,瑞士",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇻",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,萨尔瓦多",
        "emojiLength": 4
      }, {
        "emoji": "🇼🇸",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,萨摩亚",
        "emojiLength": 4
      }, {
        "emoji": "🇷🇸",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,塞尔维亚",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇱",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,塞拉利昂",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇳",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,塞内加尔",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇾",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,塞浦路斯",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇨",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,塞舌尔",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇦",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,沙特阿拉伯",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇱",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,圣巴泰勒米",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇽",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,圣诞岛",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇹",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,圣多美和普林西比",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇭",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,圣赫勒拿",
        "emojiLength": 4
      }, {
        "emoji": "🇰🇳",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,圣基茨和尼维斯",
        "emojiLength": 4
      }, {
        "emoji": "🇱🇨",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,圣卢西亚",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,圣马力诺",
        "emojiLength": 4
      }, {
        "emoji": "🇵🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,圣皮埃尔和密克隆群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇻🇨",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,圣文森特和格林纳丁斯",
        "emojiLength": 4
      }, {
        "emoji": "🇱🇰",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,斯里兰卡",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇰",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,斯洛伐克",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇮",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,斯洛文尼亚",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇿",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,斯威士兰",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇩",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,苏丹",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,苏里南",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇧",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,所罗门群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇴",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,索马里",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇯",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,塔吉克斯坦",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇭",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,泰国",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇿",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,坦桑尼亚",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇴",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,汤加",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇨",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,特克斯和凯科斯群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇹",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,特立尼达和多巴哥",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇳",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,突尼斯",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇻",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,图瓦卢",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,土耳其",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,土库曼斯坦",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇰",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,托克劳",
        "emojiLength": 4
      }, {
        "emoji": "🇼🇫",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,瓦利斯和富图纳",
        "emojiLength": 4
      }, {
        "emoji": "🇻🇺",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,瓦努阿图",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇹",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,危地马拉",
        "emojiLength": 4
      }, {
        "emoji": "🇻🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,委内瑞拉",
        "emojiLength": 4
      }, {
        "emoji": "🇧🇳",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,文莱",
        "emojiLength": 4
      }, {
        "emoji": "🇺🇬",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,乌干达",
        "emojiLength": 4
      }, {
        "emoji": "🇺🇦",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,乌克兰",
        "emojiLength": 4
      }, {
        "emoji": "🇺🇾",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,乌拉圭",
        "emojiLength": 4
      }, {
        "emoji": "🇺🇿",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,乌兹别克斯坦",
        "emojiLength": 4
      }, {
        "emoji": "🇪🇸",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,西班牙",
        "emojiLength": 4
      }, {
        "emoji": "🇪🇭",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,西撒哈拉",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,希腊",
        "emojiLength": 4
      }, {
        "emoji": "🇭🇰",
        "emojiKeyword": "旗,旗子,旗帜,中国香港特别行政区,香港",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇬",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,新加坡",
        "emojiLength": 4
      }, {
        "emoji": "🇳🇨",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,新喀里多尼亚",
        "emojiLength": 4
      }, {
        "emoji": "🇳🇿",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,新西兰",
        "emojiLength": 4
      }, {
        "emoji": "🇭🇺",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,匈牙利",
        "emojiLength": 4
      }, {
        "emoji": "🇸🇾",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,叙利亚",
        "emojiLength": 4
      }, {
        "emoji": "🇯🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,牙买加",
        "emojiLength": 4
      }, {
        "emoji": "🇦🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,亚美尼亚",
        "emojiLength": 4
      }, {
        "emoji": "🇾🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,也门",
        "emojiLength": 4
      }, {
        "emoji": "🇮🇶",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,伊拉克",
        "emojiLength": 4
      }, {
        "emoji": "🇮🇷",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,伊朗",
        "emojiLength": 4
      }, {
        "emoji": "🇮🇱",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,以色列",
        "emojiLength": 4
      }, {
        "emoji": "🇮🇹",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,意大利",
        "emojiLength": 4
      }, {
        "emoji": "🇮🇳",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,印度",
        "emojiLength": 4
      }, {
        "emoji": "🇮🇩",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,印度尼西亚,印尼",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇧",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,英国",
        "emojiLength": 4
      }, {
        "emoji": "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,英格兰",
        "emojiLength": 14
      }, {
        "emoji": "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,苏格兰",
        "emojiLength": 14
      }, {
        "emoji": "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,威尔士",
        "emojiLength": 14
      }, {
        "emoji": "🇻🇬",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,英属维尔京群岛",
        "emojiLength": 4
      }, {
        "emoji": "🇯🇴",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,约旦",
        "emojiLength": 4
      }, {
        "emoji": "🇻🇳",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,越南",
        "emojiLength": 4
      }, {
        "emoji": "🇿🇲",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,赞比亚",
        "emojiLength": 4
      }, {
        "emoji": "🇯🇪",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,泽西岛",
        "emojiLength": 4
      }, {
        "emoji": "🇹🇩",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,乍得",
        "emojiLength": 4
      }, {
        "emoji": "🇬🇮",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,直布罗陀",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇱",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,智利",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇫",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,中非,中非共和国",
        "emojiLength": 4
      }, {
        "emoji": "🇨🇳",
        "emojiKeyword": "旗,旗子,旗帜,国家,国旗,中国,中华人民共和国",
        "emojiLength": 4
      }]
    }, {
      "categoryName": "组合",
      "emojiCategoryEntities": [{
        "emoji": "🌎🌍🌏加油",
        "emojiKeyword": "地球,加油,地球加油",
        "emojiLength": 8
      }, {
        "emoji": "勤🧼🤲",
        "emojiKeyword": "勤洗手,讲卫生,卫生,洗手",
        "emojiLength": 5
      }, {
        "emoji": "出🚪😷",
        "emojiKeyword": "口罩,戴口罩,出门戴口罩",
        "emojiLength": 5
      }, {
        "emoji": "👊败🦠",
        "emojiKeyword": "新冠,病毒,打败病毒",
        "emojiLength": 5
      }, {
        "emoji": "🌶️🐔",
        "emojiKeyword": "辣鸡,垃圾",
        "emojiLength": 5
      }, {
        "emoji": "👅🐶",
        "emojiKeyword": "舔,舔狗,狗",
        "emojiLength": 4
      }, {
        "emoji": "🐂🍺",
        "emojiKeyword": "牛啤,厉害,牛逼",
        "emojiLength": 4
      }, {
        "emoji": "🙂你在想🍑",
        "emojiKeyword": "屁,你在想屁吃,想屁吃",
        "emojiLength": 7
      }, {
        "emoji": "我💔开",
        "emojiKeyword": "心碎,裂开,我裂开了",
        "emojiLength": 4
      }, {
        "emoji": "👴❤️了",
        "emojiKeyword": "爱了,爷爱了",
        "emojiLength": 5
      }, {
        "emoji": "你在 🈚㊥🥜🈶",
        "emojiKeyword": "无中生有,你在无中生有",
        "emojiLength": 10
      }, {
        "emoji": "🐎🉑🍍",
        "emojiKeyword": "马可波罗",
        "emojiLength": 6
      }, {
        "emoji": "🦊👧",
        "emojiKeyword": "狐狸,女孩",
        "emojiLength": 4
      }, {
        "emoji": "💉🐔",
        "emojiKeyword": "打针,鸡",
        "emojiLength": 4
      }, {
        "emoji": "🏠里📖",
        "emojiKeyword": "看书,在家读书,学习,居家上课",
        "emojiLength": 5
      }, {
        "emoji": "🏠里💻",
        "emojiKeyword": "电脑,在家办公,上班,居家办公",
        "emojiLength": 5
      }, {
        "emoji": "聚会❌❌❌",
        "emojiKeyword": "拒绝,拒绝聚会",
        "emojiLength": 5
      }, {
        "emoji": "我想去吃🍧🍦🍡",
        "emojiKeyword": "想吃甜食,甜品",
        "emojiLength": 10
      }, {
        "emoji": "胖成🐷了",
        "emojiKeyword": "胖,猪,胖成猪",
        "emojiLength": 5
      }, {
        "emoji": "💖里有你",
        "emojiKeyword": "爱,心,心里有你,想你",
        "emojiLength": 5
      }, {
        "emoji": "🐂🍺🐃🍺🐄🍺",
        "emojiKeyword": "牛啤,厉害,牛逼,牛",
        "emojiLength": 12
      }, {
        "emoji": "不要吃🦇🐍🐀",
        "emojiKeyword": "蝙蝠,蛇,老鼠",
        "emojiLength": 9
      }, {
        "emoji": "💰💴💵💶💷",
        "emojiKeyword": "钱,暴富,发财",
        "emojiLength": 10
      }, {
        "emoji": "给👴🏻整笑了",
        "emojiKeyword": "笑,无语,给爷整笑了,笑了",
        "emojiLength": 8
      }, {
        "emoji": "我🍋了",
        "emojiKeyword": "酸,我酸了,柠檬精,柠檬",
        "emojiLength": 4
      }, {
        "emoji": "我 💤了",
        "emojiKeyword": "困了,睡了,我睡了",
        "emojiLength": 5
      }, {
        "emoji": "你是🐷吗",
        "emojiKeyword": "猪,笨,你是猪吗",
        "emojiLength": 5
      }, {
        "emoji": "关你💨事",
        "emojiKeyword": "关你屁事,多管闲事",
        "emojiLength": 5
      }, {
        "emoji": "🈶🈚吃🐔",
        "emojiKeyword": "吃鸡,和平精英",
        "emojiLength": 7
      }, {
        "emoji": "我🥀了",
        "emojiKeyword": "凋谢,枯萎,我谢了,我枯了",
        "emojiLength": 4
      }, {
        "emoji": "我👀到了",
        "emojiKeyword": "看,看到,我看到了",
        "emojiLength": 5
      }, {
        "emoji": "我💥了",
        "emojiKeyword": "爆炸,我炸了",
        "emojiLength": 4
      }, {
        "emoji": "🗝️您配吗",
        "emojiKeyword": "您配吗",
        "emojiLength": 6
      }, {
        "emoji": "我🚗过去",
        "emojiKeyword": "开车,打车,坐车,我开车过去,我坐车过去,我打车过去",
        "emojiLength": 5
      }, {
        "emoji": "打🏀吗",
        "emojiKeyword": "打篮球,篮球,打球吗",
        "emojiLength": 4
      }, {
        "emoji": "看📖",
        "emojiKeyword": "看书",
        "emojiLength": 3
      }, {
        "emoji": "写📃",
        "emojiKeyword": "写信,写作",
        "emojiLength": 3
      }, {
        "emoji": "坐🎡不?",
        "emojiKeyword": "摩天轮",
        "emojiLength": 5
      }, {
        "emoji": "记得🌂",
        "emojiKeyword": "下雨,记得带伞",
        "emojiLength": 4
      }, {
        "emoji": "去🏥了",
        "emojiKeyword": "生病,去医院,看病",
        "emojiLength": 4
      }, {
        "emoji": "🌑🌒🌓🌔🌕🌖🌗🌘🌑",
        "emojiKeyword": "月食,月亮",
        "emojiLength": 18
      }, {
        "emoji": "傻🐷🐷",
        "emojiKeyword": "猪,傻,笨,傻猪猪",
        "emojiLength": 5
      }, {
        "emoji": "💢💢💢",
        "emojiKeyword": "生气,愤怒",
        "emojiLength": 6
      }, {
        "emoji": "🌈💨",
        "emojiKeyword": "彩虹屁,夸赞,恭维",
        "emojiLength": 4
      }, {
        "emoji": "🤒了",
        "emojiKeyword": "生病,发烧,感冒,温度计,量体温",
        "emojiLength": 3
      }, {
        "emoji": "我😭了",
        "emojiKeyword": "我哭了,哭",
        "emojiLength": 4
      }, {
        "emoji": "🥺你了",
        "emojiKeyword": "想你了,想你",
        "emojiLength": 4
      }, {
        "emoji": "想看🎬吃🍿",
        "emojiKeyword": "看电影,爆米花,电影",
        "emojiLength": 7
      }]
    }];
    this.emojiList = this.emojiTypeList[0].emojiCategoryEntities;
  },
  async mounted() {

    // console.log("emojiList:",emojiList);
  }
};